/*!
 * Webflow: Front-end site library
 * @license MIT
 * Inline scripts may access the api using an async handler:
 *   var Webflow = Webflow || [];
 *   Webflow.push(readyFunction);
 */

(() => {
  var u = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports);
  var Di = u(() => {
    window.tram = (function (e) {
      function t(l, E) {
        var O = new p.Bare();
        return O.init(l, E);
      }
      function r(l) {
        return l.replace(/[A-Z]/g, function (E) {
          return "-" + E.toLowerCase();
        });
      }
      function n(l) {
        var E = parseInt(l.slice(1), 16),
          O = (E >> 16) & 255,
          A = (E >> 8) & 255,
          T = 255 & E;
        return [O, A, T];
      }
      function i(l, E, O) {
        return (
          "#" + ((1 << 24) | (l << 16) | (E << 8) | O).toString(16).slice(1)
        );
      }
      function o() {}
      function a(l, E) {
        d("Type warning: Expected: [" + l + "] Got: [" + typeof E + "] " + E);
      }
      function s(l, E, O) {
        d("Units do not match [" + l + "]: " + E + ", " + O);
      }
      function c(l, E, O) {
        if ((E !== void 0 && (O = E), l === void 0)) return O;
        var A = O;
        return (
          Ke.test(l) || !Ue.test(l)
            ? (A = parseInt(l, 10))
            : Ue.test(l) && (A = 1e3 * parseFloat(l)),
          0 > A && (A = 0),
          A === A ? A : O
        );
      }
      function d(l) {
        fe.debug && window && window.console.warn(l);
      }
      function g(l) {
        for (var E = -1, O = l ? l.length : 0, A = []; ++E < O; ) {
          var T = l[E];
          T && A.push(T);
        }
        return A;
      }
      var f = (function (l, E, O) {
          function A(oe) {
            return typeof oe == "object";
          }
          function T(oe) {
            return typeof oe == "function";
          }
          function w() {}
          function Z(oe, Ee) {
            function H() {
              var De = new le();
              return T(De.init) && De.init.apply(De, arguments), De;
            }
            function le() {}
            Ee === O && ((Ee = oe), (oe = Object)), (H.Bare = le);
            var de,
              Se = (w[l] = oe[l]),
              ot = (le[l] = H[l] = new w());
            return (
              (ot.constructor = H),
              (H.mixin = function (De) {
                return (le[l] = H[l] = Z(H, De)[l]), H;
              }),
              (H.open = function (De) {
                if (
                  ((de = {}),
                  T(De) ? (de = De.call(H, ot, Se, H, oe)) : A(De) && (de = De),
                  A(de))
                )
                  for (var Tr in de) E.call(de, Tr) && (ot[Tr] = de[Tr]);
                return T(ot.init) || (ot.init = oe), H;
              }),
              H.open(Ee)
            );
          }
          return Z;
        })("prototype", {}.hasOwnProperty),
        y = {
          ease: [
            "ease",
            function (l, E, O, A) {
              var T = (l /= A) * l,
                w = T * l;
              return (
                E +
                O * (-2.75 * w * T + 11 * T * T + -15.5 * w + 8 * T + 0.25 * l)
              );
            },
          ],
          "ease-in": [
            "ease-in",
            function (l, E, O, A) {
              var T = (l /= A) * l,
                w = T * l;
              return E + O * (-1 * w * T + 3 * T * T + -3 * w + 2 * T);
            },
          ],
          "ease-out": [
            "ease-out",
            function (l, E, O, A) {
              var T = (l /= A) * l,
                w = T * l;
              return (
                E +
                O * (0.3 * w * T + -1.6 * T * T + 2.2 * w + -1.8 * T + 1.9 * l)
              );
            },
          ],
          "ease-in-out": [
            "ease-in-out",
            function (l, E, O, A) {
              var T = (l /= A) * l,
                w = T * l;
              return E + O * (2 * w * T + -5 * T * T + 2 * w + 2 * T);
            },
          ],
          linear: [
            "linear",
            function (l, E, O, A) {
              return (O * l) / A + E;
            },
          ],
          "ease-in-quad": [
            "cubic-bezier(0.550, 0.085, 0.680, 0.530)",
            function (l, E, O, A) {
              return O * (l /= A) * l + E;
            },
          ],
          "ease-out-quad": [
            "cubic-bezier(0.250, 0.460, 0.450, 0.940)",
            function (l, E, O, A) {
              return -O * (l /= A) * (l - 2) + E;
            },
          ],
          "ease-in-out-quad": [
            "cubic-bezier(0.455, 0.030, 0.515, 0.955)",
            function (l, E, O, A) {
              return (l /= A / 2) < 1
                ? (O / 2) * l * l + E
                : (-O / 2) * (--l * (l - 2) - 1) + E;
            },
          ],
          "ease-in-cubic": [
            "cubic-bezier(0.550, 0.055, 0.675, 0.190)",
            function (l, E, O, A) {
              return O * (l /= A) * l * l + E;
            },
          ],
          "ease-out-cubic": [
            "cubic-bezier(0.215, 0.610, 0.355, 1)",
            function (l, E, O, A) {
              return O * ((l = l / A - 1) * l * l + 1) + E;
            },
          ],
          "ease-in-out-cubic": [
            "cubic-bezier(0.645, 0.045, 0.355, 1)",
            function (l, E, O, A) {
              return (l /= A / 2) < 1
                ? (O / 2) * l * l * l + E
                : (O / 2) * ((l -= 2) * l * l + 2) + E;
            },
          ],
          "ease-in-quart": [
            "cubic-bezier(0.895, 0.030, 0.685, 0.220)",
            function (l, E, O, A) {
              return O * (l /= A) * l * l * l + E;
            },
          ],
          "ease-out-quart": [
            "cubic-bezier(0.165, 0.840, 0.440, 1)",
            function (l, E, O, A) {
              return -O * ((l = l / A - 1) * l * l * l - 1) + E;
            },
          ],
          "ease-in-out-quart": [
            "cubic-bezier(0.770, 0, 0.175, 1)",
            function (l, E, O, A) {
              return (l /= A / 2) < 1
                ? (O / 2) * l * l * l * l + E
                : (-O / 2) * ((l -= 2) * l * l * l - 2) + E;
            },
          ],
          "ease-in-quint": [
            "cubic-bezier(0.755, 0.050, 0.855, 0.060)",
            function (l, E, O, A) {
              return O * (l /= A) * l * l * l * l + E;
            },
          ],
          "ease-out-quint": [
            "cubic-bezier(0.230, 1, 0.320, 1)",
            function (l, E, O, A) {
              return O * ((l = l / A - 1) * l * l * l * l + 1) + E;
            },
          ],
          "ease-in-out-quint": [
            "cubic-bezier(0.860, 0, 0.070, 1)",
            function (l, E, O, A) {
              return (l /= A / 2) < 1
                ? (O / 2) * l * l * l * l * l + E
                : (O / 2) * ((l -= 2) * l * l * l * l + 2) + E;
            },
          ],
          "ease-in-sine": [
            "cubic-bezier(0.470, 0, 0.745, 0.715)",
            function (l, E, O, A) {
              return -O * Math.cos((l / A) * (Math.PI / 2)) + O + E;
            },
          ],
          "ease-out-sine": [
            "cubic-bezier(0.390, 0.575, 0.565, 1)",
            function (l, E, O, A) {
              return O * Math.sin((l / A) * (Math.PI / 2)) + E;
            },
          ],
          "ease-in-out-sine": [
            "cubic-bezier(0.445, 0.050, 0.550, 0.950)",
            function (l, E, O, A) {
              return (-O / 2) * (Math.cos((Math.PI * l) / A) - 1) + E;
            },
          ],
          "ease-in-expo": [
            "cubic-bezier(0.950, 0.050, 0.795, 0.035)",
            function (l, E, O, A) {
              return l === 0 ? E : O * Math.pow(2, 10 * (l / A - 1)) + E;
            },
          ],
          "ease-out-expo": [
            "cubic-bezier(0.190, 1, 0.220, 1)",
            function (l, E, O, A) {
              return l === A
                ? E + O
                : O * (-Math.pow(2, (-10 * l) / A) + 1) + E;
            },
          ],
          "ease-in-out-expo": [
            "cubic-bezier(1, 0, 0, 1)",
            function (l, E, O, A) {
              return l === 0
                ? E
                : l === A
                ? E + O
                : (l /= A / 2) < 1
                ? (O / 2) * Math.pow(2, 10 * (l - 1)) + E
                : (O / 2) * (-Math.pow(2, -10 * --l) + 2) + E;
            },
          ],
          "ease-in-circ": [
            "cubic-bezier(0.600, 0.040, 0.980, 0.335)",
            function (l, E, O, A) {
              return -O * (Math.sqrt(1 - (l /= A) * l) - 1) + E;
            },
          ],
          "ease-out-circ": [
            "cubic-bezier(0.075, 0.820, 0.165, 1)",
            function (l, E, O, A) {
              return O * Math.sqrt(1 - (l = l / A - 1) * l) + E;
            },
          ],
          "ease-in-out-circ": [
            "cubic-bezier(0.785, 0.135, 0.150, 0.860)",
            function (l, E, O, A) {
              return (l /= A / 2) < 1
                ? (-O / 2) * (Math.sqrt(1 - l * l) - 1) + E
                : (O / 2) * (Math.sqrt(1 - (l -= 2) * l) + 1) + E;
            },
          ],
          "ease-in-back": [
            "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
            function (l, E, O, A, T) {
              return (
                T === void 0 && (T = 1.70158),
                O * (l /= A) * l * ((T + 1) * l - T) + E
              );
            },
          ],
          "ease-out-back": [
            "cubic-bezier(0.175, 0.885, 0.320, 1.275)",
            function (l, E, O, A, T) {
              return (
                T === void 0 && (T = 1.70158),
                O * ((l = l / A - 1) * l * ((T + 1) * l + T) + 1) + E
              );
            },
          ],
          "ease-in-out-back": [
            "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
            function (l, E, O, A, T) {
              return (
                T === void 0 && (T = 1.70158),
                (l /= A / 2) < 1
                  ? (O / 2) * l * l * (((T *= 1.525) + 1) * l - T) + E
                  : (O / 2) *
                      ((l -= 2) * l * (((T *= 1.525) + 1) * l + T) + 2) +
                    E
              );
            },
          ],
        },
        h = {
          "ease-in-back": "cubic-bezier(0.600, 0, 0.735, 0.045)",
          "ease-out-back": "cubic-bezier(0.175, 0.885, 0.320, 1)",
          "ease-in-out-back": "cubic-bezier(0.680, 0, 0.265, 1)",
        },
        _ = document,
        b = window,
        C = "bkwld-tram",
        R = /[\-\.0-9]/g,
        N = /[A-Z]/,
        S = "number",
        G = /^(rgb|#)/,
        F = /(em|cm|mm|in|pt|pc|px)$/,
        q = /(em|cm|mm|in|pt|pc|px|%)$/,
        W = /(deg|rad|turn)$/,
        j = "unitless",
        Q = /(all|none) 0s ease 0s/,
        ae = /^(width|height)$/,
        re = " ",
        X = _.createElement("a"),
        I = ["Webkit", "Moz", "O", "ms"],
        L = ["-webkit-", "-moz-", "-o-", "-ms-"],
        M = function (l) {
          if (l in X.style) return { dom: l, css: l };
          var E,
            O,
            A = "",
            T = l.split("-");
          for (E = 0; E < T.length; E++)
            A += T[E].charAt(0).toUpperCase() + T[E].slice(1);
          for (E = 0; E < I.length; E++)
            if (((O = I[E] + A), O in X.style))
              return { dom: O, css: L[E] + l };
        },
        D = (t.support = {
          bind: Function.prototype.bind,
          transform: M("transform"),
          transition: M("transition"),
          backface: M("backface-visibility"),
          timing: M("transition-timing-function"),
        });
      if (D.transition) {
        var $ = D.timing.dom;
        if (((X.style[$] = y["ease-in-back"][0]), !X.style[$]))
          for (var ne in h) y[ne][0] = h[ne];
      }
      var P = (t.frame = (function () {
          var l =
            b.requestAnimationFrame ||
            b.webkitRequestAnimationFrame ||
            b.mozRequestAnimationFrame ||
            b.oRequestAnimationFrame ||
            b.msRequestAnimationFrame;
          return l && D.bind
            ? l.bind(b)
            : function (E) {
                b.setTimeout(E, 16);
              };
        })()),
        U = (t.now = (function () {
          var l = b.performance,
            E = l && (l.now || l.webkitNow || l.msNow || l.mozNow);
          return E && D.bind
            ? E.bind(l)
            : Date.now ||
                function () {
                  return +new Date();
                };
        })()),
        K = f(function (l) {
          function E(te, pe) {
            var Ie = g(("" + te).split(re)),
              he = Ie[0];
            pe = pe || {};
            var Me = k[he];
            if (!Me) return d("Unsupported property: " + he);
            if (!pe.weak || !this.props[he]) {
              var Ye = Me[0],
                Ve = this.props[he];
              return (
                Ve || (Ve = this.props[he] = new Ye.Bare()),
                Ve.init(this.$el, Ie, Me, pe),
                Ve
              );
            }
          }
          function O(te, pe, Ie) {
            if (te) {
              var he = typeof te;
              if (
                (pe ||
                  (this.timer && this.timer.destroy(),
                  (this.queue = []),
                  (this.active = !1)),
                he == "number" && pe)
              )
                return (
                  (this.timer = new J({
                    duration: te,
                    context: this,
                    complete: w,
                  })),
                  void (this.active = !0)
                );
              if (he == "string" && pe) {
                switch (te) {
                  case "hide":
                    H.call(this);
                    break;
                  case "stop":
                    Z.call(this);
                    break;
                  case "redraw":
                    le.call(this);
                    break;
                  default:
                    E.call(this, te, Ie && Ie[1]);
                }
                return w.call(this);
              }
              if (he == "function") return void te.call(this, this);
              if (he == "object") {
                var Me = 0;
                ot.call(
                  this,
                  te,
                  function (Ae, lm) {
                    Ae.span > Me && (Me = Ae.span), Ae.stop(), Ae.animate(lm);
                  },
                  function (Ae) {
                    "wait" in Ae && (Me = c(Ae.wait, 0));
                  }
                ),
                  Se.call(this),
                  Me > 0 &&
                    ((this.timer = new J({ duration: Me, context: this })),
                    (this.active = !0),
                    pe && (this.timer.complete = w));
                var Ye = this,
                  Ve = !1,
                  un = {};
                P(function () {
                  ot.call(Ye, te, function (Ae) {
                    Ae.active && ((Ve = !0), (un[Ae.name] = Ae.nextStyle));
                  }),
                    Ve && Ye.$el.css(un);
                });
              }
            }
          }
          function A(te) {
            (te = c(te, 0)),
              this.active
                ? this.queue.push({ options: te })
                : ((this.timer = new J({
                    duration: te,
                    context: this,
                    complete: w,
                  })),
                  (this.active = !0));
          }
          function T(te) {
            return this.active
              ? (this.queue.push({ options: te, args: arguments }),
                void (this.timer.complete = w))
              : d(
                  "No active transition timer. Use start() or wait() before then()."
                );
          }
          function w() {
            if (
              (this.timer && this.timer.destroy(),
              (this.active = !1),
              this.queue.length)
            ) {
              var te = this.queue.shift();
              O.call(this, te.options, !0, te.args);
            }
          }
          function Z(te) {
            this.timer && this.timer.destroy(),
              (this.queue = []),
              (this.active = !1);
            var pe;
            typeof te == "string"
              ? ((pe = {}), (pe[te] = 1))
              : (pe = typeof te == "object" && te != null ? te : this.props),
              ot.call(this, pe, De),
              Se.call(this);
          }
          function oe(te) {
            Z.call(this, te), ot.call(this, te, Tr, um);
          }
          function Ee(te) {
            typeof te != "string" && (te = "block"),
              (this.el.style.display = te);
          }
          function H() {
            Z.call(this), (this.el.style.display = "none");
          }
          function le() {
            this.el.offsetHeight;
          }
          function de() {
            Z.call(this), e.removeData(this.el, C), (this.$el = this.el = null);
          }
          function Se() {
            var te,
              pe,
              Ie = [];
            this.upstream && Ie.push(this.upstream);
            for (te in this.props)
              (pe = this.props[te]), pe.active && Ie.push(pe.string);
            (Ie = Ie.join(",")),
              this.style !== Ie &&
                ((this.style = Ie), (this.el.style[D.transition.dom] = Ie));
          }
          function ot(te, pe, Ie) {
            var he,
              Me,
              Ye,
              Ve,
              un = pe !== De,
              Ae = {};
            for (he in te)
              (Ye = te[he]),
                he in ve
                  ? (Ae.transform || (Ae.transform = {}),
                    (Ae.transform[he] = Ye))
                  : (N.test(he) && (he = r(he)),
                    he in k ? (Ae[he] = Ye) : (Ve || (Ve = {}), (Ve[he] = Ye)));
            for (he in Ae) {
              if (((Ye = Ae[he]), (Me = this.props[he]), !Me)) {
                if (!un) continue;
                Me = E.call(this, he);
              }
              pe.call(this, Me, Ye);
            }
            Ie && Ve && Ie.call(this, Ve);
          }
          function De(te) {
            te.stop();
          }
          function Tr(te, pe) {
            te.set(pe);
          }
          function um(te) {
            this.$el.css(te);
          }
          function ze(te, pe) {
            l[te] = function () {
              return this.children
                ? cm.call(this, pe, arguments)
                : (this.el && pe.apply(this, arguments), this);
            };
          }
          function cm(te, pe) {
            var Ie,
              he = this.children.length;
            for (Ie = 0; he > Ie; Ie++) te.apply(this.children[Ie], pe);
            return this;
          }
          (l.init = function (te) {
            if (
              ((this.$el = e(te)),
              (this.el = this.$el[0]),
              (this.props = {}),
              (this.queue = []),
              (this.style = ""),
              (this.active = !1),
              fe.keepInherited && !fe.fallback)
            ) {
              var pe = V(this.el, "transition");
              pe && !Q.test(pe) && (this.upstream = pe);
            }
            D.backface &&
              fe.hideBackface &&
              v(this.el, D.backface.css, "hidden");
          }),
            ze("add", E),
            ze("start", O),
            ze("wait", A),
            ze("then", T),
            ze("next", w),
            ze("stop", Z),
            ze("set", oe),
            ze("show", Ee),
            ze("hide", H),
            ze("redraw", le),
            ze("destroy", de);
        }),
        p = f(K, function (l) {
          function E(O, A) {
            var T = e.data(O, C) || e.data(O, C, new K.Bare());
            return T.el || T.init(O), A ? T.start(A) : T;
          }
          l.init = function (O, A) {
            var T = e(O);
            if (!T.length) return this;
            if (T.length === 1) return E(T[0], A);
            var w = [];
            return (
              T.each(function (Z, oe) {
                w.push(E(oe, A));
              }),
              (this.children = w),
              this
            );
          };
        }),
        m = f(function (l) {
          function E() {
            var w = this.get();
            this.update("auto");
            var Z = this.get();
            return this.update(w), Z;
          }
          function O(w, Z, oe) {
            return Z !== void 0 && (oe = Z), w in y ? w : oe;
          }
          function A(w) {
            var Z = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(w);
            return (Z ? i(Z[1], Z[2], Z[3]) : w).replace(
              /#(\w)(\w)(\w)$/,
              "#$1$1$2$2$3$3"
            );
          }
          var T = { duration: 500, ease: "ease", delay: 0 };
          (l.init = function (w, Z, oe, Ee) {
            (this.$el = w), (this.el = w[0]);
            var H = Z[0];
            oe[2] && (H = oe[2]),
              z[H] && (H = z[H]),
              (this.name = H),
              (this.type = oe[1]),
              (this.duration = c(Z[1], this.duration, T.duration)),
              (this.ease = O(Z[2], this.ease, T.ease)),
              (this.delay = c(Z[3], this.delay, T.delay)),
              (this.span = this.duration + this.delay),
              (this.active = !1),
              (this.nextStyle = null),
              (this.auto = ae.test(this.name)),
              (this.unit = Ee.unit || this.unit || fe.defaultUnit),
              (this.angle = Ee.angle || this.angle || fe.defaultAngle),
              fe.fallback || Ee.fallback
                ? (this.animate = this.fallback)
                : ((this.animate = this.transition),
                  (this.string =
                    this.name +
                    re +
                    this.duration +
                    "ms" +
                    (this.ease != "ease" ? re + y[this.ease][0] : "") +
                    (this.delay ? re + this.delay + "ms" : "")));
          }),
            (l.set = function (w) {
              (w = this.convert(w, this.type)), this.update(w), this.redraw();
            }),
            (l.transition = function (w) {
              (this.active = !0),
                (w = this.convert(w, this.type)),
                this.auto &&
                  (this.el.style[this.name] == "auto" &&
                    (this.update(this.get()), this.redraw()),
                  w == "auto" && (w = E.call(this))),
                (this.nextStyle = w);
            }),
            (l.fallback = function (w) {
              var Z =
                this.el.style[this.name] || this.convert(this.get(), this.type);
              (w = this.convert(w, this.type)),
                this.auto &&
                  (Z == "auto" && (Z = this.convert(this.get(), this.type)),
                  w == "auto" && (w = E.call(this))),
                (this.tween = new Y({
                  from: Z,
                  to: w,
                  duration: this.duration,
                  delay: this.delay,
                  ease: this.ease,
                  update: this.update,
                  context: this,
                }));
            }),
            (l.get = function () {
              return V(this.el, this.name);
            }),
            (l.update = function (w) {
              v(this.el, this.name, w);
            }),
            (l.stop = function () {
              (this.active || this.nextStyle) &&
                ((this.active = !1),
                (this.nextStyle = null),
                v(this.el, this.name, this.get()));
              var w = this.tween;
              w && w.context && w.destroy();
            }),
            (l.convert = function (w, Z) {
              if (w == "auto" && this.auto) return w;
              var oe,
                Ee = typeof w == "number",
                H = typeof w == "string";
              switch (Z) {
                case S:
                  if (Ee) return w;
                  if (H && w.replace(R, "") === "") return +w;
                  oe = "number(unitless)";
                  break;
                case G:
                  if (H) {
                    if (w === "" && this.original) return this.original;
                    if (Z.test(w))
                      return w.charAt(0) == "#" && w.length == 7 ? w : A(w);
                  }
                  oe = "hex or rgb string";
                  break;
                case F:
                  if (Ee) return w + this.unit;
                  if (H && Z.test(w)) return w;
                  oe = "number(px) or string(unit)";
                  break;
                case q:
                  if (Ee) return w + this.unit;
                  if (H && Z.test(w)) return w;
                  oe = "number(px) or string(unit or %)";
                  break;
                case W:
                  if (Ee) return w + this.angle;
                  if (H && Z.test(w)) return w;
                  oe = "number(deg) or string(angle)";
                  break;
                case j:
                  if (Ee || (H && q.test(w))) return w;
                  oe = "number(unitless) or string(unit or %)";
              }
              return a(oe, w), w;
            }),
            (l.redraw = function () {
              this.el.offsetHeight;
            });
        }),
        B = f(m, function (l, E) {
          l.init = function () {
            E.init.apply(this, arguments),
              this.original || (this.original = this.convert(this.get(), G));
          };
        }),
        ee = f(m, function (l, E) {
          (l.init = function () {
            E.init.apply(this, arguments), (this.animate = this.fallback);
          }),
            (l.get = function () {
              return this.$el[this.name]();
            }),
            (l.update = function (O) {
              this.$el[this.name](O);
            });
        }),
        ie = f(m, function (l, E) {
          function O(A, T) {
            var w, Z, oe, Ee, H;
            for (w in A)
              (Ee = ve[w]),
                (oe = Ee[0]),
                (Z = Ee[1] || w),
                (H = this.convert(A[w], oe)),
                T.call(this, Z, H, oe);
          }
          (l.init = function () {
            E.init.apply(this, arguments),
              this.current ||
                ((this.current = {}),
                ve.perspective &&
                  fe.perspective &&
                  ((this.current.perspective = fe.perspective),
                  v(this.el, this.name, this.style(this.current)),
                  this.redraw()));
          }),
            (l.set = function (A) {
              O.call(this, A, function (T, w) {
                this.current[T] = w;
              }),
                v(this.el, this.name, this.style(this.current)),
                this.redraw();
            }),
            (l.transition = function (A) {
              var T = this.values(A);
              this.tween = new Oe({
                current: this.current,
                values: T,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
              });
              var w,
                Z = {};
              for (w in this.current) Z[w] = w in T ? T[w] : this.current[w];
              (this.active = !0), (this.nextStyle = this.style(Z));
            }),
            (l.fallback = function (A) {
              var T = this.values(A);
              this.tween = new Oe({
                current: this.current,
                values: T,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
                update: this.update,
                context: this,
              });
            }),
            (l.update = function () {
              v(this.el, this.name, this.style(this.current));
            }),
            (l.style = function (A) {
              var T,
                w = "";
              for (T in A) w += T + "(" + A[T] + ") ";
              return w;
            }),
            (l.values = function (A) {
              var T,
                w = {};
              return (
                O.call(this, A, function (Z, oe, Ee) {
                  (w[Z] = oe),
                    this.current[Z] === void 0 &&
                      ((T = 0),
                      ~Z.indexOf("scale") && (T = 1),
                      (this.current[Z] = this.convert(T, Ee)));
                }),
                w
              );
            });
        }),
        Y = f(function (l) {
          function E(H) {
            oe.push(H) === 1 && P(O);
          }
          function O() {
            var H,
              le,
              de,
              Se = oe.length;
            if (Se)
              for (P(O), le = U(), H = Se; H--; )
                (de = oe[H]), de && de.render(le);
          }
          function A(H) {
            var le,
              de = e.inArray(H, oe);
            de >= 0 &&
              ((le = oe.slice(de + 1)),
              (oe.length = de),
              le.length && (oe = oe.concat(le)));
          }
          function T(H) {
            return Math.round(H * Ee) / Ee;
          }
          function w(H, le, de) {
            return i(
              H[0] + de * (le[0] - H[0]),
              H[1] + de * (le[1] - H[1]),
              H[2] + de * (le[2] - H[2])
            );
          }
          var Z = { ease: y.ease[1], from: 0, to: 1 };
          (l.init = function (H) {
            (this.duration = H.duration || 0), (this.delay = H.delay || 0);
            var le = H.ease || Z.ease;
            y[le] && (le = y[le][1]),
              typeof le != "function" && (le = Z.ease),
              (this.ease = le),
              (this.update = H.update || o),
              (this.complete = H.complete || o),
              (this.context = H.context || this),
              (this.name = H.name);
            var de = H.from,
              Se = H.to;
            de === void 0 && (de = Z.from),
              Se === void 0 && (Se = Z.to),
              (this.unit = H.unit || ""),
              typeof de == "number" && typeof Se == "number"
                ? ((this.begin = de), (this.change = Se - de))
                : this.format(Se, de),
              (this.value = this.begin + this.unit),
              (this.start = U()),
              H.autoplay !== !1 && this.play();
          }),
            (l.play = function () {
              this.active ||
                (this.start || (this.start = U()), (this.active = !0), E(this));
            }),
            (l.stop = function () {
              this.active && ((this.active = !1), A(this));
            }),
            (l.render = function (H) {
              var le,
                de = H - this.start;
              if (this.delay) {
                if (de <= this.delay) return;
                de -= this.delay;
              }
              if (de < this.duration) {
                var Se = this.ease(de, 0, 1, this.duration);
                return (
                  (le = this.startRGB
                    ? w(this.startRGB, this.endRGB, Se)
                    : T(this.begin + Se * this.change)),
                  (this.value = le + this.unit),
                  void this.update.call(this.context, this.value)
                );
              }
              (le = this.endHex || this.begin + this.change),
                (this.value = le + this.unit),
                this.update.call(this.context, this.value),
                this.complete.call(this.context),
                this.destroy();
            }),
            (l.format = function (H, le) {
              if (((le += ""), (H += ""), H.charAt(0) == "#"))
                return (
                  (this.startRGB = n(le)),
                  (this.endRGB = n(H)),
                  (this.endHex = H),
                  (this.begin = 0),
                  void (this.change = 1)
                );
              if (!this.unit) {
                var de = le.replace(R, ""),
                  Se = H.replace(R, "");
                de !== Se && s("tween", le, H), (this.unit = de);
              }
              (le = parseFloat(le)),
                (H = parseFloat(H)),
                (this.begin = this.value = le),
                (this.change = H - le);
            }),
            (l.destroy = function () {
              this.stop(),
                (this.context = null),
                (this.ease = this.update = this.complete = o);
            });
          var oe = [],
            Ee = 1e3;
        }),
        J = f(Y, function (l) {
          (l.init = function (E) {
            (this.duration = E.duration || 0),
              (this.complete = E.complete || o),
              (this.context = E.context),
              this.play();
          }),
            (l.render = function (E) {
              var O = E - this.start;
              O < this.duration ||
                (this.complete.call(this.context), this.destroy());
            });
        }),
        Oe = f(Y, function (l, E) {
          (l.init = function (O) {
            (this.context = O.context),
              (this.update = O.update),
              (this.tweens = []),
              (this.current = O.current);
            var A, T;
            for (A in O.values)
              (T = O.values[A]),
                this.current[A] !== T &&
                  this.tweens.push(
                    new Y({
                      name: A,
                      from: this.current[A],
                      to: T,
                      duration: O.duration,
                      delay: O.delay,
                      ease: O.ease,
                      autoplay: !1,
                    })
                  );
            this.play();
          }),
            (l.render = function (O) {
              var A,
                T,
                w = this.tweens.length,
                Z = !1;
              for (A = w; A--; )
                (T = this.tweens[A]),
                  T.context &&
                    (T.render(O), (this.current[T.name] = T.value), (Z = !0));
              return Z
                ? void (this.update && this.update.call(this.context))
                : this.destroy();
            }),
            (l.destroy = function () {
              if ((E.destroy.call(this), this.tweens)) {
                var O,
                  A = this.tweens.length;
                for (O = A; O--; ) this.tweens[O].destroy();
                (this.tweens = null), (this.current = null);
              }
            });
        }),
        fe = (t.config = {
          debug: !1,
          defaultUnit: "px",
          defaultAngle: "deg",
          keepInherited: !1,
          hideBackface: !1,
          perspective: "",
          fallback: !D.transition,
          agentTests: [],
        });
      (t.fallback = function (l) {
        if (!D.transition) return (fe.fallback = !0);
        fe.agentTests.push("(" + l + ")");
        var E = new RegExp(fe.agentTests.join("|"), "i");
        fe.fallback = E.test(navigator.userAgent);
      }),
        t.fallback("6.0.[2-5] Safari"),
        (t.tween = function (l) {
          return new Y(l);
        }),
        (t.delay = function (l, E, O) {
          return new J({ complete: E, duration: l, context: O });
        }),
        (e.fn.tram = function (l) {
          return t.call(null, this, l);
        });
      var v = e.style,
        V = e.css,
        z = { transform: D.transform && D.transform.css },
        k = {
          color: [B, G],
          background: [B, G, "background-color"],
          "outline-color": [B, G],
          "border-color": [B, G],
          "border-top-color": [B, G],
          "border-right-color": [B, G],
          "border-bottom-color": [B, G],
          "border-left-color": [B, G],
          "border-width": [m, F],
          "border-top-width": [m, F],
          "border-right-width": [m, F],
          "border-bottom-width": [m, F],
          "border-left-width": [m, F],
          "border-spacing": [m, F],
          "letter-spacing": [m, F],
          margin: [m, F],
          "margin-top": [m, F],
          "margin-right": [m, F],
          "margin-bottom": [m, F],
          "margin-left": [m, F],
          padding: [m, F],
          "padding-top": [m, F],
          "padding-right": [m, F],
          "padding-bottom": [m, F],
          "padding-left": [m, F],
          "outline-width": [m, F],
          opacity: [m, S],
          top: [m, q],
          right: [m, q],
          bottom: [m, q],
          left: [m, q],
          "font-size": [m, q],
          "text-indent": [m, q],
          "word-spacing": [m, q],
          width: [m, q],
          "min-width": [m, q],
          "max-width": [m, q],
          height: [m, q],
          "min-height": [m, q],
          "max-height": [m, q],
          "line-height": [m, j],
          "scroll-top": [ee, S, "scrollTop"],
          "scroll-left": [ee, S, "scrollLeft"],
        },
        ve = {};
      D.transform &&
        ((k.transform = [ie]),
        (ve = {
          x: [q, "translateX"],
          y: [q, "translateY"],
          rotate: [W],
          rotateX: [W],
          rotateY: [W],
          scale: [S],
          scaleX: [S],
          scaleY: [S],
          skew: [W],
          skewX: [W],
          skewY: [W],
        })),
        D.transform &&
          D.backface &&
          ((ve.z = [q, "translateZ"]),
          (ve.rotateZ = [W]),
          (ve.scaleZ = [S]),
          (ve.perspective = [F]));
      var Ke = /ms/,
        Ue = /s|\./;
      return (e.tram = t);
    })(window.jQuery);
  });
  var Ts = u((uW, Is) => {
    var fm = window.$,
      dm = Di() && fm.tram;
    Is.exports = (function () {
      var e = {};
      e.VERSION = "1.6.0-Webflow";
      var t = {},
        r = Array.prototype,
        n = Object.prototype,
        i = Function.prototype,
        o = r.push,
        a = r.slice,
        s = r.concat,
        c = n.toString,
        d = n.hasOwnProperty,
        g = r.forEach,
        f = r.map,
        y = r.reduce,
        h = r.reduceRight,
        _ = r.filter,
        b = r.every,
        C = r.some,
        R = r.indexOf,
        N = r.lastIndexOf,
        S = Array.isArray,
        G = Object.keys,
        F = i.bind,
        q =
          (e.each =
          e.forEach =
            function (I, L, M) {
              if (I == null) return I;
              if (g && I.forEach === g) I.forEach(L, M);
              else if (I.length === +I.length) {
                for (var D = 0, $ = I.length; D < $; D++)
                  if (L.call(M, I[D], D, I) === t) return;
              } else
                for (var ne = e.keys(I), D = 0, $ = ne.length; D < $; D++)
                  if (L.call(M, I[ne[D]], ne[D], I) === t) return;
              return I;
            });
      (e.map = e.collect =
        function (I, L, M) {
          var D = [];
          return I == null
            ? D
            : f && I.map === f
            ? I.map(L, M)
            : (q(I, function ($, ne, P) {
                D.push(L.call(M, $, ne, P));
              }),
              D);
        }),
        (e.find = e.detect =
          function (I, L, M) {
            var D;
            return (
              W(I, function ($, ne, P) {
                if (L.call(M, $, ne, P)) return (D = $), !0;
              }),
              D
            );
          }),
        (e.filter = e.select =
          function (I, L, M) {
            var D = [];
            return I == null
              ? D
              : _ && I.filter === _
              ? I.filter(L, M)
              : (q(I, function ($, ne, P) {
                  L.call(M, $, ne, P) && D.push($);
                }),
                D);
          });
      var W =
        (e.some =
        e.any =
          function (I, L, M) {
            L || (L = e.identity);
            var D = !1;
            return I == null
              ? D
              : C && I.some === C
              ? I.some(L, M)
              : (q(I, function ($, ne, P) {
                  if (D || (D = L.call(M, $, ne, P))) return t;
                }),
                !!D);
          });
      (e.contains = e.include =
        function (I, L) {
          return I == null
            ? !1
            : R && I.indexOf === R
            ? I.indexOf(L) != -1
            : W(I, function (M) {
                return M === L;
              });
        }),
        (e.delay = function (I, L) {
          var M = a.call(arguments, 2);
          return setTimeout(function () {
            return I.apply(null, M);
          }, L);
        }),
        (e.defer = function (I) {
          return e.delay.apply(e, [I, 1].concat(a.call(arguments, 1)));
        }),
        (e.throttle = function (I) {
          var L, M, D;
          return function () {
            L ||
              ((L = !0),
              (M = arguments),
              (D = this),
              dm.frame(function () {
                (L = !1), I.apply(D, M);
              }));
          };
        }),
        (e.debounce = function (I, L, M) {
          var D,
            $,
            ne,
            P,
            U,
            K = function () {
              var p = e.now() - P;
              p < L
                ? (D = setTimeout(K, L - p))
                : ((D = null), M || ((U = I.apply(ne, $)), (ne = $ = null)));
            };
          return function () {
            (ne = this), ($ = arguments), (P = e.now());
            var p = M && !D;
            return (
              D || (D = setTimeout(K, L)),
              p && ((U = I.apply(ne, $)), (ne = $ = null)),
              U
            );
          };
        }),
        (e.defaults = function (I) {
          if (!e.isObject(I)) return I;
          for (var L = 1, M = arguments.length; L < M; L++) {
            var D = arguments[L];
            for (var $ in D) I[$] === void 0 && (I[$] = D[$]);
          }
          return I;
        }),
        (e.keys = function (I) {
          if (!e.isObject(I)) return [];
          if (G) return G(I);
          var L = [];
          for (var M in I) e.has(I, M) && L.push(M);
          return L;
        }),
        (e.has = function (I, L) {
          return d.call(I, L);
        }),
        (e.isObject = function (I) {
          return I === Object(I);
        }),
        (e.now =
          Date.now ||
          function () {
            return new Date().getTime();
          }),
        (e.templateSettings = {
          evaluate: /<%([\s\S]+?)%>/g,
          interpolate: /<%=([\s\S]+?)%>/g,
          escape: /<%-([\s\S]+?)%>/g,
        });
      var j = /(.)^/,
        Q = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\u2028": "u2028",
          "\u2029": "u2029",
        },
        ae = /\\|'|\r|\n|\u2028|\u2029/g,
        re = function (I) {
          return "\\" + Q[I];
        },
        X = /^\s*(\w|\$)+\s*$/;
      return (
        (e.template = function (I, L, M) {
          !L && M && (L = M), (L = e.defaults({}, L, e.templateSettings));
          var D = RegExp(
              [
                (L.escape || j).source,
                (L.interpolate || j).source,
                (L.evaluate || j).source,
              ].join("|") + "|$",
              "g"
            ),
            $ = 0,
            ne = "__p+='";
          I.replace(D, function (p, m, B, ee, ie) {
            return (
              (ne += I.slice($, ie).replace(ae, re)),
              ($ = ie + p.length),
              m
                ? (ne +=
                    `'+
((__t=(` +
                    m +
                    `))==null?'':_.escape(__t))+
'`)
                : B
                ? (ne +=
                    `'+
((__t=(` +
                    B +
                    `))==null?'':__t)+
'`)
                : ee &&
                  (ne +=
                    `';
` +
                    ee +
                    `
__p+='`),
              p
            );
          }),
            (ne += `';
`);
          var P = L.variable;
          if (P) {
            if (!X.test(P))
              throw new Error("variable is not a bare identifier: " + P);
          } else
            (ne =
              `with(obj||{}){
` +
              ne +
              `}
`),
              (P = "obj");
          ne =
            `var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
` +
            ne +
            `return __p;
`;
          var U;
          try {
            U = new Function(L.variable || "obj", "_", ne);
          } catch (p) {
            throw ((p.source = ne), p);
          }
          var K = function (p) {
            return U.call(this, p, e);
          };
          return (
            (K.source =
              "function(" +
              P +
              `){
` +
              ne +
              "}"),
            K
          );
        }),
        e
      );
    })();
  });
  var Ze = u((cW, xs) => {
    var ge = {},
      kt = {},
      jt = [],
      Fi = window.Webflow || [],
      It = window.jQuery,
      $e = It(window),
      pm = It(document),
      at = It.isFunction,
      Qe = (ge._ = Ts()),
      bs = (ge.tram = Di() && It.tram),
      ln = !1,
      Gi = !1;
    bs.config.hideBackface = !1;
    bs.config.keepInherited = !0;
    ge.define = function (e, t, r) {
      kt[e] && As(kt[e]);
      var n = (kt[e] = t(It, Qe, r) || {});
      return Ss(n), n;
    };
    ge.require = function (e) {
      return kt[e];
    };
    function Ss(e) {
      ge.env() &&
        (at(e.design) && $e.on("__wf_design", e.design),
        at(e.preview) && $e.on("__wf_preview", e.preview)),
        at(e.destroy) && $e.on("__wf_destroy", e.destroy),
        e.ready && at(e.ready) && vm(e);
    }
    function vm(e) {
      if (ln) {
        e.ready();
        return;
      }
      Qe.contains(jt, e.ready) || jt.push(e.ready);
    }
    function As(e) {
      at(e.design) && $e.off("__wf_design", e.design),
        at(e.preview) && $e.off("__wf_preview", e.preview),
        at(e.destroy) && $e.off("__wf_destroy", e.destroy),
        e.ready && at(e.ready) && hm(e);
    }
    function hm(e) {
      jt = Qe.filter(jt, function (t) {
        return t !== e.ready;
      });
    }
    ge.push = function (e) {
      if (ln) {
        at(e) && e();
        return;
      }
      Fi.push(e);
    };
    ge.env = function (e) {
      var t = window.__wf_design,
        r = typeof t < "u";
      if (!e) return r;
      if (e === "design") return r && t;
      if (e === "preview") return r && !t;
      if (e === "slug") return r && window.__wf_slug;
      if (e === "editor") return window.WebflowEditor;
      if (e === "test") return window.__wf_test;
      if (e === "frame") return window !== window.top;
    };
    var cn = navigator.userAgent.toLowerCase(),
      ws = (ge.env.touch =
        "ontouchstart" in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch)),
      gm = (ge.env.chrome =
        /chrome/.test(cn) &&
        /Google/.test(navigator.vendor) &&
        parseInt(cn.match(/chrome\/(\d+)\./)[1], 10)),
      Em = (ge.env.ios = /(ipod|iphone|ipad)/.test(cn));
    ge.env.safari = /safari/.test(cn) && !gm && !Em;
    var Mi;
    ws &&
      pm.on("touchstart mousedown", function (e) {
        Mi = e.target;
      });
    ge.validClick = ws
      ? function (e) {
          return e === Mi || It.contains(e, Mi);
        }
      : function () {
          return !0;
        };
    var Rs = "resize.webflow orientationchange.webflow load.webflow",
      _m = "scroll.webflow " + Rs;
    ge.resize = Xi($e, Rs);
    ge.scroll = Xi($e, _m);
    ge.redraw = Xi();
    function Xi(e, t) {
      var r = [],
        n = {};
      return (
        (n.up = Qe.throttle(function (i) {
          Qe.each(r, function (o) {
            o(i);
          });
        })),
        e && t && e.on(t, n.up),
        (n.on = function (i) {
          typeof i == "function" && (Qe.contains(r, i) || r.push(i));
        }),
        (n.off = function (i) {
          if (!arguments.length) {
            r = [];
            return;
          }
          r = Qe.filter(r, function (o) {
            return o !== i;
          });
        }),
        n
      );
    }
    ge.location = function (e) {
      window.location = e;
    };
    ge.env() && (ge.location = function () {});
    ge.ready = function () {
      (ln = !0), Gi ? ym() : Qe.each(jt, Os), Qe.each(Fi, Os), ge.resize.up();
    };
    function Os(e) {
      at(e) && e();
    }
    function ym() {
      (Gi = !1), Qe.each(kt, Ss);
    }
    var qt;
    ge.load = function (e) {
      qt.then(e);
    };
    function Cs() {
      qt && (qt.reject(), $e.off("load", qt.resolve)),
        (qt = new It.Deferred()),
        $e.on("load", qt.resolve);
    }
    ge.destroy = function (e) {
      (e = e || {}),
        (Gi = !0),
        $e.triggerHandler("__wf_destroy"),
        e.domready != null && (ln = e.domready),
        Qe.each(kt, As),
        ge.resize.off(),
        ge.scroll.off(),
        ge.redraw.off(),
        (jt = []),
        (Fi = []),
        qt.state() === "pending" && Cs();
    };
    It(ge.ready);
    Cs();
    xs.exports = window.Webflow = ge;
  });
  var Ls = u((lW, qs) => {
    var Ns = Ze();
    Ns.define(
      "brand",
      (qs.exports = function (e) {
        var t = {},
          r = document,
          n = e("html"),
          i = e("body"),
          o = ".w-webflow-badge",
          a = window.location,
          s = /PhantomJS/i.test(navigator.userAgent),
          c =
            "fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange",
          d;
        t.ready = function () {
          var h = n.attr("data-wf-status"),
            _ = n.attr("data-wf-domain") || "";
          /\.webflow\.io$/i.test(_) && a.hostname !== _ && (h = !0),
            h &&
              !s &&
              ((d = d || f()),
              y(),
              setTimeout(y, 500),
              e(r).off(c, g).on(c, g));
        };
        function g() {
          var h =
            r.fullScreen ||
            r.mozFullScreen ||
            r.webkitIsFullScreen ||
            r.msFullscreenElement ||
            !!r.webkitFullscreenElement;
          e(d).attr("style", h ? "display: none !important;" : "");
        }
        function f() {
          var h = e('<a class="w-webflow-badge"></a>').attr(
              "href",
              "https://webflow.com?utm_campaign=brandjs"
            ),
            _ = e("<img>")
              .attr(
                "src",
                "https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-icon.f67cd735e3.svg"
              )
              .attr("alt", "")
              .css({ marginRight: "8px", width: "16px" }),
            b = e("<img>")
              .attr(
                "src",
                "https://d1otoma47x30pg.cloudfront.net/img/webflow-badge-text.6faa6a38cd.svg"
              )
              .attr("alt", "Made in Webflow");
          return h.append(_, b), h[0];
        }
        function y() {
          var h = i.children(o),
            _ = h.length && h.get(0) === d,
            b = Ns.env("editor");
          if (_) {
            b && h.remove();
            return;
          }
          h.length && h.remove(), b || i.append(d);
        }
        return t;
      })
    );
  });
  var Ds = u((fW, Ps) => {
    var mm = Ze();
    mm.define(
      "focus-visible",
      (Ps.exports = function () {
        function e(r) {
          var n = !0,
            i = !1,
            o = null,
            a = {
              text: !0,
              search: !0,
              url: !0,
              tel: !0,
              email: !0,
              password: !0,
              number: !0,
              date: !0,
              month: !0,
              week: !0,
              time: !0,
              datetime: !0,
              "datetime-local": !0,
            };
          function s(S) {
            return !!(
              S &&
              S !== document &&
              S.nodeName !== "HTML" &&
              S.nodeName !== "BODY" &&
              "classList" in S &&
              "contains" in S.classList
            );
          }
          function c(S) {
            var G = S.type,
              F = S.tagName;
            return !!(
              (F === "INPUT" && a[G] && !S.readOnly) ||
              (F === "TEXTAREA" && !S.readOnly) ||
              S.isContentEditable
            );
          }
          function d(S) {
            S.getAttribute("data-wf-focus-visible") ||
              S.setAttribute("data-wf-focus-visible", "true");
          }
          function g(S) {
            S.getAttribute("data-wf-focus-visible") &&
              S.removeAttribute("data-wf-focus-visible");
          }
          function f(S) {
            S.metaKey ||
              S.altKey ||
              S.ctrlKey ||
              (s(r.activeElement) && d(r.activeElement), (n = !0));
          }
          function y() {
            n = !1;
          }
          function h(S) {
            s(S.target) && (n || c(S.target)) && d(S.target);
          }
          function _(S) {
            s(S.target) &&
              S.target.hasAttribute("data-wf-focus-visible") &&
              ((i = !0),
              window.clearTimeout(o),
              (o = window.setTimeout(function () {
                i = !1;
              }, 100)),
              g(S.target));
          }
          function b() {
            document.visibilityState === "hidden" && (i && (n = !0), C());
          }
          function C() {
            document.addEventListener("mousemove", N),
              document.addEventListener("mousedown", N),
              document.addEventListener("mouseup", N),
              document.addEventListener("pointermove", N),
              document.addEventListener("pointerdown", N),
              document.addEventListener("pointerup", N),
              document.addEventListener("touchmove", N),
              document.addEventListener("touchstart", N),
              document.addEventListener("touchend", N);
          }
          function R() {
            document.removeEventListener("mousemove", N),
              document.removeEventListener("mousedown", N),
              document.removeEventListener("mouseup", N),
              document.removeEventListener("pointermove", N),
              document.removeEventListener("pointerdown", N),
              document.removeEventListener("pointerup", N),
              document.removeEventListener("touchmove", N),
              document.removeEventListener("touchstart", N),
              document.removeEventListener("touchend", N);
          }
          function N(S) {
            (S.target.nodeName && S.target.nodeName.toLowerCase() === "html") ||
              ((n = !1), R());
          }
          document.addEventListener("keydown", f, !0),
            document.addEventListener("mousedown", y, !0),
            document.addEventListener("pointerdown", y, !0),
            document.addEventListener("touchstart", y, !0),
            document.addEventListener("visibilitychange", b, !0),
            C(),
            r.addEventListener("focus", h, !0),
            r.addEventListener("blur", _, !0);
        }
        function t() {
          if (typeof document < "u")
            try {
              document.querySelector(":focus-visible");
            } catch {
              e(document);
            }
        }
        return { ready: t };
      })
    );
  });
  var Gs = u((dW, Fs) => {
    var Ms = Ze();
    Ms.define(
      "focus",
      (Fs.exports = function () {
        var e = [],
          t = !1;
        function r(a) {
          t &&
            (a.preventDefault(),
            a.stopPropagation(),
            a.stopImmediatePropagation(),
            e.unshift(a));
        }
        function n(a) {
          var s = a.target,
            c = s.tagName;
          return (
            (/^a$/i.test(c) && s.href != null) ||
            (/^(button|textarea)$/i.test(c) && s.disabled !== !0) ||
            (/^input$/i.test(c) &&
              /^(button|reset|submit|radio|checkbox)$/i.test(s.type) &&
              !s.disabled) ||
            (!/^(button|input|textarea|select|a)$/i.test(c) &&
              !Number.isNaN(Number.parseFloat(s.tabIndex))) ||
            /^audio$/i.test(c) ||
            (/^video$/i.test(c) && s.controls === !0)
          );
        }
        function i(a) {
          n(a) &&
            ((t = !0),
            setTimeout(() => {
              for (t = !1, a.target.focus(); e.length > 0; ) {
                var s = e.pop();
                s.target.dispatchEvent(new MouseEvent(s.type, s));
              }
            }, 0));
        }
        function o() {
          typeof document < "u" &&
            document.body.hasAttribute("data-wf-focus-within") &&
            Ms.env.safari &&
            (document.addEventListener("mousedown", i, !0),
            document.addEventListener("mouseup", r, !0),
            document.addEventListener("click", r, !0));
        }
        return { ready: o };
      })
    );
  });
  var Vs = u((pW, Us) => {
    "use strict";
    var Ui = window.jQuery,
      st = {},
      fn = [],
      Xs = ".w-ix",
      dn = {
        reset: function (e, t) {
          t.__wf_intro = null;
        },
        intro: function (e, t) {
          t.__wf_intro ||
            ((t.__wf_intro = !0), Ui(t).triggerHandler(st.types.INTRO));
        },
        outro: function (e, t) {
          t.__wf_intro &&
            ((t.__wf_intro = null), Ui(t).triggerHandler(st.types.OUTRO));
        },
      };
    st.triggers = {};
    st.types = { INTRO: "w-ix-intro" + Xs, OUTRO: "w-ix-outro" + Xs };
    st.init = function () {
      for (var e = fn.length, t = 0; t < e; t++) {
        var r = fn[t];
        r[0](0, r[1]);
      }
      (fn = []), Ui.extend(st.triggers, dn);
    };
    st.async = function () {
      for (var e in dn) {
        var t = dn[e];
        dn.hasOwnProperty(e) &&
          (st.triggers[e] = function (r, n) {
            fn.push([t, n]);
          });
      }
    };
    st.async();
    Us.exports = st;
  });
  var Wi = u((vW, Hs) => {
    "use strict";
    var Vi = Vs();
    function Ws(e, t) {
      var r = document.createEvent("CustomEvent");
      r.initCustomEvent(t, !0, !0, null), e.dispatchEvent(r);
    }
    var Im = window.jQuery,
      pn = {},
      Bs = ".w-ix",
      Tm = {
        reset: function (e, t) {
          Vi.triggers.reset(e, t);
        },
        intro: function (e, t) {
          Vi.triggers.intro(e, t), Ws(t, "COMPONENT_ACTIVE");
        },
        outro: function (e, t) {
          Vi.triggers.outro(e, t), Ws(t, "COMPONENT_INACTIVE");
        },
      };
    pn.triggers = {};
    pn.types = { INTRO: "w-ix-intro" + Bs, OUTRO: "w-ix-outro" + Bs };
    Im.extend(pn.triggers, Tm);
    Hs.exports = pn;
  });
  var ks = u((hW, gt) => {
    function Bi(e) {
      return (
        (gt.exports = Bi =
          typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  typeof Symbol == "function" &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        (gt.exports.__esModule = !0),
        (gt.exports.default = gt.exports),
        Bi(e)
      );
    }
    (gt.exports = Bi),
      (gt.exports.__esModule = !0),
      (gt.exports.default = gt.exports);
  });
  var Kt = u((gW, Or) => {
    var Om = ks().default;
    function js(e) {
      if (typeof WeakMap != "function") return null;
      var t = new WeakMap(),
        r = new WeakMap();
      return (js = function (i) {
        return i ? r : t;
      })(e);
    }
    function bm(e, t) {
      if (!t && e && e.__esModule) return e;
      if (e === null || (Om(e) !== "object" && typeof e != "function"))
        return { default: e };
      var r = js(t);
      if (r && r.has(e)) return r.get(e);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var o in e)
        if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
          var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
          a && (a.get || a.set)
            ? Object.defineProperty(n, o, a)
            : (n[o] = e[o]);
        }
      return (n.default = e), r && r.set(e, n), n;
    }
    (Or.exports = bm),
      (Or.exports.__esModule = !0),
      (Or.exports.default = Or.exports);
  });
  var ut = u((EW, br) => {
    function Sm(e) {
      return e && e.__esModule ? e : { default: e };
    }
    (br.exports = Sm),
      (br.exports.__esModule = !0),
      (br.exports.default = br.exports);
  });
  var me = u((_W, Ks) => {
    var vn = function (e) {
      return e && e.Math == Math && e;
    };
    Ks.exports =
      vn(typeof globalThis == "object" && globalThis) ||
      vn(typeof window == "object" && window) ||
      vn(typeof self == "object" && self) ||
      vn(typeof global == "object" && global) ||
      (function () {
        return this;
      })() ||
      Function("return this")();
  });
  var zt = u((yW, zs) => {
    zs.exports = function (e) {
      try {
        return !!e();
      } catch {
        return !0;
      }
    };
  });
  var Lt = u((mW, Ys) => {
    var Am = zt();
    Ys.exports = !Am(function () {
      return (
        Object.defineProperty({}, 1, {
          get: function () {
            return 7;
          },
        })[1] != 7
      );
    });
  });
  var hn = u((IW, Qs) => {
    var Sr = Function.prototype.call;
    Qs.exports = Sr.bind
      ? Sr.bind(Sr)
      : function () {
          return Sr.apply(Sr, arguments);
        };
  });
  var eu = u((Js) => {
    "use strict";
    var $s = {}.propertyIsEnumerable,
      Zs = Object.getOwnPropertyDescriptor,
      wm = Zs && !$s.call({ 1: 2 }, 1);
    Js.f = wm
      ? function (t) {
          var r = Zs(this, t);
          return !!r && r.enumerable;
        }
      : $s;
  });
  var Hi = u((OW, tu) => {
    tu.exports = function (e, t) {
      return {
        enumerable: !(e & 1),
        configurable: !(e & 2),
        writable: !(e & 4),
        value: t,
      };
    };
  });
  var Je = u((bW, nu) => {
    var ru = Function.prototype,
      ki = ru.bind,
      ji = ru.call,
      Rm = ki && ki.bind(ji);
    nu.exports = ki
      ? function (e) {
          return e && Rm(ji, e);
        }
      : function (e) {
          return (
            e &&
            function () {
              return ji.apply(e, arguments);
            }
          );
        };
  });
  var au = u((SW, ou) => {
    var iu = Je(),
      Cm = iu({}.toString),
      xm = iu("".slice);
    ou.exports = function (e) {
      return xm(Cm(e), 8, -1);
    };
  });
  var uu = u((AW, su) => {
    var Nm = me(),
      qm = Je(),
      Lm = zt(),
      Pm = au(),
      Ki = Nm.Object,
      Dm = qm("".split);
    su.exports = Lm(function () {
      return !Ki("z").propertyIsEnumerable(0);
    })
      ? function (e) {
          return Pm(e) == "String" ? Dm(e, "") : Ki(e);
        }
      : Ki;
  });
  var zi = u((wW, cu) => {
    var Mm = me(),
      Fm = Mm.TypeError;
    cu.exports = function (e) {
      if (e == null) throw Fm("Can't call method on " + e);
      return e;
    };
  });
  var Ar = u((RW, lu) => {
    var Gm = uu(),
      Xm = zi();
    lu.exports = function (e) {
      return Gm(Xm(e));
    };
  });
  var ct = u((CW, fu) => {
    fu.exports = function (e) {
      return typeof e == "function";
    };
  });
  var Yt = u((xW, du) => {
    var Um = ct();
    du.exports = function (e) {
      return typeof e == "object" ? e !== null : Um(e);
    };
  });
  var wr = u((NW, pu) => {
    var Yi = me(),
      Vm = ct(),
      Wm = function (e) {
        return Vm(e) ? e : void 0;
      };
    pu.exports = function (e, t) {
      return arguments.length < 2 ? Wm(Yi[e]) : Yi[e] && Yi[e][t];
    };
  });
  var hu = u((qW, vu) => {
    var Bm = Je();
    vu.exports = Bm({}.isPrototypeOf);
  });
  var Eu = u((LW, gu) => {
    var Hm = wr();
    gu.exports = Hm("navigator", "userAgent") || "";
  });
  var bu = u((PW, Ou) => {
    var Tu = me(),
      Qi = Eu(),
      _u = Tu.process,
      yu = Tu.Deno,
      mu = (_u && _u.versions) || (yu && yu.version),
      Iu = mu && mu.v8,
      et,
      gn;
    Iu &&
      ((et = Iu.split(".")),
      (gn = et[0] > 0 && et[0] < 4 ? 1 : +(et[0] + et[1])));
    !gn &&
      Qi &&
      ((et = Qi.match(/Edge\/(\d+)/)),
      (!et || et[1] >= 74) &&
        ((et = Qi.match(/Chrome\/(\d+)/)), et && (gn = +et[1])));
    Ou.exports = gn;
  });
  var $i = u((DW, Au) => {
    var Su = bu(),
      km = zt();
    Au.exports =
      !!Object.getOwnPropertySymbols &&
      !km(function () {
        var e = Symbol();
        return (
          !String(e) ||
          !(Object(e) instanceof Symbol) ||
          (!Symbol.sham && Su && Su < 41)
        );
      });
  });
  var Zi = u((MW, wu) => {
    var jm = $i();
    wu.exports = jm && !Symbol.sham && typeof Symbol.iterator == "symbol";
  });
  var Ji = u((FW, Ru) => {
    var Km = me(),
      zm = wr(),
      Ym = ct(),
      Qm = hu(),
      $m = Zi(),
      Zm = Km.Object;
    Ru.exports = $m
      ? function (e) {
          return typeof e == "symbol";
        }
      : function (e) {
          var t = zm("Symbol");
          return Ym(t) && Qm(t.prototype, Zm(e));
        };
  });
  var xu = u((GW, Cu) => {
    var Jm = me(),
      eI = Jm.String;
    Cu.exports = function (e) {
      try {
        return eI(e);
      } catch {
        return "Object";
      }
    };
  });
  var qu = u((XW, Nu) => {
    var tI = me(),
      rI = ct(),
      nI = xu(),
      iI = tI.TypeError;
    Nu.exports = function (e) {
      if (rI(e)) return e;
      throw iI(nI(e) + " is not a function");
    };
  });
  var Pu = u((UW, Lu) => {
    var oI = qu();
    Lu.exports = function (e, t) {
      var r = e[t];
      return r == null ? void 0 : oI(r);
    };
  });
  var Mu = u((VW, Du) => {
    var aI = me(),
      eo = hn(),
      to = ct(),
      ro = Yt(),
      sI = aI.TypeError;
    Du.exports = function (e, t) {
      var r, n;
      if (
        (t === "string" && to((r = e.toString)) && !ro((n = eo(r, e)))) ||
        (to((r = e.valueOf)) && !ro((n = eo(r, e)))) ||
        (t !== "string" && to((r = e.toString)) && !ro((n = eo(r, e))))
      )
        return n;
      throw sI("Can't convert object to primitive value");
    };
  });
  var Gu = u((WW, Fu) => {
    Fu.exports = !1;
  });
  var En = u((BW, Uu) => {
    var Xu = me(),
      uI = Object.defineProperty;
    Uu.exports = function (e, t) {
      try {
        uI(Xu, e, { value: t, configurable: !0, writable: !0 });
      } catch {
        Xu[e] = t;
      }
      return t;
    };
  });
  var _n = u((HW, Wu) => {
    var cI = me(),
      lI = En(),
      Vu = "__core-js_shared__",
      fI = cI[Vu] || lI(Vu, {});
    Wu.exports = fI;
  });
  var no = u((kW, Hu) => {
    var dI = Gu(),
      Bu = _n();
    (Hu.exports = function (e, t) {
      return Bu[e] || (Bu[e] = t !== void 0 ? t : {});
    })("versions", []).push({
      version: "3.19.0",
      mode: dI ? "pure" : "global",
      copyright: "\xA9 2021 Denis Pushkarev (zloirock.ru)",
    });
  });
  var ju = u((jW, ku) => {
    var pI = me(),
      vI = zi(),
      hI = pI.Object;
    ku.exports = function (e) {
      return hI(vI(e));
    };
  });
  var Tt = u((KW, Ku) => {
    var gI = Je(),
      EI = ju(),
      _I = gI({}.hasOwnProperty);
    Ku.exports =
      Object.hasOwn ||
      function (t, r) {
        return _I(EI(t), r);
      };
  });
  var io = u((zW, zu) => {
    var yI = Je(),
      mI = 0,
      II = Math.random(),
      TI = yI((1).toString);
    zu.exports = function (e) {
      return "Symbol(" + (e === void 0 ? "" : e) + ")_" + TI(++mI + II, 36);
    };
  });
  var oo = u((YW, Ju) => {
    var OI = me(),
      bI = no(),
      Yu = Tt(),
      SI = io(),
      Qu = $i(),
      Zu = Zi(),
      Qt = bI("wks"),
      Pt = OI.Symbol,
      $u = Pt && Pt.for,
      AI = Zu ? Pt : (Pt && Pt.withoutSetter) || SI;
    Ju.exports = function (e) {
      if (!Yu(Qt, e) || !(Qu || typeof Qt[e] == "string")) {
        var t = "Symbol." + e;
        Qu && Yu(Pt, e)
          ? (Qt[e] = Pt[e])
          : Zu && $u
          ? (Qt[e] = $u(t))
          : (Qt[e] = AI(t));
      }
      return Qt[e];
    };
  });
  var nc = u((QW, rc) => {
    var wI = me(),
      RI = hn(),
      ec = Yt(),
      tc = Ji(),
      CI = Pu(),
      xI = Mu(),
      NI = oo(),
      qI = wI.TypeError,
      LI = NI("toPrimitive");
    rc.exports = function (e, t) {
      if (!ec(e) || tc(e)) return e;
      var r = CI(e, LI),
        n;
      if (r) {
        if (
          (t === void 0 && (t = "default"), (n = RI(r, e, t)), !ec(n) || tc(n))
        )
          return n;
        throw qI("Can't convert object to primitive value");
      }
      return t === void 0 && (t = "number"), xI(e, t);
    };
  });
  var ao = u(($W, ic) => {
    var PI = nc(),
      DI = Ji();
    ic.exports = function (e) {
      var t = PI(e, "string");
      return DI(t) ? t : t + "";
    };
  });
  var uo = u((ZW, ac) => {
    var MI = me(),
      oc = Yt(),
      so = MI.document,
      FI = oc(so) && oc(so.createElement);
    ac.exports = function (e) {
      return FI ? so.createElement(e) : {};
    };
  });
  var co = u((JW, sc) => {
    var GI = Lt(),
      XI = zt(),
      UI = uo();
    sc.exports =
      !GI &&
      !XI(function () {
        return (
          Object.defineProperty(UI("div"), "a", {
            get: function () {
              return 7;
            },
          }).a != 7
        );
      });
  });
  var lo = u((cc) => {
    var VI = Lt(),
      WI = hn(),
      BI = eu(),
      HI = Hi(),
      kI = Ar(),
      jI = ao(),
      KI = Tt(),
      zI = co(),
      uc = Object.getOwnPropertyDescriptor;
    cc.f = VI
      ? uc
      : function (t, r) {
          if (((t = kI(t)), (r = jI(r)), zI))
            try {
              return uc(t, r);
            } catch {}
          if (KI(t, r)) return HI(!WI(BI.f, t, r), t[r]);
        };
  });
  var Rr = u((tB, fc) => {
    var lc = me(),
      YI = Yt(),
      QI = lc.String,
      $I = lc.TypeError;
    fc.exports = function (e) {
      if (YI(e)) return e;
      throw $I(QI(e) + " is not an object");
    };
  });
  var Cr = u((vc) => {
    var ZI = me(),
      JI = Lt(),
      eT = co(),
      dc = Rr(),
      tT = ao(),
      rT = ZI.TypeError,
      pc = Object.defineProperty;
    vc.f = JI
      ? pc
      : function (t, r, n) {
          if ((dc(t), (r = tT(r)), dc(n), eT))
            try {
              return pc(t, r, n);
            } catch {}
          if ("get" in n || "set" in n) throw rT("Accessors not supported");
          return "value" in n && (t[r] = n.value), t;
        };
  });
  var yn = u((nB, hc) => {
    var nT = Lt(),
      iT = Cr(),
      oT = Hi();
    hc.exports = nT
      ? function (e, t, r) {
          return iT.f(e, t, oT(1, r));
        }
      : function (e, t, r) {
          return (e[t] = r), e;
        };
  });
  var po = u((iB, gc) => {
    var aT = Je(),
      sT = ct(),
      fo = _n(),
      uT = aT(Function.toString);
    sT(fo.inspectSource) ||
      (fo.inspectSource = function (e) {
        return uT(e);
      });
    gc.exports = fo.inspectSource;
  });
  var yc = u((oB, _c) => {
    var cT = me(),
      lT = ct(),
      fT = po(),
      Ec = cT.WeakMap;
    _c.exports = lT(Ec) && /native code/.test(fT(Ec));
  });
  var vo = u((aB, Ic) => {
    var dT = no(),
      pT = io(),
      mc = dT("keys");
    Ic.exports = function (e) {
      return mc[e] || (mc[e] = pT(e));
    };
  });
  var mn = u((sB, Tc) => {
    Tc.exports = {};
  });
  var Rc = u((uB, wc) => {
    var vT = yc(),
      Ac = me(),
      ho = Je(),
      hT = Yt(),
      gT = yn(),
      go = Tt(),
      Eo = _n(),
      ET = vo(),
      _T = mn(),
      Oc = "Object already initialized",
      yo = Ac.TypeError,
      yT = Ac.WeakMap,
      In,
      xr,
      Tn,
      mT = function (e) {
        return Tn(e) ? xr(e) : In(e, {});
      },
      IT = function (e) {
        return function (t) {
          var r;
          if (!hT(t) || (r = xr(t)).type !== e)
            throw yo("Incompatible receiver, " + e + " required");
          return r;
        };
      };
    vT || Eo.state
      ? ((Ot = Eo.state || (Eo.state = new yT())),
        (bc = ho(Ot.get)),
        (_o = ho(Ot.has)),
        (Sc = ho(Ot.set)),
        (In = function (e, t) {
          if (_o(Ot, e)) throw new yo(Oc);
          return (t.facade = e), Sc(Ot, e, t), t;
        }),
        (xr = function (e) {
          return bc(Ot, e) || {};
        }),
        (Tn = function (e) {
          return _o(Ot, e);
        }))
      : ((Dt = ET("state")),
        (_T[Dt] = !0),
        (In = function (e, t) {
          if (go(e, Dt)) throw new yo(Oc);
          return (t.facade = e), gT(e, Dt, t), t;
        }),
        (xr = function (e) {
          return go(e, Dt) ? e[Dt] : {};
        }),
        (Tn = function (e) {
          return go(e, Dt);
        }));
    var Ot, bc, _o, Sc, Dt;
    wc.exports = { set: In, get: xr, has: Tn, enforce: mT, getterFor: IT };
  });
  var Nc = u((cB, xc) => {
    var mo = Lt(),
      TT = Tt(),
      Cc = Function.prototype,
      OT = mo && Object.getOwnPropertyDescriptor,
      Io = TT(Cc, "name"),
      bT = Io && function () {}.name === "something",
      ST = Io && (!mo || (mo && OT(Cc, "name").configurable));
    xc.exports = { EXISTS: Io, PROPER: bT, CONFIGURABLE: ST };
  });
  var Mc = u((lB, Dc) => {
    var AT = me(),
      qc = ct(),
      wT = Tt(),
      Lc = yn(),
      RT = En(),
      CT = po(),
      Pc = Rc(),
      xT = Nc().CONFIGURABLE,
      NT = Pc.get,
      qT = Pc.enforce,
      LT = String(String).split("String");
    (Dc.exports = function (e, t, r, n) {
      var i = n ? !!n.unsafe : !1,
        o = n ? !!n.enumerable : !1,
        a = n ? !!n.noTargetGet : !1,
        s = n && n.name !== void 0 ? n.name : t,
        c;
      if (
        (qc(r) &&
          (String(s).slice(0, 7) === "Symbol(" &&
            (s = "[" + String(s).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"),
          (!wT(r, "name") || (xT && r.name !== s)) && Lc(r, "name", s),
          (c = qT(r)),
          c.source || (c.source = LT.join(typeof s == "string" ? s : ""))),
        e === AT)
      ) {
        o ? (e[t] = r) : RT(t, r);
        return;
      } else i ? !a && e[t] && (o = !0) : delete e[t];
      o ? (e[t] = r) : Lc(e, t, r);
    })(Function.prototype, "toString", function () {
      return (qc(this) && NT(this).source) || CT(this);
    });
  });
  var To = u((fB, Fc) => {
    var PT = Math.ceil,
      DT = Math.floor;
    Fc.exports = function (e) {
      var t = +e;
      return t !== t || t === 0 ? 0 : (t > 0 ? DT : PT)(t);
    };
  });
  var Xc = u((dB, Gc) => {
    var MT = To(),
      FT = Math.max,
      GT = Math.min;
    Gc.exports = function (e, t) {
      var r = MT(e);
      return r < 0 ? FT(r + t, 0) : GT(r, t);
    };
  });
  var Vc = u((pB, Uc) => {
    var XT = To(),
      UT = Math.min;
    Uc.exports = function (e) {
      return e > 0 ? UT(XT(e), 9007199254740991) : 0;
    };
  });
  var Bc = u((vB, Wc) => {
    var VT = Vc();
    Wc.exports = function (e) {
      return VT(e.length);
    };
  });
  var Oo = u((hB, kc) => {
    var WT = Ar(),
      BT = Xc(),
      HT = Bc(),
      Hc = function (e) {
        return function (t, r, n) {
          var i = WT(t),
            o = HT(i),
            a = BT(n, o),
            s;
          if (e && r != r) {
            for (; o > a; ) if (((s = i[a++]), s != s)) return !0;
          } else
            for (; o > a; a++)
              if ((e || a in i) && i[a] === r) return e || a || 0;
          return !e && -1;
        };
      };
    kc.exports = { includes: Hc(!0), indexOf: Hc(!1) };
  });
  var So = u((gB, Kc) => {
    var kT = Je(),
      bo = Tt(),
      jT = Ar(),
      KT = Oo().indexOf,
      zT = mn(),
      jc = kT([].push);
    Kc.exports = function (e, t) {
      var r = jT(e),
        n = 0,
        i = [],
        o;
      for (o in r) !bo(zT, o) && bo(r, o) && jc(i, o);
      for (; t.length > n; ) bo(r, (o = t[n++])) && (~KT(i, o) || jc(i, o));
      return i;
    };
  });
  var On = u((EB, zc) => {
    zc.exports = [
      "constructor",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "toLocaleString",
      "toString",
      "valueOf",
    ];
  });
  var Qc = u((Yc) => {
    var YT = So(),
      QT = On(),
      $T = QT.concat("length", "prototype");
    Yc.f =
      Object.getOwnPropertyNames ||
      function (t) {
        return YT(t, $T);
      };
  });
  var Zc = u(($c) => {
    $c.f = Object.getOwnPropertySymbols;
  });
  var el = u((mB, Jc) => {
    var ZT = wr(),
      JT = Je(),
      eO = Qc(),
      tO = Zc(),
      rO = Rr(),
      nO = JT([].concat);
    Jc.exports =
      ZT("Reflect", "ownKeys") ||
      function (t) {
        var r = eO.f(rO(t)),
          n = tO.f;
        return n ? nO(r, n(t)) : r;
      };
  });
  var rl = u((IB, tl) => {
    var iO = Tt(),
      oO = el(),
      aO = lo(),
      sO = Cr();
    tl.exports = function (e, t) {
      for (var r = oO(t), n = sO.f, i = aO.f, o = 0; o < r.length; o++) {
        var a = r[o];
        iO(e, a) || n(e, a, i(t, a));
      }
    };
  });
  var il = u((TB, nl) => {
    var uO = zt(),
      cO = ct(),
      lO = /#|\.prototype\./,
      Nr = function (e, t) {
        var r = dO[fO(e)];
        return r == vO ? !0 : r == pO ? !1 : cO(t) ? uO(t) : !!t;
      },
      fO = (Nr.normalize = function (e) {
        return String(e).replace(lO, ".").toLowerCase();
      }),
      dO = (Nr.data = {}),
      pO = (Nr.NATIVE = "N"),
      vO = (Nr.POLYFILL = "P");
    nl.exports = Nr;
  });
  var al = u((OB, ol) => {
    var Ao = me(),
      hO = lo().f,
      gO = yn(),
      EO = Mc(),
      _O = En(),
      yO = rl(),
      mO = il();
    ol.exports = function (e, t) {
      var r = e.target,
        n = e.global,
        i = e.stat,
        o,
        a,
        s,
        c,
        d,
        g;
      if (
        (n
          ? (a = Ao)
          : i
          ? (a = Ao[r] || _O(r, {}))
          : (a = (Ao[r] || {}).prototype),
        a)
      )
        for (s in t) {
          if (
            ((d = t[s]),
            e.noTargetGet ? ((g = hO(a, s)), (c = g && g.value)) : (c = a[s]),
            (o = mO(n ? s : r + (i ? "." : "#") + s, e.forced)),
            !o && c !== void 0)
          ) {
            if (typeof d == typeof c) continue;
            yO(d, c);
          }
          (e.sham || (c && c.sham)) && gO(d, "sham", !0), EO(a, s, d, e);
        }
    };
  });
  var ul = u((bB, sl) => {
    var IO = So(),
      TO = On();
    sl.exports =
      Object.keys ||
      function (t) {
        return IO(t, TO);
      };
  });
  var ll = u((SB, cl) => {
    var OO = Lt(),
      bO = Cr(),
      SO = Rr(),
      AO = Ar(),
      wO = ul();
    cl.exports = OO
      ? Object.defineProperties
      : function (t, r) {
          SO(t);
          for (var n = AO(r), i = wO(r), o = i.length, a = 0, s; o > a; )
            bO.f(t, (s = i[a++]), n[s]);
          return t;
        };
  });
  var dl = u((AB, fl) => {
    var RO = wr();
    fl.exports = RO("document", "documentElement");
  });
  var ml = u((wB, yl) => {
    var CO = Rr(),
      xO = ll(),
      pl = On(),
      NO = mn(),
      qO = dl(),
      LO = uo(),
      PO = vo(),
      vl = ">",
      hl = "<",
      Ro = "prototype",
      Co = "script",
      El = PO("IE_PROTO"),
      wo = function () {},
      _l = function (e) {
        return hl + Co + vl + e + hl + "/" + Co + vl;
      },
      gl = function (e) {
        e.write(_l("")), e.close();
        var t = e.parentWindow.Object;
        return (e = null), t;
      },
      DO = function () {
        var e = LO("iframe"),
          t = "java" + Co + ":",
          r;
        return (
          (e.style.display = "none"),
          qO.appendChild(e),
          (e.src = String(t)),
          (r = e.contentWindow.document),
          r.open(),
          r.write(_l("document.F=Object")),
          r.close(),
          r.F
        );
      },
      bn,
      Sn = function () {
        try {
          bn = new ActiveXObject("htmlfile");
        } catch {}
        Sn =
          typeof document < "u"
            ? document.domain && bn
              ? gl(bn)
              : DO()
            : gl(bn);
        for (var e = pl.length; e--; ) delete Sn[Ro][pl[e]];
        return Sn();
      };
    NO[El] = !0;
    yl.exports =
      Object.create ||
      function (t, r) {
        var n;
        return (
          t !== null
            ? ((wo[Ro] = CO(t)), (n = new wo()), (wo[Ro] = null), (n[El] = t))
            : (n = Sn()),
          r === void 0 ? n : xO(n, r)
        );
      };
  });
  var Tl = u((RB, Il) => {
    var MO = oo(),
      FO = ml(),
      GO = Cr(),
      xo = MO("unscopables"),
      No = Array.prototype;
    No[xo] == null && GO.f(No, xo, { configurable: !0, value: FO(null) });
    Il.exports = function (e) {
      No[xo][e] = !0;
    };
  });
  var Ol = u(() => {
    "use strict";
    var XO = al(),
      UO = Oo().includes,
      VO = Tl();
    XO(
      { target: "Array", proto: !0 },
      {
        includes: function (t) {
          return UO(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      }
    );
    VO("includes");
  });
  var Sl = u((NB, bl) => {
    var WO = me(),
      BO = Je();
    bl.exports = function (e, t) {
      return BO(WO[e].prototype[t]);
    };
  });
  var wl = u((qB, Al) => {
    Ol();
    var HO = Sl();
    Al.exports = HO("Array", "includes");
  });
  var Cl = u((LB, Rl) => {
    var kO = wl();
    Rl.exports = kO;
  });
  var Nl = u((PB, xl) => {
    var jO = Cl();
    xl.exports = jO;
  });
  var qo = u((DB, ql) => {
    var KO =
      typeof global == "object" && global && global.Object === Object && global;
    ql.exports = KO;
  });
  var tt = u((MB, Ll) => {
    var zO = qo(),
      YO = typeof self == "object" && self && self.Object === Object && self,
      QO = zO || YO || Function("return this")();
    Ll.exports = QO;
  });
  var $t = u((FB, Pl) => {
    var $O = tt(),
      ZO = $O.Symbol;
    Pl.exports = ZO;
  });
  var Gl = u((GB, Fl) => {
    var Dl = $t(),
      Ml = Object.prototype,
      JO = Ml.hasOwnProperty,
      eb = Ml.toString,
      qr = Dl ? Dl.toStringTag : void 0;
    function tb(e) {
      var t = JO.call(e, qr),
        r = e[qr];
      try {
        e[qr] = void 0;
        var n = !0;
      } catch {}
      var i = eb.call(e);
      return n && (t ? (e[qr] = r) : delete e[qr]), i;
    }
    Fl.exports = tb;
  });
  var Ul = u((XB, Xl) => {
    var rb = Object.prototype,
      nb = rb.toString;
    function ib(e) {
      return nb.call(e);
    }
    Xl.exports = ib;
  });
  var bt = u((UB, Bl) => {
    var Vl = $t(),
      ob = Gl(),
      ab = Ul(),
      sb = "[object Null]",
      ub = "[object Undefined]",
      Wl = Vl ? Vl.toStringTag : void 0;
    function cb(e) {
      return e == null
        ? e === void 0
          ? ub
          : sb
        : Wl && Wl in Object(e)
        ? ob(e)
        : ab(e);
    }
    Bl.exports = cb;
  });
  var Lo = u((VB, Hl) => {
    function lb(e, t) {
      return function (r) {
        return e(t(r));
      };
    }
    Hl.exports = lb;
  });
  var Po = u((WB, kl) => {
    var fb = Lo(),
      db = fb(Object.getPrototypeOf, Object);
    kl.exports = db;
  });
  var Et = u((BB, jl) => {
    function pb(e) {
      return e != null && typeof e == "object";
    }
    jl.exports = pb;
  });
  var Do = u((HB, zl) => {
    var vb = bt(),
      hb = Po(),
      gb = Et(),
      Eb = "[object Object]",
      _b = Function.prototype,
      yb = Object.prototype,
      Kl = _b.toString,
      mb = yb.hasOwnProperty,
      Ib = Kl.call(Object);
    function Tb(e) {
      if (!gb(e) || vb(e) != Eb) return !1;
      var t = hb(e);
      if (t === null) return !0;
      var r = mb.call(t, "constructor") && t.constructor;
      return typeof r == "function" && r instanceof r && Kl.call(r) == Ib;
    }
    zl.exports = Tb;
  });
  var Yl = u((Mo) => {
    "use strict";
    Object.defineProperty(Mo, "__esModule", { value: !0 });
    Mo.default = Ob;
    function Ob(e) {
      var t,
        r = e.Symbol;
      return (
        typeof r == "function"
          ? r.observable
            ? (t = r.observable)
            : ((t = r("observable")), (r.observable = t))
          : (t = "@@observable"),
        t
      );
    }
  });
  var Ql = u((Go, Fo) => {
    "use strict";
    Object.defineProperty(Go, "__esModule", { value: !0 });
    var bb = Yl(),
      Sb = Ab(bb);
    function Ab(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var Zt;
    typeof self < "u"
      ? (Zt = self)
      : typeof window < "u"
      ? (Zt = window)
      : typeof global < "u"
      ? (Zt = global)
      : typeof Fo < "u"
      ? (Zt = Fo)
      : (Zt = Function("return this")());
    var wb = (0, Sb.default)(Zt);
    Go.default = wb;
  });
  var Xo = u((Lr) => {
    "use strict";
    Lr.__esModule = !0;
    Lr.ActionTypes = void 0;
    Lr.default = ef;
    var Rb = Do(),
      Cb = Jl(Rb),
      xb = Ql(),
      $l = Jl(xb);
    function Jl(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var Zl = (Lr.ActionTypes = { INIT: "@@redux/INIT" });
    function ef(e, t, r) {
      var n;
      if (
        (typeof t == "function" && typeof r > "u" && ((r = t), (t = void 0)),
        typeof r < "u")
      ) {
        if (typeof r != "function")
          throw new Error("Expected the enhancer to be a function.");
        return r(ef)(e, t);
      }
      if (typeof e != "function")
        throw new Error("Expected the reducer to be a function.");
      var i = e,
        o = t,
        a = [],
        s = a,
        c = !1;
      function d() {
        s === a && (s = a.slice());
      }
      function g() {
        return o;
      }
      function f(b) {
        if (typeof b != "function")
          throw new Error("Expected listener to be a function.");
        var C = !0;
        return (
          d(),
          s.push(b),
          function () {
            if (C) {
              (C = !1), d();
              var N = s.indexOf(b);
              s.splice(N, 1);
            }
          }
        );
      }
      function y(b) {
        if (!(0, Cb.default)(b))
          throw new Error(
            "Actions must be plain objects. Use custom middleware for async actions."
          );
        if (typeof b.type > "u")
          throw new Error(
            'Actions may not have an undefined "type" property. Have you misspelled a constant?'
          );
        if (c) throw new Error("Reducers may not dispatch actions.");
        try {
          (c = !0), (o = i(o, b));
        } finally {
          c = !1;
        }
        for (var C = (a = s), R = 0; R < C.length; R++) C[R]();
        return b;
      }
      function h(b) {
        if (typeof b != "function")
          throw new Error("Expected the nextReducer to be a function.");
        (i = b), y({ type: Zl.INIT });
      }
      function _() {
        var b,
          C = f;
        return (
          (b = {
            subscribe: function (N) {
              if (typeof N != "object")
                throw new TypeError("Expected the observer to be an object.");
              function S() {
                N.next && N.next(g());
              }
              S();
              var G = C(S);
              return { unsubscribe: G };
            },
          }),
          (b[$l.default] = function () {
            return this;
          }),
          b
        );
      }
      return (
        y({ type: Zl.INIT }),
        (n = { dispatch: y, subscribe: f, getState: g, replaceReducer: h }),
        (n[$l.default] = _),
        n
      );
    }
  });
  var Vo = u((Uo) => {
    "use strict";
    Uo.__esModule = !0;
    Uo.default = Nb;
    function Nb(e) {
      typeof console < "u" &&
        typeof console.error == "function" &&
        console.error(e);
      try {
        throw new Error(e);
      } catch {}
    }
  });
  var nf = u((Wo) => {
    "use strict";
    Wo.__esModule = !0;
    Wo.default = Mb;
    var tf = Xo(),
      qb = Do(),
      zB = rf(qb),
      Lb = Vo(),
      YB = rf(Lb);
    function rf(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function Pb(e, t) {
      var r = t && t.type,
        n = (r && '"' + r.toString() + '"') || "an action";
      return (
        "Given action " +
        n +
        ', reducer "' +
        e +
        '" returned undefined. To ignore an action, you must explicitly return the previous state.'
      );
    }
    function Db(e) {
      Object.keys(e).forEach(function (t) {
        var r = e[t],
          n = r(void 0, { type: tf.ActionTypes.INIT });
        if (typeof n > "u")
          throw new Error(
            'Reducer "' +
              t +
              '" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined.'
          );
        var i =
          "@@redux/PROBE_UNKNOWN_ACTION_" +
          Math.random().toString(36).substring(7).split("").join(".");
        if (typeof r(void 0, { type: i }) > "u")
          throw new Error(
            'Reducer "' +
              t +
              '" returned undefined when probed with a random type. ' +
              ("Don't try to handle " +
                tf.ActionTypes.INIT +
                ' or other actions in "redux/*" ') +
              "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined."
          );
      });
    }
    function Mb(e) {
      for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
        var i = t[n];
        typeof e[i] == "function" && (r[i] = e[i]);
      }
      var o = Object.keys(r);
      if (!1) var a;
      var s;
      try {
        Db(r);
      } catch (c) {
        s = c;
      }
      return function () {
        var d =
            arguments.length <= 0 || arguments[0] === void 0
              ? {}
              : arguments[0],
          g = arguments[1];
        if (s) throw s;
        if (!1) var f;
        for (var y = !1, h = {}, _ = 0; _ < o.length; _++) {
          var b = o[_],
            C = r[b],
            R = d[b],
            N = C(R, g);
          if (typeof N > "u") {
            var S = Pb(b, g);
            throw new Error(S);
          }
          (h[b] = N), (y = y || N !== R);
        }
        return y ? h : d;
      };
    }
  });
  var af = u((Bo) => {
    "use strict";
    Bo.__esModule = !0;
    Bo.default = Fb;
    function of(e, t) {
      return function () {
        return t(e.apply(void 0, arguments));
      };
    }
    function Fb(e, t) {
      if (typeof e == "function") return of(e, t);
      if (typeof e != "object" || e === null)
        throw new Error(
          "bindActionCreators expected an object or a function, instead received " +
            (e === null ? "null" : typeof e) +
            '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?'
        );
      for (var r = Object.keys(e), n = {}, i = 0; i < r.length; i++) {
        var o = r[i],
          a = e[o];
        typeof a == "function" && (n[o] = of(a, t));
      }
      return n;
    }
  });
  var ko = u((Ho) => {
    "use strict";
    Ho.__esModule = !0;
    Ho.default = Gb;
    function Gb() {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      if (t.length === 0)
        return function (o) {
          return o;
        };
      if (t.length === 1) return t[0];
      var n = t[t.length - 1],
        i = t.slice(0, -1);
      return function () {
        return i.reduceRight(function (o, a) {
          return a(o);
        }, n.apply(void 0, arguments));
      };
    }
  });
  var sf = u((jo) => {
    "use strict";
    jo.__esModule = !0;
    var Xb =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r)
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      };
    jo.default = Bb;
    var Ub = ko(),
      Vb = Wb(Ub);
    function Wb(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function Bb() {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      return function (n) {
        return function (i, o, a) {
          var s = n(i, o, a),
            c = s.dispatch,
            d = [],
            g = {
              getState: s.getState,
              dispatch: function (y) {
                return c(y);
              },
            };
          return (
            (d = t.map(function (f) {
              return f(g);
            })),
            (c = Vb.default.apply(void 0, d)(s.dispatch)),
            Xb({}, s, { dispatch: c })
          );
        };
      };
    }
  });
  var Ko = u((ke) => {
    "use strict";
    ke.__esModule = !0;
    ke.compose =
      ke.applyMiddleware =
      ke.bindActionCreators =
      ke.combineReducers =
      ke.createStore =
        void 0;
    var Hb = Xo(),
      kb = Jt(Hb),
      jb = nf(),
      Kb = Jt(jb),
      zb = af(),
      Yb = Jt(zb),
      Qb = sf(),
      $b = Jt(Qb),
      Zb = ko(),
      Jb = Jt(Zb),
      eS = Vo(),
      eH = Jt(eS);
    function Jt(e) {
      return e && e.__esModule ? e : { default: e };
    }
    ke.createStore = kb.default;
    ke.combineReducers = Kb.default;
    ke.bindActionCreators = Yb.default;
    ke.applyMiddleware = $b.default;
    ke.compose = Jb.default;
  });
  var uf = u((xe) => {
    "use strict";
    Object.defineProperty(xe, "__esModule", { value: !0 });
    xe.QuickEffectIds =
      xe.QuickEffectDirectionConsts =
      xe.EventTypeConsts =
      xe.EventLimitAffectedElements =
      xe.EventContinuousMouseAxes =
      xe.EventBasedOn =
      xe.EventAppliesTo =
        void 0;
    var tS = {
      NAVBAR_OPEN: "NAVBAR_OPEN",
      NAVBAR_CLOSE: "NAVBAR_CLOSE",
      TAB_ACTIVE: "TAB_ACTIVE",
      TAB_INACTIVE: "TAB_INACTIVE",
      SLIDER_ACTIVE: "SLIDER_ACTIVE",
      SLIDER_INACTIVE: "SLIDER_INACTIVE",
      DROPDOWN_OPEN: "DROPDOWN_OPEN",
      DROPDOWN_CLOSE: "DROPDOWN_CLOSE",
      MOUSE_CLICK: "MOUSE_CLICK",
      MOUSE_SECOND_CLICK: "MOUSE_SECOND_CLICK",
      MOUSE_DOWN: "MOUSE_DOWN",
      MOUSE_UP: "MOUSE_UP",
      MOUSE_OVER: "MOUSE_OVER",
      MOUSE_OUT: "MOUSE_OUT",
      MOUSE_MOVE: "MOUSE_MOVE",
      MOUSE_MOVE_IN_VIEWPORT: "MOUSE_MOVE_IN_VIEWPORT",
      SCROLL_INTO_VIEW: "SCROLL_INTO_VIEW",
      SCROLL_OUT_OF_VIEW: "SCROLL_OUT_OF_VIEW",
      SCROLLING_IN_VIEW: "SCROLLING_IN_VIEW",
      ECOMMERCE_CART_OPEN: "ECOMMERCE_CART_OPEN",
      ECOMMERCE_CART_CLOSE: "ECOMMERCE_CART_CLOSE",
      PAGE_START: "PAGE_START",
      PAGE_FINISH: "PAGE_FINISH",
      PAGE_SCROLL_UP: "PAGE_SCROLL_UP",
      PAGE_SCROLL_DOWN: "PAGE_SCROLL_DOWN",
      PAGE_SCROLL: "PAGE_SCROLL",
    };
    xe.EventTypeConsts = tS;
    var rS = { ELEMENT: "ELEMENT", CLASS: "CLASS", PAGE: "PAGE" };
    xe.EventAppliesTo = rS;
    var nS = { ELEMENT: "ELEMENT", VIEWPORT: "VIEWPORT" };
    xe.EventBasedOn = nS;
    var iS = { X_AXIS: "X_AXIS", Y_AXIS: "Y_AXIS" };
    xe.EventContinuousMouseAxes = iS;
    var oS = {
      CHILDREN: "CHILDREN",
      SIBLINGS: "SIBLINGS",
      IMMEDIATE_CHILDREN: "IMMEDIATE_CHILDREN",
    };
    xe.EventLimitAffectedElements = oS;
    var aS = {
      FADE_EFFECT: "FADE_EFFECT",
      SLIDE_EFFECT: "SLIDE_EFFECT",
      GROW_EFFECT: "GROW_EFFECT",
      SHRINK_EFFECT: "SHRINK_EFFECT",
      SPIN_EFFECT: "SPIN_EFFECT",
      FLY_EFFECT: "FLY_EFFECT",
      POP_EFFECT: "POP_EFFECT",
      FLIP_EFFECT: "FLIP_EFFECT",
      JIGGLE_EFFECT: "JIGGLE_EFFECT",
      PULSE_EFFECT: "PULSE_EFFECT",
      DROP_EFFECT: "DROP_EFFECT",
      BLINK_EFFECT: "BLINK_EFFECT",
      BOUNCE_EFFECT: "BOUNCE_EFFECT",
      FLIP_LEFT_TO_RIGHT_EFFECT: "FLIP_LEFT_TO_RIGHT_EFFECT",
      FLIP_RIGHT_TO_LEFT_EFFECT: "FLIP_RIGHT_TO_LEFT_EFFECT",
      RUBBER_BAND_EFFECT: "RUBBER_BAND_EFFECT",
      JELLO_EFFECT: "JELLO_EFFECT",
      GROW_BIG_EFFECT: "GROW_BIG_EFFECT",
      SHRINK_BIG_EFFECT: "SHRINK_BIG_EFFECT",
      PLUGIN_LOTTIE_EFFECT: "PLUGIN_LOTTIE_EFFECT",
    };
    xe.QuickEffectIds = aS;
    var sS = {
      LEFT: "LEFT",
      RIGHT: "RIGHT",
      BOTTOM: "BOTTOM",
      TOP: "TOP",
      BOTTOM_LEFT: "BOTTOM_LEFT",
      BOTTOM_RIGHT: "BOTTOM_RIGHT",
      TOP_RIGHT: "TOP_RIGHT",
      TOP_LEFT: "TOP_LEFT",
      CLOCKWISE: "CLOCKWISE",
      COUNTER_CLOCKWISE: "COUNTER_CLOCKWISE",
    };
    xe.QuickEffectDirectionConsts = sS;
  });
  var zo = u((er) => {
    "use strict";
    Object.defineProperty(er, "__esModule", { value: !0 });
    er.ActionTypeConsts = er.ActionAppliesTo = void 0;
    var uS = {
      TRANSFORM_MOVE: "TRANSFORM_MOVE",
      TRANSFORM_SCALE: "TRANSFORM_SCALE",
      TRANSFORM_ROTATE: "TRANSFORM_ROTATE",
      TRANSFORM_SKEW: "TRANSFORM_SKEW",
      STYLE_OPACITY: "STYLE_OPACITY",
      STYLE_SIZE: "STYLE_SIZE",
      STYLE_FILTER: "STYLE_FILTER",
      STYLE_FONT_VARIATION: "STYLE_FONT_VARIATION",
      STYLE_BACKGROUND_COLOR: "STYLE_BACKGROUND_COLOR",
      STYLE_BORDER: "STYLE_BORDER",
      STYLE_TEXT_COLOR: "STYLE_TEXT_COLOR",
      PLUGIN_LOTTIE: "PLUGIN_LOTTIE",
      GENERAL_DISPLAY: "GENERAL_DISPLAY",
      GENERAL_START_ACTION: "GENERAL_START_ACTION",
      GENERAL_CONTINUOUS_ACTION: "GENERAL_CONTINUOUS_ACTION",
      GENERAL_COMBO_CLASS: "GENERAL_COMBO_CLASS",
      GENERAL_STOP_ACTION: "GENERAL_STOP_ACTION",
      GENERAL_LOOP: "GENERAL_LOOP",
      STYLE_BOX_SHADOW: "STYLE_BOX_SHADOW",
    };
    er.ActionTypeConsts = uS;
    var cS = {
      ELEMENT: "ELEMENT",
      ELEMENT_CLASS: "ELEMENT_CLASS",
      TRIGGER_ELEMENT: "TRIGGER_ELEMENT",
    };
    er.ActionAppliesTo = cS;
  });
  var cf = u((An) => {
    "use strict";
    Object.defineProperty(An, "__esModule", { value: !0 });
    An.InteractionTypeConsts = void 0;
    var lS = {
      MOUSE_CLICK_INTERACTION: "MOUSE_CLICK_INTERACTION",
      MOUSE_HOVER_INTERACTION: "MOUSE_HOVER_INTERACTION",
      MOUSE_MOVE_INTERACTION: "MOUSE_MOVE_INTERACTION",
      SCROLL_INTO_VIEW_INTERACTION: "SCROLL_INTO_VIEW_INTERACTION",
      SCROLLING_IN_VIEW_INTERACTION: "SCROLLING_IN_VIEW_INTERACTION",
      MOUSE_MOVE_IN_VIEWPORT_INTERACTION: "MOUSE_MOVE_IN_VIEWPORT_INTERACTION",
      PAGE_IS_SCROLLING_INTERACTION: "PAGE_IS_SCROLLING_INTERACTION",
      PAGE_LOAD_INTERACTION: "PAGE_LOAD_INTERACTION",
      PAGE_SCROLLED_INTERACTION: "PAGE_SCROLLED_INTERACTION",
      NAVBAR_INTERACTION: "NAVBAR_INTERACTION",
      DROPDOWN_INTERACTION: "DROPDOWN_INTERACTION",
      ECOMMERCE_CART_INTERACTION: "ECOMMERCE_CART_INTERACTION",
      TAB_INTERACTION: "TAB_INTERACTION",
      SLIDER_INTERACTION: "SLIDER_INTERACTION",
    };
    An.InteractionTypeConsts = lS;
  });
  var lf = u((wn) => {
    "use strict";
    Object.defineProperty(wn, "__esModule", { value: !0 });
    wn.ReducedMotionTypes = void 0;
    var fS = zo(),
      {
        TRANSFORM_MOVE: dS,
        TRANSFORM_SCALE: pS,
        TRANSFORM_ROTATE: vS,
        TRANSFORM_SKEW: hS,
        STYLE_SIZE: gS,
        STYLE_FILTER: ES,
        STYLE_FONT_VARIATION: _S,
      } = fS.ActionTypeConsts,
      yS = {
        [dS]: !0,
        [pS]: !0,
        [vS]: !0,
        [hS]: !0,
        [gS]: !0,
        [ES]: !0,
        [_S]: !0,
      };
    wn.ReducedMotionTypes = yS;
  });
  var ff = u((ue) => {
    "use strict";
    Object.defineProperty(ue, "__esModule", { value: !0 });
    ue.IX2_VIEWPORT_WIDTH_CHANGED =
      ue.IX2_TEST_FRAME_RENDERED =
      ue.IX2_STOP_REQUESTED =
      ue.IX2_SESSION_STOPPED =
      ue.IX2_SESSION_STARTED =
      ue.IX2_SESSION_INITIALIZED =
      ue.IX2_RAW_DATA_IMPORTED =
      ue.IX2_PREVIEW_REQUESTED =
      ue.IX2_PLAYBACK_REQUESTED =
      ue.IX2_PARAMETER_CHANGED =
      ue.IX2_MEDIA_QUERIES_DEFINED =
      ue.IX2_INSTANCE_STARTED =
      ue.IX2_INSTANCE_REMOVED =
      ue.IX2_INSTANCE_ADDED =
      ue.IX2_EVENT_STATE_CHANGED =
      ue.IX2_EVENT_LISTENER_ADDED =
      ue.IX2_ELEMENT_STATE_CHANGED =
      ue.IX2_CLEAR_REQUESTED =
      ue.IX2_ANIMATION_FRAME_CHANGED =
      ue.IX2_ACTION_LIST_PLAYBACK_CHANGED =
        void 0;
    var mS = "IX2_RAW_DATA_IMPORTED";
    ue.IX2_RAW_DATA_IMPORTED = mS;
    var IS = "IX2_SESSION_INITIALIZED";
    ue.IX2_SESSION_INITIALIZED = IS;
    var TS = "IX2_SESSION_STARTED";
    ue.IX2_SESSION_STARTED = TS;
    var OS = "IX2_SESSION_STOPPED";
    ue.IX2_SESSION_STOPPED = OS;
    var bS = "IX2_PREVIEW_REQUESTED";
    ue.IX2_PREVIEW_REQUESTED = bS;
    var SS = "IX2_PLAYBACK_REQUESTED";
    ue.IX2_PLAYBACK_REQUESTED = SS;
    var AS = "IX2_STOP_REQUESTED";
    ue.IX2_STOP_REQUESTED = AS;
    var wS = "IX2_CLEAR_REQUESTED";
    ue.IX2_CLEAR_REQUESTED = wS;
    var RS = "IX2_EVENT_LISTENER_ADDED";
    ue.IX2_EVENT_LISTENER_ADDED = RS;
    var CS = "IX2_EVENT_STATE_CHANGED";
    ue.IX2_EVENT_STATE_CHANGED = CS;
    var xS = "IX2_ANIMATION_FRAME_CHANGED";
    ue.IX2_ANIMATION_FRAME_CHANGED = xS;
    var NS = "IX2_PARAMETER_CHANGED";
    ue.IX2_PARAMETER_CHANGED = NS;
    var qS = "IX2_INSTANCE_ADDED";
    ue.IX2_INSTANCE_ADDED = qS;
    var LS = "IX2_INSTANCE_STARTED";
    ue.IX2_INSTANCE_STARTED = LS;
    var PS = "IX2_INSTANCE_REMOVED";
    ue.IX2_INSTANCE_REMOVED = PS;
    var DS = "IX2_ELEMENT_STATE_CHANGED";
    ue.IX2_ELEMENT_STATE_CHANGED = DS;
    var MS = "IX2_ACTION_LIST_PLAYBACK_CHANGED";
    ue.IX2_ACTION_LIST_PLAYBACK_CHANGED = MS;
    var FS = "IX2_VIEWPORT_WIDTH_CHANGED";
    ue.IX2_VIEWPORT_WIDTH_CHANGED = FS;
    var GS = "IX2_MEDIA_QUERIES_DEFINED";
    ue.IX2_MEDIA_QUERIES_DEFINED = GS;
    var XS = "IX2_TEST_FRAME_RENDERED";
    ue.IX2_TEST_FRAME_RENDERED = XS;
  });
  var df = u((x) => {
    "use strict";
    Object.defineProperty(x, "__esModule", { value: !0 });
    x.W_MOD_JS =
      x.W_MOD_IX =
      x.WILL_CHANGE =
      x.WIDTH =
      x.WF_PAGE =
      x.TRANSLATE_Z =
      x.TRANSLATE_Y =
      x.TRANSLATE_X =
      x.TRANSLATE_3D =
      x.TRANSFORM =
      x.SKEW_Y =
      x.SKEW_X =
      x.SKEW =
      x.SIBLINGS =
      x.SCALE_Z =
      x.SCALE_Y =
      x.SCALE_X =
      x.SCALE_3D =
      x.ROTATE_Z =
      x.ROTATE_Y =
      x.ROTATE_X =
      x.RENDER_TRANSFORM =
      x.RENDER_STYLE =
      x.RENDER_PLUGIN =
      x.RENDER_GENERAL =
      x.PRESERVE_3D =
      x.PLAIN_OBJECT =
      x.PARENT =
      x.OPACITY =
      x.IX2_ID_DELIMITER =
      x.IMMEDIATE_CHILDREN =
      x.HTML_ELEMENT =
      x.HEIGHT =
      x.FONT_VARIATION_SETTINGS =
      x.FLEX =
      x.FILTER =
      x.DISPLAY =
      x.CONFIG_Z_VALUE =
      x.CONFIG_Z_UNIT =
      x.CONFIG_Y_VALUE =
      x.CONFIG_Y_UNIT =
      x.CONFIG_X_VALUE =
      x.CONFIG_X_UNIT =
      x.CONFIG_VALUE =
      x.CONFIG_UNIT =
      x.COMMA_DELIMITER =
      x.COLOR =
      x.COLON_DELIMITER =
      x.CHILDREN =
      x.BOUNDARY_SELECTOR =
      x.BORDER_COLOR =
      x.BAR_DELIMITER =
      x.BACKGROUND_COLOR =
      x.BACKGROUND =
      x.AUTO =
      x.ABSTRACT_NODE =
        void 0;
    var US = "|";
    x.IX2_ID_DELIMITER = US;
    var VS = "data-wf-page";
    x.WF_PAGE = VS;
    var WS = "w-mod-js";
    x.W_MOD_JS = WS;
    var BS = "w-mod-ix";
    x.W_MOD_IX = BS;
    var HS = ".w-dyn-item";
    x.BOUNDARY_SELECTOR = HS;
    var kS = "xValue";
    x.CONFIG_X_VALUE = kS;
    var jS = "yValue";
    x.CONFIG_Y_VALUE = jS;
    var KS = "zValue";
    x.CONFIG_Z_VALUE = KS;
    var zS = "value";
    x.CONFIG_VALUE = zS;
    var YS = "xUnit";
    x.CONFIG_X_UNIT = YS;
    var QS = "yUnit";
    x.CONFIG_Y_UNIT = QS;
    var $S = "zUnit";
    x.CONFIG_Z_UNIT = $S;
    var ZS = "unit";
    x.CONFIG_UNIT = ZS;
    var JS = "transform";
    x.TRANSFORM = JS;
    var eA = "translateX";
    x.TRANSLATE_X = eA;
    var tA = "translateY";
    x.TRANSLATE_Y = tA;
    var rA = "translateZ";
    x.TRANSLATE_Z = rA;
    var nA = "translate3d";
    x.TRANSLATE_3D = nA;
    var iA = "scaleX";
    x.SCALE_X = iA;
    var oA = "scaleY";
    x.SCALE_Y = oA;
    var aA = "scaleZ";
    x.SCALE_Z = aA;
    var sA = "scale3d";
    x.SCALE_3D = sA;
    var uA = "rotateX";
    x.ROTATE_X = uA;
    var cA = "rotateY";
    x.ROTATE_Y = cA;
    var lA = "rotateZ";
    x.ROTATE_Z = lA;
    var fA = "skew";
    x.SKEW = fA;
    var dA = "skewX";
    x.SKEW_X = dA;
    var pA = "skewY";
    x.SKEW_Y = pA;
    var vA = "opacity";
    x.OPACITY = vA;
    var hA = "filter";
    x.FILTER = hA;
    var gA = "font-variation-settings";
    x.FONT_VARIATION_SETTINGS = gA;
    var EA = "width";
    x.WIDTH = EA;
    var _A = "height";
    x.HEIGHT = _A;
    var yA = "backgroundColor";
    x.BACKGROUND_COLOR = yA;
    var mA = "background";
    x.BACKGROUND = mA;
    var IA = "borderColor";
    x.BORDER_COLOR = IA;
    var TA = "color";
    x.COLOR = TA;
    var OA = "display";
    x.DISPLAY = OA;
    var bA = "flex";
    x.FLEX = bA;
    var SA = "willChange";
    x.WILL_CHANGE = SA;
    var AA = "AUTO";
    x.AUTO = AA;
    var wA = ",";
    x.COMMA_DELIMITER = wA;
    var RA = ":";
    x.COLON_DELIMITER = RA;
    var CA = "|";
    x.BAR_DELIMITER = CA;
    var xA = "CHILDREN";
    x.CHILDREN = xA;
    var NA = "IMMEDIATE_CHILDREN";
    x.IMMEDIATE_CHILDREN = NA;
    var qA = "SIBLINGS";
    x.SIBLINGS = qA;
    var LA = "PARENT";
    x.PARENT = LA;
    var PA = "preserve-3d";
    x.PRESERVE_3D = PA;
    var DA = "HTML_ELEMENT";
    x.HTML_ELEMENT = DA;
    var MA = "PLAIN_OBJECT";
    x.PLAIN_OBJECT = MA;
    var FA = "ABSTRACT_NODE";
    x.ABSTRACT_NODE = FA;
    var GA = "RENDER_TRANSFORM";
    x.RENDER_TRANSFORM = GA;
    var XA = "RENDER_GENERAL";
    x.RENDER_GENERAL = XA;
    var UA = "RENDER_STYLE";
    x.RENDER_STYLE = UA;
    var VA = "RENDER_PLUGIN";
    x.RENDER_PLUGIN = VA;
  });
  var We = u((we) => {
    "use strict";
    var pf = Kt().default;
    Object.defineProperty(we, "__esModule", { value: !0 });
    var Rn = { IX2EngineActionTypes: !0, IX2EngineConstants: !0 };
    we.IX2EngineConstants = we.IX2EngineActionTypes = void 0;
    var Yo = uf();
    Object.keys(Yo).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(Rn, e) ||
        (e in we && we[e] === Yo[e]) ||
        Object.defineProperty(we, e, {
          enumerable: !0,
          get: function () {
            return Yo[e];
          },
        });
    });
    var Qo = zo();
    Object.keys(Qo).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(Rn, e) ||
        (e in we && we[e] === Qo[e]) ||
        Object.defineProperty(we, e, {
          enumerable: !0,
          get: function () {
            return Qo[e];
          },
        });
    });
    var $o = cf();
    Object.keys($o).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(Rn, e) ||
        (e in we && we[e] === $o[e]) ||
        Object.defineProperty(we, e, {
          enumerable: !0,
          get: function () {
            return $o[e];
          },
        });
    });
    var Zo = lf();
    Object.keys(Zo).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(Rn, e) ||
        (e in we && we[e] === Zo[e]) ||
        Object.defineProperty(we, e, {
          enumerable: !0,
          get: function () {
            return Zo[e];
          },
        });
    });
    var WA = pf(ff());
    we.IX2EngineActionTypes = WA;
    var BA = pf(df());
    we.IX2EngineConstants = BA;
  });
  var vf = u((Cn) => {
    "use strict";
    Object.defineProperty(Cn, "__esModule", { value: !0 });
    Cn.ixData = void 0;
    var HA = We(),
      { IX2_RAW_DATA_IMPORTED: kA } = HA.IX2EngineActionTypes,
      jA = (e = Object.freeze({}), t) => {
        switch (t.type) {
          case kA:
            return t.payload.ixData || Object.freeze({});
          default:
            return e;
        }
      };
    Cn.ixData = jA;
  });
  var Pr = u((lH, _t) => {
    function Jo() {
      return (
        (_t.exports = Jo =
          Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var r = arguments[t];
                  for (var n in r)
                    Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
              }),
        (_t.exports.__esModule = !0),
        (_t.exports.default = _t.exports),
        Jo.apply(this, arguments)
      );
    }
    (_t.exports = Jo),
      (_t.exports.__esModule = !0),
      (_t.exports.default = _t.exports);
  });
  var tr = u((Te) => {
    "use strict";
    Object.defineProperty(Te, "__esModule", { value: !0 });
    var KA =
      typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              typeof Symbol == "function" &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          };
    Te.clone = Nn;
    Te.addLast = Ef;
    Te.addFirst = _f;
    Te.removeLast = yf;
    Te.removeFirst = mf;
    Te.insert = If;
    Te.removeAt = Tf;
    Te.replaceAt = Of;
    Te.getIn = qn;
    Te.set = Ln;
    Te.setIn = Pn;
    Te.update = Sf;
    Te.updateIn = Af;
    Te.merge = wf;
    Te.mergeDeep = Rf;
    Te.mergeIn = Cf;
    Te.omit = xf;
    Te.addDefaults = Nf;
    var hf = "INVALID_ARGS";
    function gf(e) {
      throw new Error(e);
    }
    function ea(e) {
      var t = Object.keys(e);
      return Object.getOwnPropertySymbols
        ? t.concat(Object.getOwnPropertySymbols(e))
        : t;
    }
    var zA = {}.hasOwnProperty;
    function Nn(e) {
      if (Array.isArray(e)) return e.slice();
      for (var t = ea(e), r = {}, n = 0; n < t.length; n++) {
        var i = t[n];
        r[i] = e[i];
      }
      return r;
    }
    function Be(e, t, r) {
      var n = r;
      n == null && gf(hf);
      for (
        var i = !1, o = arguments.length, a = Array(o > 3 ? o - 3 : 0), s = 3;
        s < o;
        s++
      )
        a[s - 3] = arguments[s];
      for (var c = 0; c < a.length; c++) {
        var d = a[c];
        if (d != null) {
          var g = ea(d);
          if (g.length)
            for (var f = 0; f <= g.length; f++) {
              var y = g[f];
              if (!(e && n[y] !== void 0)) {
                var h = d[y];
                t && xn(n[y]) && xn(h) && (h = Be(e, t, n[y], h)),
                  !(h === void 0 || h === n[y]) &&
                    (i || ((i = !0), (n = Nn(n))), (n[y] = h));
              }
            }
        }
      }
      return n;
    }
    function xn(e) {
      var t = typeof e > "u" ? "undefined" : KA(e);
      return e != null && (t === "object" || t === "function");
    }
    function Ef(e, t) {
      return Array.isArray(t) ? e.concat(t) : e.concat([t]);
    }
    function _f(e, t) {
      return Array.isArray(t) ? t.concat(e) : [t].concat(e);
    }
    function yf(e) {
      return e.length ? e.slice(0, e.length - 1) : e;
    }
    function mf(e) {
      return e.length ? e.slice(1) : e;
    }
    function If(e, t, r) {
      return e
        .slice(0, t)
        .concat(Array.isArray(r) ? r : [r])
        .concat(e.slice(t));
    }
    function Tf(e, t) {
      return t >= e.length || t < 0 ? e : e.slice(0, t).concat(e.slice(t + 1));
    }
    function Of(e, t, r) {
      if (e[t] === r) return e;
      for (var n = e.length, i = Array(n), o = 0; o < n; o++) i[o] = e[o];
      return (i[t] = r), i;
    }
    function qn(e, t) {
      if ((!Array.isArray(t) && gf(hf), e != null)) {
        for (var r = e, n = 0; n < t.length; n++) {
          var i = t[n];
          if (((r = r?.[i]), r === void 0)) return r;
        }
        return r;
      }
    }
    function Ln(e, t, r) {
      var n = typeof t == "number" ? [] : {},
        i = e ?? n;
      if (i[t] === r) return i;
      var o = Nn(i);
      return (o[t] = r), o;
    }
    function bf(e, t, r, n) {
      var i = void 0,
        o = t[n];
      if (n === t.length - 1) i = r;
      else {
        var a =
          xn(e) && xn(e[o]) ? e[o] : typeof t[n + 1] == "number" ? [] : {};
        i = bf(a, t, r, n + 1);
      }
      return Ln(e, o, i);
    }
    function Pn(e, t, r) {
      return t.length ? bf(e, t, r, 0) : r;
    }
    function Sf(e, t, r) {
      var n = e?.[t],
        i = r(n);
      return Ln(e, t, i);
    }
    function Af(e, t, r) {
      var n = qn(e, t),
        i = r(n);
      return Pn(e, t, i);
    }
    function wf(e, t, r, n, i, o) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), c = 6;
        c < a;
        c++
      )
        s[c - 6] = arguments[c];
      return s.length
        ? Be.call.apply(Be, [null, !1, !1, e, t, r, n, i, o].concat(s))
        : Be(!1, !1, e, t, r, n, i, o);
    }
    function Rf(e, t, r, n, i, o) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), c = 6;
        c < a;
        c++
      )
        s[c - 6] = arguments[c];
      return s.length
        ? Be.call.apply(Be, [null, !1, !0, e, t, r, n, i, o].concat(s))
        : Be(!1, !0, e, t, r, n, i, o);
    }
    function Cf(e, t, r, n, i, o, a) {
      var s = qn(e, t);
      s == null && (s = {});
      for (
        var c = void 0,
          d = arguments.length,
          g = Array(d > 7 ? d - 7 : 0),
          f = 7;
        f < d;
        f++
      )
        g[f - 7] = arguments[f];
      return (
        g.length
          ? (c = Be.call.apply(Be, [null, !1, !1, s, r, n, i, o, a].concat(g)))
          : (c = Be(!1, !1, s, r, n, i, o, a)),
        Pn(e, t, c)
      );
    }
    function xf(e, t) {
      for (var r = Array.isArray(t) ? t : [t], n = !1, i = 0; i < r.length; i++)
        if (zA.call(e, r[i])) {
          n = !0;
          break;
        }
      if (!n) return e;
      for (var o = {}, a = ea(e), s = 0; s < a.length; s++) {
        var c = a[s];
        r.indexOf(c) >= 0 || (o[c] = e[c]);
      }
      return o;
    }
    function Nf(e, t, r, n, i, o) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), c = 6;
        c < a;
        c++
      )
        s[c - 6] = arguments[c];
      return s.length
        ? Be.call.apply(Be, [null, !0, !1, e, t, r, n, i, o].concat(s))
        : Be(!0, !1, e, t, r, n, i, o);
    }
    var YA = {
      clone: Nn,
      addLast: Ef,
      addFirst: _f,
      removeLast: yf,
      removeFirst: mf,
      insert: If,
      removeAt: Tf,
      replaceAt: Of,
      getIn: qn,
      set: Ln,
      setIn: Pn,
      update: Sf,
      updateIn: Af,
      merge: wf,
      mergeDeep: Rf,
      mergeIn: Cf,
      omit: xf,
      addDefaults: Nf,
    };
    Te.default = YA;
  });
  var Lf = u((Dn) => {
    "use strict";
    var QA = ut().default;
    Object.defineProperty(Dn, "__esModule", { value: !0 });
    Dn.ixRequest = void 0;
    var $A = QA(Pr()),
      ZA = We(),
      JA = tr(),
      {
        IX2_PREVIEW_REQUESTED: ew,
        IX2_PLAYBACK_REQUESTED: tw,
        IX2_STOP_REQUESTED: rw,
        IX2_CLEAR_REQUESTED: nw,
      } = ZA.IX2EngineActionTypes,
      iw = { preview: {}, playback: {}, stop: {}, clear: {} },
      qf = Object.create(null, {
        [ew]: { value: "preview" },
        [tw]: { value: "playback" },
        [rw]: { value: "stop" },
        [nw]: { value: "clear" },
      }),
      ow = (e = iw, t) => {
        if (t.type in qf) {
          let r = [qf[t.type]];
          return (0, JA.setIn)(e, [r], (0, $A.default)({}, t.payload));
        }
        return e;
      };
    Dn.ixRequest = ow;
  });
  var Df = u((Mn) => {
    "use strict";
    Object.defineProperty(Mn, "__esModule", { value: !0 });
    Mn.ixSession = void 0;
    var aw = We(),
      lt = tr(),
      {
        IX2_SESSION_INITIALIZED: sw,
        IX2_SESSION_STARTED: uw,
        IX2_TEST_FRAME_RENDERED: cw,
        IX2_SESSION_STOPPED: lw,
        IX2_EVENT_LISTENER_ADDED: fw,
        IX2_EVENT_STATE_CHANGED: dw,
        IX2_ANIMATION_FRAME_CHANGED: pw,
        IX2_ACTION_LIST_PLAYBACK_CHANGED: vw,
        IX2_VIEWPORT_WIDTH_CHANGED: hw,
        IX2_MEDIA_QUERIES_DEFINED: gw,
      } = aw.IX2EngineActionTypes,
      Pf = {
        active: !1,
        tick: 0,
        eventListeners: [],
        eventState: {},
        playbackState: {},
        viewportWidth: 0,
        mediaQueryKey: null,
        hasBoundaryNodes: !1,
        hasDefinedMediaQueries: !1,
        reducedMotion: !1,
      },
      Ew = 20,
      _w = (e = Pf, t) => {
        switch (t.type) {
          case sw: {
            let { hasBoundaryNodes: r, reducedMotion: n } = t.payload;
            return (0, lt.merge)(e, { hasBoundaryNodes: r, reducedMotion: n });
          }
          case uw:
            return (0, lt.set)(e, "active", !0);
          case cw: {
            let {
              payload: { step: r = Ew },
            } = t;
            return (0, lt.set)(e, "tick", e.tick + r);
          }
          case lw:
            return Pf;
          case pw: {
            let {
              payload: { now: r },
            } = t;
            return (0, lt.set)(e, "tick", r);
          }
          case fw: {
            let r = (0, lt.addLast)(e.eventListeners, t.payload);
            return (0, lt.set)(e, "eventListeners", r);
          }
          case dw: {
            let { stateKey: r, newState: n } = t.payload;
            return (0, lt.setIn)(e, ["eventState", r], n);
          }
          case vw: {
            let { actionListId: r, isPlaying: n } = t.payload;
            return (0, lt.setIn)(e, ["playbackState", r], n);
          }
          case hw: {
            let { width: r, mediaQueries: n } = t.payload,
              i = n.length,
              o = null;
            for (let a = 0; a < i; a++) {
              let { key: s, min: c, max: d } = n[a];
              if (r >= c && r <= d) {
                o = s;
                break;
              }
            }
            return (0, lt.merge)(e, { viewportWidth: r, mediaQueryKey: o });
          }
          case gw:
            return (0, lt.set)(e, "hasDefinedMediaQueries", !0);
          default:
            return e;
        }
      };
    Mn.ixSession = _w;
  });
  var Ff = u((vH, Mf) => {
    function yw() {
      (this.__data__ = []), (this.size = 0);
    }
    Mf.exports = yw;
  });
  var Fn = u((hH, Gf) => {
    function mw(e, t) {
      return e === t || (e !== e && t !== t);
    }
    Gf.exports = mw;
  });
  var Dr = u((gH, Xf) => {
    var Iw = Fn();
    function Tw(e, t) {
      for (var r = e.length; r--; ) if (Iw(e[r][0], t)) return r;
      return -1;
    }
    Xf.exports = Tw;
  });
  var Vf = u((EH, Uf) => {
    var Ow = Dr(),
      bw = Array.prototype,
      Sw = bw.splice;
    function Aw(e) {
      var t = this.__data__,
        r = Ow(t, e);
      if (r < 0) return !1;
      var n = t.length - 1;
      return r == n ? t.pop() : Sw.call(t, r, 1), --this.size, !0;
    }
    Uf.exports = Aw;
  });
  var Bf = u((_H, Wf) => {
    var ww = Dr();
    function Rw(e) {
      var t = this.__data__,
        r = ww(t, e);
      return r < 0 ? void 0 : t[r][1];
    }
    Wf.exports = Rw;
  });
  var kf = u((yH, Hf) => {
    var Cw = Dr();
    function xw(e) {
      return Cw(this.__data__, e) > -1;
    }
    Hf.exports = xw;
  });
  var Kf = u((mH, jf) => {
    var Nw = Dr();
    function qw(e, t) {
      var r = this.__data__,
        n = Nw(r, e);
      return n < 0 ? (++this.size, r.push([e, t])) : (r[n][1] = t), this;
    }
    jf.exports = qw;
  });
  var Mr = u((IH, zf) => {
    var Lw = Ff(),
      Pw = Vf(),
      Dw = Bf(),
      Mw = kf(),
      Fw = Kf();
    function rr(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    rr.prototype.clear = Lw;
    rr.prototype.delete = Pw;
    rr.prototype.get = Dw;
    rr.prototype.has = Mw;
    rr.prototype.set = Fw;
    zf.exports = rr;
  });
  var Qf = u((TH, Yf) => {
    var Gw = Mr();
    function Xw() {
      (this.__data__ = new Gw()), (this.size = 0);
    }
    Yf.exports = Xw;
  });
  var Zf = u((OH, $f) => {
    function Uw(e) {
      var t = this.__data__,
        r = t.delete(e);
      return (this.size = t.size), r;
    }
    $f.exports = Uw;
  });
  var ed = u((bH, Jf) => {
    function Vw(e) {
      return this.__data__.get(e);
    }
    Jf.exports = Vw;
  });
  var rd = u((SH, td) => {
    function Ww(e) {
      return this.__data__.has(e);
    }
    td.exports = Ww;
  });
  var ft = u((AH, nd) => {
    function Bw(e) {
      var t = typeof e;
      return e != null && (t == "object" || t == "function");
    }
    nd.exports = Bw;
  });
  var ta = u((wH, id) => {
    var Hw = bt(),
      kw = ft(),
      jw = "[object AsyncFunction]",
      Kw = "[object Function]",
      zw = "[object GeneratorFunction]",
      Yw = "[object Proxy]";
    function Qw(e) {
      if (!kw(e)) return !1;
      var t = Hw(e);
      return t == Kw || t == zw || t == jw || t == Yw;
    }
    id.exports = Qw;
  });
  var ad = u((RH, od) => {
    var $w = tt(),
      Zw = $w["__core-js_shared__"];
    od.exports = Zw;
  });
  var cd = u((CH, ud) => {
    var ra = ad(),
      sd = (function () {
        var e = /[^.]+$/.exec((ra && ra.keys && ra.keys.IE_PROTO) || "");
        return e ? "Symbol(src)_1." + e : "";
      })();
    function Jw(e) {
      return !!sd && sd in e;
    }
    ud.exports = Jw;
  });
  var na = u((xH, ld) => {
    var e0 = Function.prototype,
      t0 = e0.toString;
    function r0(e) {
      if (e != null) {
        try {
          return t0.call(e);
        } catch {}
        try {
          return e + "";
        } catch {}
      }
      return "";
    }
    ld.exports = r0;
  });
  var dd = u((NH, fd) => {
    var n0 = ta(),
      i0 = cd(),
      o0 = ft(),
      a0 = na(),
      s0 = /[\\^$.*+?()[\]{}|]/g,
      u0 = /^\[object .+?Constructor\]$/,
      c0 = Function.prototype,
      l0 = Object.prototype,
      f0 = c0.toString,
      d0 = l0.hasOwnProperty,
      p0 = RegExp(
        "^" +
          f0
            .call(d0)
            .replace(s0, "\\$&")
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              "$1.*?"
            ) +
          "$"
      );
    function v0(e) {
      if (!o0(e) || i0(e)) return !1;
      var t = n0(e) ? p0 : u0;
      return t.test(a0(e));
    }
    fd.exports = v0;
  });
  var vd = u((qH, pd) => {
    function h0(e, t) {
      return e?.[t];
    }
    pd.exports = h0;
  });
  var St = u((LH, hd) => {
    var g0 = dd(),
      E0 = vd();
    function _0(e, t) {
      var r = E0(e, t);
      return g0(r) ? r : void 0;
    }
    hd.exports = _0;
  });
  var Gn = u((PH, gd) => {
    var y0 = St(),
      m0 = tt(),
      I0 = y0(m0, "Map");
    gd.exports = I0;
  });
  var Fr = u((DH, Ed) => {
    var T0 = St(),
      O0 = T0(Object, "create");
    Ed.exports = O0;
  });
  var md = u((MH, yd) => {
    var _d = Fr();
    function b0() {
      (this.__data__ = _d ? _d(null) : {}), (this.size = 0);
    }
    yd.exports = b0;
  });
  var Td = u((FH, Id) => {
    function S0(e) {
      var t = this.has(e) && delete this.__data__[e];
      return (this.size -= t ? 1 : 0), t;
    }
    Id.exports = S0;
  });
  var bd = u((GH, Od) => {
    var A0 = Fr(),
      w0 = "__lodash_hash_undefined__",
      R0 = Object.prototype,
      C0 = R0.hasOwnProperty;
    function x0(e) {
      var t = this.__data__;
      if (A0) {
        var r = t[e];
        return r === w0 ? void 0 : r;
      }
      return C0.call(t, e) ? t[e] : void 0;
    }
    Od.exports = x0;
  });
  var Ad = u((XH, Sd) => {
    var N0 = Fr(),
      q0 = Object.prototype,
      L0 = q0.hasOwnProperty;
    function P0(e) {
      var t = this.__data__;
      return N0 ? t[e] !== void 0 : L0.call(t, e);
    }
    Sd.exports = P0;
  });
  var Rd = u((UH, wd) => {
    var D0 = Fr(),
      M0 = "__lodash_hash_undefined__";
    function F0(e, t) {
      var r = this.__data__;
      return (
        (this.size += this.has(e) ? 0 : 1),
        (r[e] = D0 && t === void 0 ? M0 : t),
        this
      );
    }
    wd.exports = F0;
  });
  var xd = u((VH, Cd) => {
    var G0 = md(),
      X0 = Td(),
      U0 = bd(),
      V0 = Ad(),
      W0 = Rd();
    function nr(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    nr.prototype.clear = G0;
    nr.prototype.delete = X0;
    nr.prototype.get = U0;
    nr.prototype.has = V0;
    nr.prototype.set = W0;
    Cd.exports = nr;
  });
  var Ld = u((WH, qd) => {
    var Nd = xd(),
      B0 = Mr(),
      H0 = Gn();
    function k0() {
      (this.size = 0),
        (this.__data__ = {
          hash: new Nd(),
          map: new (H0 || B0)(),
          string: new Nd(),
        });
    }
    qd.exports = k0;
  });
  var Dd = u((BH, Pd) => {
    function j0(e) {
      var t = typeof e;
      return t == "string" || t == "number" || t == "symbol" || t == "boolean"
        ? e !== "__proto__"
        : e === null;
    }
    Pd.exports = j0;
  });
  var Gr = u((HH, Md) => {
    var K0 = Dd();
    function z0(e, t) {
      var r = e.__data__;
      return K0(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
    }
    Md.exports = z0;
  });
  var Gd = u((kH, Fd) => {
    var Y0 = Gr();
    function Q0(e) {
      var t = Y0(this, e).delete(e);
      return (this.size -= t ? 1 : 0), t;
    }
    Fd.exports = Q0;
  });
  var Ud = u((jH, Xd) => {
    var $0 = Gr();
    function Z0(e) {
      return $0(this, e).get(e);
    }
    Xd.exports = Z0;
  });
  var Wd = u((KH, Vd) => {
    var J0 = Gr();
    function eR(e) {
      return J0(this, e).has(e);
    }
    Vd.exports = eR;
  });
  var Hd = u((zH, Bd) => {
    var tR = Gr();
    function rR(e, t) {
      var r = tR(this, e),
        n = r.size;
      return r.set(e, t), (this.size += r.size == n ? 0 : 1), this;
    }
    Bd.exports = rR;
  });
  var Xn = u((YH, kd) => {
    var nR = Ld(),
      iR = Gd(),
      oR = Ud(),
      aR = Wd(),
      sR = Hd();
    function ir(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    ir.prototype.clear = nR;
    ir.prototype.delete = iR;
    ir.prototype.get = oR;
    ir.prototype.has = aR;
    ir.prototype.set = sR;
    kd.exports = ir;
  });
  var Kd = u((QH, jd) => {
    var uR = Mr(),
      cR = Gn(),
      lR = Xn(),
      fR = 200;
    function dR(e, t) {
      var r = this.__data__;
      if (r instanceof uR) {
        var n = r.__data__;
        if (!cR || n.length < fR - 1)
          return n.push([e, t]), (this.size = ++r.size), this;
        r = this.__data__ = new lR(n);
      }
      return r.set(e, t), (this.size = r.size), this;
    }
    jd.exports = dR;
  });
  var ia = u(($H, zd) => {
    var pR = Mr(),
      vR = Qf(),
      hR = Zf(),
      gR = ed(),
      ER = rd(),
      _R = Kd();
    function or(e) {
      var t = (this.__data__ = new pR(e));
      this.size = t.size;
    }
    or.prototype.clear = vR;
    or.prototype.delete = hR;
    or.prototype.get = gR;
    or.prototype.has = ER;
    or.prototype.set = _R;
    zd.exports = or;
  });
  var Qd = u((ZH, Yd) => {
    var yR = "__lodash_hash_undefined__";
    function mR(e) {
      return this.__data__.set(e, yR), this;
    }
    Yd.exports = mR;
  });
  var Zd = u((JH, $d) => {
    function IR(e) {
      return this.__data__.has(e);
    }
    $d.exports = IR;
  });
  var ep = u((e5, Jd) => {
    var TR = Xn(),
      OR = Qd(),
      bR = Zd();
    function Un(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.__data__ = new TR(); ++t < r; ) this.add(e[t]);
    }
    Un.prototype.add = Un.prototype.push = OR;
    Un.prototype.has = bR;
    Jd.exports = Un;
  });
  var rp = u((t5, tp) => {
    function SR(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
        if (t(e[r], r, e)) return !0;
      return !1;
    }
    tp.exports = SR;
  });
  var ip = u((r5, np) => {
    function AR(e, t) {
      return e.has(t);
    }
    np.exports = AR;
  });
  var oa = u((n5, op) => {
    var wR = ep(),
      RR = rp(),
      CR = ip(),
      xR = 1,
      NR = 2;
    function qR(e, t, r, n, i, o) {
      var a = r & xR,
        s = e.length,
        c = t.length;
      if (s != c && !(a && c > s)) return !1;
      var d = o.get(e),
        g = o.get(t);
      if (d && g) return d == t && g == e;
      var f = -1,
        y = !0,
        h = r & NR ? new wR() : void 0;
      for (o.set(e, t), o.set(t, e); ++f < s; ) {
        var _ = e[f],
          b = t[f];
        if (n) var C = a ? n(b, _, f, t, e, o) : n(_, b, f, e, t, o);
        if (C !== void 0) {
          if (C) continue;
          y = !1;
          break;
        }
        if (h) {
          if (
            !RR(t, function (R, N) {
              if (!CR(h, N) && (_ === R || i(_, R, r, n, o))) return h.push(N);
            })
          ) {
            y = !1;
            break;
          }
        } else if (!(_ === b || i(_, b, r, n, o))) {
          y = !1;
          break;
        }
      }
      return o.delete(e), o.delete(t), y;
    }
    op.exports = qR;
  });
  var sp = u((i5, ap) => {
    var LR = tt(),
      PR = LR.Uint8Array;
    ap.exports = PR;
  });
  var cp = u((o5, up) => {
    function DR(e) {
      var t = -1,
        r = Array(e.size);
      return (
        e.forEach(function (n, i) {
          r[++t] = [i, n];
        }),
        r
      );
    }
    up.exports = DR;
  });
  var fp = u((a5, lp) => {
    function MR(e) {
      var t = -1,
        r = Array(e.size);
      return (
        e.forEach(function (n) {
          r[++t] = n;
        }),
        r
      );
    }
    lp.exports = MR;
  });
  var gp = u((s5, hp) => {
    var dp = $t(),
      pp = sp(),
      FR = Fn(),
      GR = oa(),
      XR = cp(),
      UR = fp(),
      VR = 1,
      WR = 2,
      BR = "[object Boolean]",
      HR = "[object Date]",
      kR = "[object Error]",
      jR = "[object Map]",
      KR = "[object Number]",
      zR = "[object RegExp]",
      YR = "[object Set]",
      QR = "[object String]",
      $R = "[object Symbol]",
      ZR = "[object ArrayBuffer]",
      JR = "[object DataView]",
      vp = dp ? dp.prototype : void 0,
      aa = vp ? vp.valueOf : void 0;
    function eC(e, t, r, n, i, o, a) {
      switch (r) {
        case JR:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
            return !1;
          (e = e.buffer), (t = t.buffer);
        case ZR:
          return !(e.byteLength != t.byteLength || !o(new pp(e), new pp(t)));
        case BR:
        case HR:
        case KR:
          return FR(+e, +t);
        case kR:
          return e.name == t.name && e.message == t.message;
        case zR:
        case QR:
          return e == t + "";
        case jR:
          var s = XR;
        case YR:
          var c = n & VR;
          if ((s || (s = UR), e.size != t.size && !c)) return !1;
          var d = a.get(e);
          if (d) return d == t;
          (n |= WR), a.set(e, t);
          var g = GR(s(e), s(t), n, i, o, a);
          return a.delete(e), g;
        case $R:
          if (aa) return aa.call(e) == aa.call(t);
      }
      return !1;
    }
    hp.exports = eC;
  });
  var Vn = u((u5, Ep) => {
    function tC(e, t) {
      for (var r = -1, n = t.length, i = e.length; ++r < n; ) e[i + r] = t[r];
      return e;
    }
    Ep.exports = tC;
  });
  var Ne = u((c5, _p) => {
    var rC = Array.isArray;
    _p.exports = rC;
  });
  var sa = u((l5, yp) => {
    var nC = Vn(),
      iC = Ne();
    function oC(e, t, r) {
      var n = t(e);
      return iC(e) ? n : nC(n, r(e));
    }
    yp.exports = oC;
  });
  var Ip = u((f5, mp) => {
    function aC(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length, i = 0, o = []; ++r < n; ) {
        var a = e[r];
        t(a, r, e) && (o[i++] = a);
      }
      return o;
    }
    mp.exports = aC;
  });
  var ua = u((d5, Tp) => {
    function sC() {
      return [];
    }
    Tp.exports = sC;
  });
  var ca = u((p5, bp) => {
    var uC = Ip(),
      cC = ua(),
      lC = Object.prototype,
      fC = lC.propertyIsEnumerable,
      Op = Object.getOwnPropertySymbols,
      dC = Op
        ? function (e) {
            return e == null
              ? []
              : ((e = Object(e)),
                uC(Op(e), function (t) {
                  return fC.call(e, t);
                }));
          }
        : cC;
    bp.exports = dC;
  });
  var Ap = u((v5, Sp) => {
    function pC(e, t) {
      for (var r = -1, n = Array(e); ++r < e; ) n[r] = t(r);
      return n;
    }
    Sp.exports = pC;
  });
  var Rp = u((h5, wp) => {
    var vC = bt(),
      hC = Et(),
      gC = "[object Arguments]";
    function EC(e) {
      return hC(e) && vC(e) == gC;
    }
    wp.exports = EC;
  });
  var Xr = u((g5, Np) => {
    var Cp = Rp(),
      _C = Et(),
      xp = Object.prototype,
      yC = xp.hasOwnProperty,
      mC = xp.propertyIsEnumerable,
      IC = Cp(
        (function () {
          return arguments;
        })()
      )
        ? Cp
        : function (e) {
            return _C(e) && yC.call(e, "callee") && !mC.call(e, "callee");
          };
    Np.exports = IC;
  });
  var Lp = u((E5, qp) => {
    function TC() {
      return !1;
    }
    qp.exports = TC;
  });
  var Wn = u((Ur, ar) => {
    var OC = tt(),
      bC = Lp(),
      Mp = typeof Ur == "object" && Ur && !Ur.nodeType && Ur,
      Pp = Mp && typeof ar == "object" && ar && !ar.nodeType && ar,
      SC = Pp && Pp.exports === Mp,
      Dp = SC ? OC.Buffer : void 0,
      AC = Dp ? Dp.isBuffer : void 0,
      wC = AC || bC;
    ar.exports = wC;
  });
  var Bn = u((_5, Fp) => {
    var RC = 9007199254740991,
      CC = /^(?:0|[1-9]\d*)$/;
    function xC(e, t) {
      var r = typeof e;
      return (
        (t = t ?? RC),
        !!t &&
          (r == "number" || (r != "symbol" && CC.test(e))) &&
          e > -1 &&
          e % 1 == 0 &&
          e < t
      );
    }
    Fp.exports = xC;
  });
  var Hn = u((y5, Gp) => {
    var NC = 9007199254740991;
    function qC(e) {
      return typeof e == "number" && e > -1 && e % 1 == 0 && e <= NC;
    }
    Gp.exports = qC;
  });
  var Up = u((m5, Xp) => {
    var LC = bt(),
      PC = Hn(),
      DC = Et(),
      MC = "[object Arguments]",
      FC = "[object Array]",
      GC = "[object Boolean]",
      XC = "[object Date]",
      UC = "[object Error]",
      VC = "[object Function]",
      WC = "[object Map]",
      BC = "[object Number]",
      HC = "[object Object]",
      kC = "[object RegExp]",
      jC = "[object Set]",
      KC = "[object String]",
      zC = "[object WeakMap]",
      YC = "[object ArrayBuffer]",
      QC = "[object DataView]",
      $C = "[object Float32Array]",
      ZC = "[object Float64Array]",
      JC = "[object Int8Array]",
      ex = "[object Int16Array]",
      tx = "[object Int32Array]",
      rx = "[object Uint8Array]",
      nx = "[object Uint8ClampedArray]",
      ix = "[object Uint16Array]",
      ox = "[object Uint32Array]",
      ye = {};
    ye[$C] =
      ye[ZC] =
      ye[JC] =
      ye[ex] =
      ye[tx] =
      ye[rx] =
      ye[nx] =
      ye[ix] =
      ye[ox] =
        !0;
    ye[MC] =
      ye[FC] =
      ye[YC] =
      ye[GC] =
      ye[QC] =
      ye[XC] =
      ye[UC] =
      ye[VC] =
      ye[WC] =
      ye[BC] =
      ye[HC] =
      ye[kC] =
      ye[jC] =
      ye[KC] =
      ye[zC] =
        !1;
    function ax(e) {
      return DC(e) && PC(e.length) && !!ye[LC(e)];
    }
    Xp.exports = ax;
  });
  var Wp = u((I5, Vp) => {
    function sx(e) {
      return function (t) {
        return e(t);
      };
    }
    Vp.exports = sx;
  });
  var Hp = u((Vr, sr) => {
    var ux = qo(),
      Bp = typeof Vr == "object" && Vr && !Vr.nodeType && Vr,
      Wr = Bp && typeof sr == "object" && sr && !sr.nodeType && sr,
      cx = Wr && Wr.exports === Bp,
      la = cx && ux.process,
      lx = (function () {
        try {
          var e = Wr && Wr.require && Wr.require("util").types;
          return e || (la && la.binding && la.binding("util"));
        } catch {}
      })();
    sr.exports = lx;
  });
  var kn = u((T5, Kp) => {
    var fx = Up(),
      dx = Wp(),
      kp = Hp(),
      jp = kp && kp.isTypedArray,
      px = jp ? dx(jp) : fx;
    Kp.exports = px;
  });
  var fa = u((O5, zp) => {
    var vx = Ap(),
      hx = Xr(),
      gx = Ne(),
      Ex = Wn(),
      _x = Bn(),
      yx = kn(),
      mx = Object.prototype,
      Ix = mx.hasOwnProperty;
    function Tx(e, t) {
      var r = gx(e),
        n = !r && hx(e),
        i = !r && !n && Ex(e),
        o = !r && !n && !i && yx(e),
        a = r || n || i || o,
        s = a ? vx(e.length, String) : [],
        c = s.length;
      for (var d in e)
        (t || Ix.call(e, d)) &&
          !(
            a &&
            (d == "length" ||
              (i && (d == "offset" || d == "parent")) ||
              (o &&
                (d == "buffer" || d == "byteLength" || d == "byteOffset")) ||
              _x(d, c))
          ) &&
          s.push(d);
      return s;
    }
    zp.exports = Tx;
  });
  var jn = u((b5, Yp) => {
    var Ox = Object.prototype;
    function bx(e) {
      var t = e && e.constructor,
        r = (typeof t == "function" && t.prototype) || Ox;
      return e === r;
    }
    Yp.exports = bx;
  });
  var $p = u((S5, Qp) => {
    var Sx = Lo(),
      Ax = Sx(Object.keys, Object);
    Qp.exports = Ax;
  });
  var Kn = u((A5, Zp) => {
    var wx = jn(),
      Rx = $p(),
      Cx = Object.prototype,
      xx = Cx.hasOwnProperty;
    function Nx(e) {
      if (!wx(e)) return Rx(e);
      var t = [];
      for (var r in Object(e)) xx.call(e, r) && r != "constructor" && t.push(r);
      return t;
    }
    Zp.exports = Nx;
  });
  var Mt = u((w5, Jp) => {
    var qx = ta(),
      Lx = Hn();
    function Px(e) {
      return e != null && Lx(e.length) && !qx(e);
    }
    Jp.exports = Px;
  });
  var Br = u((R5, ev) => {
    var Dx = fa(),
      Mx = Kn(),
      Fx = Mt();
    function Gx(e) {
      return Fx(e) ? Dx(e) : Mx(e);
    }
    ev.exports = Gx;
  });
  var rv = u((C5, tv) => {
    var Xx = sa(),
      Ux = ca(),
      Vx = Br();
    function Wx(e) {
      return Xx(e, Vx, Ux);
    }
    tv.exports = Wx;
  });
  var ov = u((x5, iv) => {
    var nv = rv(),
      Bx = 1,
      Hx = Object.prototype,
      kx = Hx.hasOwnProperty;
    function jx(e, t, r, n, i, o) {
      var a = r & Bx,
        s = nv(e),
        c = s.length,
        d = nv(t),
        g = d.length;
      if (c != g && !a) return !1;
      for (var f = c; f--; ) {
        var y = s[f];
        if (!(a ? y in t : kx.call(t, y))) return !1;
      }
      var h = o.get(e),
        _ = o.get(t);
      if (h && _) return h == t && _ == e;
      var b = !0;
      o.set(e, t), o.set(t, e);
      for (var C = a; ++f < c; ) {
        y = s[f];
        var R = e[y],
          N = t[y];
        if (n) var S = a ? n(N, R, y, t, e, o) : n(R, N, y, e, t, o);
        if (!(S === void 0 ? R === N || i(R, N, r, n, o) : S)) {
          b = !1;
          break;
        }
        C || (C = y == "constructor");
      }
      if (b && !C) {
        var G = e.constructor,
          F = t.constructor;
        G != F &&
          "constructor" in e &&
          "constructor" in t &&
          !(
            typeof G == "function" &&
            G instanceof G &&
            typeof F == "function" &&
            F instanceof F
          ) &&
          (b = !1);
      }
      return o.delete(e), o.delete(t), b;
    }
    iv.exports = jx;
  });
  var sv = u((N5, av) => {
    var Kx = St(),
      zx = tt(),
      Yx = Kx(zx, "DataView");
    av.exports = Yx;
  });
  var cv = u((q5, uv) => {
    var Qx = St(),
      $x = tt(),
      Zx = Qx($x, "Promise");
    uv.exports = Zx;
  });
  var fv = u((L5, lv) => {
    var Jx = St(),
      eN = tt(),
      tN = Jx(eN, "Set");
    lv.exports = tN;
  });
  var da = u((P5, dv) => {
    var rN = St(),
      nN = tt(),
      iN = rN(nN, "WeakMap");
    dv.exports = iN;
  });
  var zn = u((D5, yv) => {
    var pa = sv(),
      va = Gn(),
      ha = cv(),
      ga = fv(),
      Ea = da(),
      _v = bt(),
      ur = na(),
      pv = "[object Map]",
      oN = "[object Object]",
      vv = "[object Promise]",
      hv = "[object Set]",
      gv = "[object WeakMap]",
      Ev = "[object DataView]",
      aN = ur(pa),
      sN = ur(va),
      uN = ur(ha),
      cN = ur(ga),
      lN = ur(Ea),
      Ft = _v;
    ((pa && Ft(new pa(new ArrayBuffer(1))) != Ev) ||
      (va && Ft(new va()) != pv) ||
      (ha && Ft(ha.resolve()) != vv) ||
      (ga && Ft(new ga()) != hv) ||
      (Ea && Ft(new Ea()) != gv)) &&
      (Ft = function (e) {
        var t = _v(e),
          r = t == oN ? e.constructor : void 0,
          n = r ? ur(r) : "";
        if (n)
          switch (n) {
            case aN:
              return Ev;
            case sN:
              return pv;
            case uN:
              return vv;
            case cN:
              return hv;
            case lN:
              return gv;
          }
        return t;
      });
    yv.exports = Ft;
  });
  var wv = u((M5, Av) => {
    var _a = ia(),
      fN = oa(),
      dN = gp(),
      pN = ov(),
      mv = zn(),
      Iv = Ne(),
      Tv = Wn(),
      vN = kn(),
      hN = 1,
      Ov = "[object Arguments]",
      bv = "[object Array]",
      Yn = "[object Object]",
      gN = Object.prototype,
      Sv = gN.hasOwnProperty;
    function EN(e, t, r, n, i, o) {
      var a = Iv(e),
        s = Iv(t),
        c = a ? bv : mv(e),
        d = s ? bv : mv(t);
      (c = c == Ov ? Yn : c), (d = d == Ov ? Yn : d);
      var g = c == Yn,
        f = d == Yn,
        y = c == d;
      if (y && Tv(e)) {
        if (!Tv(t)) return !1;
        (a = !0), (g = !1);
      }
      if (y && !g)
        return (
          o || (o = new _a()),
          a || vN(e) ? fN(e, t, r, n, i, o) : dN(e, t, c, r, n, i, o)
        );
      if (!(r & hN)) {
        var h = g && Sv.call(e, "__wrapped__"),
          _ = f && Sv.call(t, "__wrapped__");
        if (h || _) {
          var b = h ? e.value() : e,
            C = _ ? t.value() : t;
          return o || (o = new _a()), i(b, C, r, n, o);
        }
      }
      return y ? (o || (o = new _a()), pN(e, t, r, n, i, o)) : !1;
    }
    Av.exports = EN;
  });
  var ya = u((F5, xv) => {
    var _N = wv(),
      Rv = Et();
    function Cv(e, t, r, n, i) {
      return e === t
        ? !0
        : e == null || t == null || (!Rv(e) && !Rv(t))
        ? e !== e && t !== t
        : _N(e, t, r, n, Cv, i);
    }
    xv.exports = Cv;
  });
  var qv = u((G5, Nv) => {
    var yN = ia(),
      mN = ya(),
      IN = 1,
      TN = 2;
    function ON(e, t, r, n) {
      var i = r.length,
        o = i,
        a = !n;
      if (e == null) return !o;
      for (e = Object(e); i--; ) {
        var s = r[i];
        if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
      }
      for (; ++i < o; ) {
        s = r[i];
        var c = s[0],
          d = e[c],
          g = s[1];
        if (a && s[2]) {
          if (d === void 0 && !(c in e)) return !1;
        } else {
          var f = new yN();
          if (n) var y = n(d, g, c, e, t, f);
          if (!(y === void 0 ? mN(g, d, IN | TN, n, f) : y)) return !1;
        }
      }
      return !0;
    }
    Nv.exports = ON;
  });
  var ma = u((X5, Lv) => {
    var bN = ft();
    function SN(e) {
      return e === e && !bN(e);
    }
    Lv.exports = SN;
  });
  var Dv = u((U5, Pv) => {
    var AN = ma(),
      wN = Br();
    function RN(e) {
      for (var t = wN(e), r = t.length; r--; ) {
        var n = t[r],
          i = e[n];
        t[r] = [n, i, AN(i)];
      }
      return t;
    }
    Pv.exports = RN;
  });
  var Ia = u((V5, Mv) => {
    function CN(e, t) {
      return function (r) {
        return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
      };
    }
    Mv.exports = CN;
  });
  var Gv = u((W5, Fv) => {
    var xN = qv(),
      NN = Dv(),
      qN = Ia();
    function LN(e) {
      var t = NN(e);
      return t.length == 1 && t[0][2]
        ? qN(t[0][0], t[0][1])
        : function (r) {
            return r === e || xN(r, e, t);
          };
    }
    Fv.exports = LN;
  });
  var Hr = u((B5, Xv) => {
    var PN = bt(),
      DN = Et(),
      MN = "[object Symbol]";
    function FN(e) {
      return typeof e == "symbol" || (DN(e) && PN(e) == MN);
    }
    Xv.exports = FN;
  });
  var Qn = u((H5, Uv) => {
    var GN = Ne(),
      XN = Hr(),
      UN = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      VN = /^\w*$/;
    function WN(e, t) {
      if (GN(e)) return !1;
      var r = typeof e;
      return r == "number" ||
        r == "symbol" ||
        r == "boolean" ||
        e == null ||
        XN(e)
        ? !0
        : VN.test(e) || !UN.test(e) || (t != null && e in Object(t));
    }
    Uv.exports = WN;
  });
  var Bv = u((k5, Wv) => {
    var Vv = Xn(),
      BN = "Expected a function";
    function Ta(e, t) {
      if (typeof e != "function" || (t != null && typeof t != "function"))
        throw new TypeError(BN);
      var r = function () {
        var n = arguments,
          i = t ? t.apply(this, n) : n[0],
          o = r.cache;
        if (o.has(i)) return o.get(i);
        var a = e.apply(this, n);
        return (r.cache = o.set(i, a) || o), a;
      };
      return (r.cache = new (Ta.Cache || Vv)()), r;
    }
    Ta.Cache = Vv;
    Wv.exports = Ta;
  });
  var kv = u((j5, Hv) => {
    var HN = Bv(),
      kN = 500;
    function jN(e) {
      var t = HN(e, function (n) {
          return r.size === kN && r.clear(), n;
        }),
        r = t.cache;
      return t;
    }
    Hv.exports = jN;
  });
  var Kv = u((K5, jv) => {
    var KN = kv(),
      zN =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      YN = /\\(\\)?/g,
      QN = KN(function (e) {
        var t = [];
        return (
          e.charCodeAt(0) === 46 && t.push(""),
          e.replace(zN, function (r, n, i, o) {
            t.push(i ? o.replace(YN, "$1") : n || r);
          }),
          t
        );
      });
    jv.exports = QN;
  });
  var Oa = u((z5, zv) => {
    function $N(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n; )
        i[r] = t(e[r], r, e);
      return i;
    }
    zv.exports = $N;
  });
  var eh = u((Y5, Jv) => {
    var Yv = $t(),
      ZN = Oa(),
      JN = Ne(),
      eq = Hr(),
      tq = 1 / 0,
      Qv = Yv ? Yv.prototype : void 0,
      $v = Qv ? Qv.toString : void 0;
    function Zv(e) {
      if (typeof e == "string") return e;
      if (JN(e)) return ZN(e, Zv) + "";
      if (eq(e)) return $v ? $v.call(e) : "";
      var t = e + "";
      return t == "0" && 1 / e == -tq ? "-0" : t;
    }
    Jv.exports = Zv;
  });
  var rh = u((Q5, th) => {
    var rq = eh();
    function nq(e) {
      return e == null ? "" : rq(e);
    }
    th.exports = nq;
  });
  var kr = u(($5, nh) => {
    var iq = Ne(),
      oq = Qn(),
      aq = Kv(),
      sq = rh();
    function uq(e, t) {
      return iq(e) ? e : oq(e, t) ? [e] : aq(sq(e));
    }
    nh.exports = uq;
  });
  var cr = u((Z5, ih) => {
    var cq = Hr(),
      lq = 1 / 0;
    function fq(e) {
      if (typeof e == "string" || cq(e)) return e;
      var t = e + "";
      return t == "0" && 1 / e == -lq ? "-0" : t;
    }
    ih.exports = fq;
  });
  var $n = u((J5, oh) => {
    var dq = kr(),
      pq = cr();
    function vq(e, t) {
      t = dq(t, e);
      for (var r = 0, n = t.length; e != null && r < n; ) e = e[pq(t[r++])];
      return r && r == n ? e : void 0;
    }
    oh.exports = vq;
  });
  var Zn = u((ek, ah) => {
    var hq = $n();
    function gq(e, t, r) {
      var n = e == null ? void 0 : hq(e, t);
      return n === void 0 ? r : n;
    }
    ah.exports = gq;
  });
  var uh = u((tk, sh) => {
    function Eq(e, t) {
      return e != null && t in Object(e);
    }
    sh.exports = Eq;
  });
  var lh = u((rk, ch) => {
    var _q = kr(),
      yq = Xr(),
      mq = Ne(),
      Iq = Bn(),
      Tq = Hn(),
      Oq = cr();
    function bq(e, t, r) {
      t = _q(t, e);
      for (var n = -1, i = t.length, o = !1; ++n < i; ) {
        var a = Oq(t[n]);
        if (!(o = e != null && r(e, a))) break;
        e = e[a];
      }
      return o || ++n != i
        ? o
        : ((i = e == null ? 0 : e.length),
          !!i && Tq(i) && Iq(a, i) && (mq(e) || yq(e)));
    }
    ch.exports = bq;
  });
  var dh = u((nk, fh) => {
    var Sq = uh(),
      Aq = lh();
    function wq(e, t) {
      return e != null && Aq(e, t, Sq);
    }
    fh.exports = wq;
  });
  var vh = u((ik, ph) => {
    var Rq = ya(),
      Cq = Zn(),
      xq = dh(),
      Nq = Qn(),
      qq = ma(),
      Lq = Ia(),
      Pq = cr(),
      Dq = 1,
      Mq = 2;
    function Fq(e, t) {
      return Nq(e) && qq(t)
        ? Lq(Pq(e), t)
        : function (r) {
            var n = Cq(r, e);
            return n === void 0 && n === t ? xq(r, e) : Rq(t, n, Dq | Mq);
          };
    }
    ph.exports = Fq;
  });
  var Jn = u((ok, hh) => {
    function Gq(e) {
      return e;
    }
    hh.exports = Gq;
  });
  var ba = u((ak, gh) => {
    function Xq(e) {
      return function (t) {
        return t?.[e];
      };
    }
    gh.exports = Xq;
  });
  var _h = u((sk, Eh) => {
    var Uq = $n();
    function Vq(e) {
      return function (t) {
        return Uq(t, e);
      };
    }
    Eh.exports = Vq;
  });
  var mh = u((uk, yh) => {
    var Wq = ba(),
      Bq = _h(),
      Hq = Qn(),
      kq = cr();
    function jq(e) {
      return Hq(e) ? Wq(kq(e)) : Bq(e);
    }
    yh.exports = jq;
  });
  var At = u((ck, Ih) => {
    var Kq = Gv(),
      zq = vh(),
      Yq = Jn(),
      Qq = Ne(),
      $q = mh();
    function Zq(e) {
      return typeof e == "function"
        ? e
        : e == null
        ? Yq
        : typeof e == "object"
        ? Qq(e)
          ? zq(e[0], e[1])
          : Kq(e)
        : $q(e);
    }
    Ih.exports = Zq;
  });
  var Sa = u((lk, Th) => {
    var Jq = At(),
      eL = Mt(),
      tL = Br();
    function rL(e) {
      return function (t, r, n) {
        var i = Object(t);
        if (!eL(t)) {
          var o = Jq(r, 3);
          (t = tL(t)),
            (r = function (s) {
              return o(i[s], s, i);
            });
        }
        var a = e(t, r, n);
        return a > -1 ? i[o ? t[a] : a] : void 0;
      };
    }
    Th.exports = rL;
  });
  var Aa = u((fk, Oh) => {
    function nL(e, t, r, n) {
      for (var i = e.length, o = r + (n ? 1 : -1); n ? o-- : ++o < i; )
        if (t(e[o], o, e)) return o;
      return -1;
    }
    Oh.exports = nL;
  });
  var Sh = u((dk, bh) => {
    var iL = /\s/;
    function oL(e) {
      for (var t = e.length; t-- && iL.test(e.charAt(t)); );
      return t;
    }
    bh.exports = oL;
  });
  var wh = u((pk, Ah) => {
    var aL = Sh(),
      sL = /^\s+/;
    function uL(e) {
      return e && e.slice(0, aL(e) + 1).replace(sL, "");
    }
    Ah.exports = uL;
  });
  var ei = u((vk, xh) => {
    var cL = wh(),
      Rh = ft(),
      lL = Hr(),
      Ch = 0 / 0,
      fL = /^[-+]0x[0-9a-f]+$/i,
      dL = /^0b[01]+$/i,
      pL = /^0o[0-7]+$/i,
      vL = parseInt;
    function hL(e) {
      if (typeof e == "number") return e;
      if (lL(e)) return Ch;
      if (Rh(e)) {
        var t = typeof e.valueOf == "function" ? e.valueOf() : e;
        e = Rh(t) ? t + "" : t;
      }
      if (typeof e != "string") return e === 0 ? e : +e;
      e = cL(e);
      var r = dL.test(e);
      return r || pL.test(e) ? vL(e.slice(2), r ? 2 : 8) : fL.test(e) ? Ch : +e;
    }
    xh.exports = hL;
  });
  var Lh = u((hk, qh) => {
    var gL = ei(),
      Nh = 1 / 0,
      EL = 17976931348623157e292;
    function _L(e) {
      if (!e) return e === 0 ? e : 0;
      if (((e = gL(e)), e === Nh || e === -Nh)) {
        var t = e < 0 ? -1 : 1;
        return t * EL;
      }
      return e === e ? e : 0;
    }
    qh.exports = _L;
  });
  var wa = u((gk, Ph) => {
    var yL = Lh();
    function mL(e) {
      var t = yL(e),
        r = t % 1;
      return t === t ? (r ? t - r : t) : 0;
    }
    Ph.exports = mL;
  });
  var Mh = u((Ek, Dh) => {
    var IL = Aa(),
      TL = At(),
      OL = wa(),
      bL = Math.max;
    function SL(e, t, r) {
      var n = e == null ? 0 : e.length;
      if (!n) return -1;
      var i = r == null ? 0 : OL(r);
      return i < 0 && (i = bL(n + i, 0)), IL(e, TL(t, 3), i);
    }
    Dh.exports = SL;
  });
  var Ra = u((_k, Fh) => {
    var AL = Sa(),
      wL = Mh(),
      RL = AL(wL);
    Fh.exports = RL;
  });
  var ri = u((Fe) => {
    "use strict";
    var CL = ut().default;
    Object.defineProperty(Fe, "__esModule", { value: !0 });
    Fe.withBrowser =
      Fe.TRANSFORM_STYLE_PREFIXED =
      Fe.TRANSFORM_PREFIXED =
      Fe.IS_BROWSER_ENV =
      Fe.FLEX_PREFIXED =
      Fe.ELEMENT_MATCHES =
        void 0;
    var xL = CL(Ra()),
      Xh = typeof window < "u";
    Fe.IS_BROWSER_ENV = Xh;
    var ti = (e, t) => (Xh ? e() : t);
    Fe.withBrowser = ti;
    var NL = ti(() =>
      (0, xL.default)(
        [
          "matches",
          "matchesSelector",
          "mozMatchesSelector",
          "msMatchesSelector",
          "oMatchesSelector",
          "webkitMatchesSelector",
        ],
        (e) => e in Element.prototype
      )
    );
    Fe.ELEMENT_MATCHES = NL;
    var qL = ti(() => {
      let e = document.createElement("i"),
        t = ["flex", "-webkit-flex", "-ms-flexbox", "-moz-box", "-webkit-box"],
        r = "";
      try {
        let { length: n } = t;
        for (let i = 0; i < n; i++) {
          let o = t[i];
          if (((e.style.display = o), e.style.display === o)) return o;
        }
        return r;
      } catch {
        return r;
      }
    }, "flex");
    Fe.FLEX_PREFIXED = qL;
    var Uh = ti(() => {
      let e = document.createElement("i");
      if (e.style.transform == null) {
        let t = ["Webkit", "Moz", "ms"],
          r = "Transform",
          { length: n } = t;
        for (let i = 0; i < n; i++) {
          let o = t[i] + r;
          if (e.style[o] !== void 0) return o;
        }
      }
      return "transform";
    }, "transform");
    Fe.TRANSFORM_PREFIXED = Uh;
    var Gh = Uh.split("transform")[0],
      LL = Gh ? Gh + "TransformStyle" : "transformStyle";
    Fe.TRANSFORM_STYLE_PREFIXED = LL;
  });
  var Ca = u((mk, kh) => {
    var PL = 4,
      DL = 0.001,
      ML = 1e-7,
      FL = 10,
      jr = 11,
      ni = 1 / (jr - 1),
      GL = typeof Float32Array == "function";
    function Vh(e, t) {
      return 1 - 3 * t + 3 * e;
    }
    function Wh(e, t) {
      return 3 * t - 6 * e;
    }
    function Bh(e) {
      return 3 * e;
    }
    function ii(e, t, r) {
      return ((Vh(t, r) * e + Wh(t, r)) * e + Bh(t)) * e;
    }
    function Hh(e, t, r) {
      return 3 * Vh(t, r) * e * e + 2 * Wh(t, r) * e + Bh(t);
    }
    function XL(e, t, r, n, i) {
      var o,
        a,
        s = 0;
      do
        (a = t + (r - t) / 2), (o = ii(a, n, i) - e), o > 0 ? (r = a) : (t = a);
      while (Math.abs(o) > ML && ++s < FL);
      return a;
    }
    function UL(e, t, r, n) {
      for (var i = 0; i < PL; ++i) {
        var o = Hh(t, r, n);
        if (o === 0) return t;
        var a = ii(t, r, n) - e;
        t -= a / o;
      }
      return t;
    }
    kh.exports = function (t, r, n, i) {
      if (!(0 <= t && t <= 1 && 0 <= n && n <= 1))
        throw new Error("bezier x values must be in [0, 1] range");
      var o = GL ? new Float32Array(jr) : new Array(jr);
      if (t !== r || n !== i)
        for (var a = 0; a < jr; ++a) o[a] = ii(a * ni, t, n);
      function s(c) {
        for (var d = 0, g = 1, f = jr - 1; g !== f && o[g] <= c; ++g) d += ni;
        --g;
        var y = (c - o[g]) / (o[g + 1] - o[g]),
          h = d + y * ni,
          _ = Hh(h, t, n);
        return _ >= DL ? UL(c, h, t, n) : _ === 0 ? h : XL(c, d, d + ni, t, n);
      }
      return function (d) {
        return t === r && n === i
          ? d
          : d === 0
          ? 0
          : d === 1
          ? 1
          : ii(s(d), r, i);
      };
    };
  });
  var xa = u((se) => {
    "use strict";
    var VL = ut().default;
    Object.defineProperty(se, "__esModule", { value: !0 });
    se.bounce = OP;
    se.bouncePast = bP;
    se.easeOut = se.easeInOut = se.easeIn = se.ease = void 0;
    se.inBack = vP;
    se.inCirc = lP;
    se.inCubic = YL;
    se.inElastic = EP;
    se.inExpo = sP;
    se.inOutBack = gP;
    se.inOutCirc = dP;
    se.inOutCubic = $L;
    se.inOutElastic = yP;
    se.inOutExpo = cP;
    se.inOutQuad = zL;
    se.inOutQuart = eP;
    se.inOutQuint = nP;
    se.inOutSine = aP;
    se.inQuad = jL;
    se.inQuart = ZL;
    se.inQuint = tP;
    se.inSine = iP;
    se.outBack = hP;
    se.outBounce = pP;
    se.outCirc = fP;
    se.outCubic = QL;
    se.outElastic = _P;
    se.outExpo = uP;
    se.outQuad = KL;
    se.outQuart = JL;
    se.outQuint = rP;
    se.outSine = oP;
    se.swingFrom = IP;
    se.swingFromTo = mP;
    se.swingTo = TP;
    var oi = VL(Ca()),
      yt = 1.70158,
      WL = (0, oi.default)(0.25, 0.1, 0.25, 1);
    se.ease = WL;
    var BL = (0, oi.default)(0.42, 0, 1, 1);
    se.easeIn = BL;
    var HL = (0, oi.default)(0, 0, 0.58, 1);
    se.easeOut = HL;
    var kL = (0, oi.default)(0.42, 0, 0.58, 1);
    se.easeInOut = kL;
    function jL(e) {
      return Math.pow(e, 2);
    }
    function KL(e) {
      return -(Math.pow(e - 1, 2) - 1);
    }
    function zL(e) {
      return (e /= 0.5) < 1 ? 0.5 * Math.pow(e, 2) : -0.5 * ((e -= 2) * e - 2);
    }
    function YL(e) {
      return Math.pow(e, 3);
    }
    function QL(e) {
      return Math.pow(e - 1, 3) + 1;
    }
    function $L(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 3)
        : 0.5 * (Math.pow(e - 2, 3) + 2);
    }
    function ZL(e) {
      return Math.pow(e, 4);
    }
    function JL(e) {
      return -(Math.pow(e - 1, 4) - 1);
    }
    function eP(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 4)
        : -0.5 * ((e -= 2) * Math.pow(e, 3) - 2);
    }
    function tP(e) {
      return Math.pow(e, 5);
    }
    function rP(e) {
      return Math.pow(e - 1, 5) + 1;
    }
    function nP(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 5)
        : 0.5 * (Math.pow(e - 2, 5) + 2);
    }
    function iP(e) {
      return -Math.cos(e * (Math.PI / 2)) + 1;
    }
    function oP(e) {
      return Math.sin(e * (Math.PI / 2));
    }
    function aP(e) {
      return -0.5 * (Math.cos(Math.PI * e) - 1);
    }
    function sP(e) {
      return e === 0 ? 0 : Math.pow(2, 10 * (e - 1));
    }
    function uP(e) {
      return e === 1 ? 1 : -Math.pow(2, -10 * e) + 1;
    }
    function cP(e) {
      return e === 0
        ? 0
        : e === 1
        ? 1
        : (e /= 0.5) < 1
        ? 0.5 * Math.pow(2, 10 * (e - 1))
        : 0.5 * (-Math.pow(2, -10 * --e) + 2);
    }
    function lP(e) {
      return -(Math.sqrt(1 - e * e) - 1);
    }
    function fP(e) {
      return Math.sqrt(1 - Math.pow(e - 1, 2));
    }
    function dP(e) {
      return (e /= 0.5) < 1
        ? -0.5 * (Math.sqrt(1 - e * e) - 1)
        : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
    }
    function pP(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
        ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
        : e < 2.5 / 2.75
        ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
        : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
    }
    function vP(e) {
      let t = yt;
      return e * e * ((t + 1) * e - t);
    }
    function hP(e) {
      let t = yt;
      return (e -= 1) * e * ((t + 1) * e + t) + 1;
    }
    function gP(e) {
      let t = yt;
      return (e /= 0.5) < 1
        ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t))
        : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
    }
    function EP(e) {
      let t = yt,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : e === 1
        ? 1
        : (r || (r = 0.3),
          n < 1
            ? ((n = 1), (t = r / 4))
            : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
          -(
            n *
            Math.pow(2, 10 * (e -= 1)) *
            Math.sin(((e - t) * (2 * Math.PI)) / r)
          ));
    }
    function _P(e) {
      let t = yt,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : e === 1
        ? 1
        : (r || (r = 0.3),
          n < 1
            ? ((n = 1), (t = r / 4))
            : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
          n * Math.pow(2, -10 * e) * Math.sin(((e - t) * (2 * Math.PI)) / r) +
            1);
    }
    function yP(e) {
      let t = yt,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : (e /= 1 / 2) === 2
        ? 1
        : (r || (r = 0.3 * 1.5),
          n < 1
            ? ((n = 1), (t = r / 4))
            : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
          e < 1
            ? -0.5 *
              (n *
                Math.pow(2, 10 * (e -= 1)) *
                Math.sin(((e - t) * (2 * Math.PI)) / r))
            : n *
                Math.pow(2, -10 * (e -= 1)) *
                Math.sin(((e - t) * (2 * Math.PI)) / r) *
                0.5 +
              1);
    }
    function mP(e) {
      let t = yt;
      return (e /= 0.5) < 1
        ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t))
        : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
    }
    function IP(e) {
      let t = yt;
      return e * e * ((t + 1) * e - t);
    }
    function TP(e) {
      let t = yt;
      return (e -= 1) * e * ((t + 1) * e + t) + 1;
    }
    function OP(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
        ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
        : e < 2.5 / 2.75
        ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
        : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
    }
    function bP(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
        ? 2 - (7.5625 * (e -= 1.5 / 2.75) * e + 0.75)
        : e < 2.5 / 2.75
        ? 2 - (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375)
        : 2 - (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375);
    }
  });
  var qa = u((Kr) => {
    "use strict";
    var SP = ut().default,
      AP = Kt().default;
    Object.defineProperty(Kr, "__esModule", { value: !0 });
    Kr.applyEasing = CP;
    Kr.createBezierEasing = RP;
    Kr.optimizeFloat = Na;
    var jh = AP(xa()),
      wP = SP(Ca());
    function Na(e, t = 5, r = 10) {
      let n = Math.pow(r, t),
        i = Number(Math.round(e * n) / n);
      return Math.abs(i) > 1e-4 ? i : 0;
    }
    function RP(e) {
      return (0, wP.default)(...e);
    }
    function CP(e, t, r) {
      return t === 0
        ? 0
        : t === 1
        ? 1
        : Na(r ? (t > 0 ? r(t) : t) : t > 0 && e && jh[e] ? jh[e](t) : t);
    }
  });
  var Qh = u((lr) => {
    "use strict";
    Object.defineProperty(lr, "__esModule", { value: !0 });
    lr.createElementState = Yh;
    lr.ixElements = void 0;
    lr.mergeActionState = La;
    var ai = tr(),
      zh = We(),
      {
        HTML_ELEMENT: Ok,
        PLAIN_OBJECT: xP,
        ABSTRACT_NODE: bk,
        CONFIG_X_VALUE: NP,
        CONFIG_Y_VALUE: qP,
        CONFIG_Z_VALUE: LP,
        CONFIG_VALUE: PP,
        CONFIG_X_UNIT: DP,
        CONFIG_Y_UNIT: MP,
        CONFIG_Z_UNIT: FP,
        CONFIG_UNIT: GP,
      } = zh.IX2EngineConstants,
      {
        IX2_SESSION_STOPPED: XP,
        IX2_INSTANCE_ADDED: UP,
        IX2_ELEMENT_STATE_CHANGED: VP,
      } = zh.IX2EngineActionTypes,
      Kh = {},
      WP = "refState",
      BP = (e = Kh, t = {}) => {
        switch (t.type) {
          case XP:
            return Kh;
          case UP: {
            let {
                elementId: r,
                element: n,
                origin: i,
                actionItem: o,
                refType: a,
              } = t.payload,
              { actionTypeId: s } = o,
              c = e;
            return (
              (0, ai.getIn)(c, [r, n]) !== n && (c = Yh(c, n, a, r, o)),
              La(c, r, s, i, o)
            );
          }
          case VP: {
            let {
              elementId: r,
              actionTypeId: n,
              current: i,
              actionItem: o,
            } = t.payload;
            return La(e, r, n, i, o);
          }
          default:
            return e;
        }
      };
    lr.ixElements = BP;
    function Yh(e, t, r, n, i) {
      let o =
        r === xP ? (0, ai.getIn)(i, ["config", "target", "objectId"]) : null;
      return (0, ai.mergeIn)(e, [n], { id: n, ref: t, refId: o, refType: r });
    }
    function La(e, t, r, n, i) {
      let o = kP(i),
        a = [t, WP, r];
      return (0, ai.mergeIn)(e, a, n, o);
    }
    var HP = [
      [NP, DP],
      [qP, MP],
      [LP, FP],
      [PP, GP],
    ];
    function kP(e) {
      let { config: t } = e;
      return HP.reduce((r, n) => {
        let i = n[0],
          o = n[1],
          a = t[i],
          s = t[o];
        return a != null && s != null && (r[o] = s), r;
      }, {});
    }
  });
  var $h = u((qe) => {
    "use strict";
    Object.defineProperty(qe, "__esModule", { value: !0 });
    qe.renderPlugin =
      qe.getPluginOrigin =
      qe.getPluginDuration =
      qe.getPluginDestination =
      qe.getPluginConfig =
      qe.createPluginInstance =
      qe.clearPlugin =
        void 0;
    var jP = (e) => e.value;
    qe.getPluginConfig = jP;
    var KP = (e, t) => {
      if (t.config.duration !== "auto") return null;
      let r = parseFloat(e.getAttribute("data-duration"));
      return r > 0
        ? r * 1e3
        : parseFloat(e.getAttribute("data-default-duration")) * 1e3;
    };
    qe.getPluginDuration = KP;
    var zP = (e) => e || { value: 0 };
    qe.getPluginOrigin = zP;
    var YP = (e) => ({ value: e.value });
    qe.getPluginDestination = YP;
    var QP = (e) => {
      let t = window.Webflow.require("lottie").createInstance(e);
      return t.stop(), t.setSubframe(!0), t;
    };
    qe.createPluginInstance = QP;
    var $P = (e, t, r) => {
      if (!e) return;
      let n = t[r.actionTypeId].value / 100;
      e.goToFrame(e.frames * n);
    };
    qe.renderPlugin = $P;
    var ZP = (e) => {
      window.Webflow.require("lottie").createInstance(e).stop();
    };
    qe.clearPlugin = ZP;
  });
  var Pa = u((Ce) => {
    "use strict";
    Object.defineProperty(Ce, "__esModule", { value: !0 });
    Ce.getPluginOrigin =
      Ce.getPluginDuration =
      Ce.getPluginDestination =
      Ce.getPluginConfig =
      Ce.createPluginInstance =
      Ce.clearPlugin =
        void 0;
    Ce.isPluginType = tD;
    Ce.renderPlugin = void 0;
    var Gt = $h(),
      Zh = We(),
      JP = ri(),
      eD = {
        [Zh.ActionTypeConsts.PLUGIN_LOTTIE]: {
          getConfig: Gt.getPluginConfig,
          getOrigin: Gt.getPluginOrigin,
          getDuration: Gt.getPluginDuration,
          getDestination: Gt.getPluginDestination,
          createInstance: Gt.createPluginInstance,
          render: Gt.renderPlugin,
          clear: Gt.clearPlugin,
        },
      };
    function tD(e) {
      return e === Zh.ActionTypeConsts.PLUGIN_LOTTIE;
    }
    var Xt = (e) => (t) => {
        if (!JP.IS_BROWSER_ENV) return () => null;
        let r = eD[t];
        if (!r) throw new Error(`IX2 no plugin configured for: ${t}`);
        let n = r[e];
        if (!n) throw new Error(`IX2 invalid plugin method: ${e}`);
        return n;
      },
      rD = Xt("getConfig");
    Ce.getPluginConfig = rD;
    var nD = Xt("getOrigin");
    Ce.getPluginOrigin = nD;
    var iD = Xt("getDuration");
    Ce.getPluginDuration = iD;
    var oD = Xt("getDestination");
    Ce.getPluginDestination = oD;
    var aD = Xt("createInstance");
    Ce.createPluginInstance = aD;
    var sD = Xt("render");
    Ce.renderPlugin = sD;
    var uD = Xt("clear");
    Ce.clearPlugin = uD;
  });
  var eg = u((Rk, Jh) => {
    function cD(e, t) {
      return e == null || e !== e ? t : e;
    }
    Jh.exports = cD;
  });
  var rg = u((Ck, tg) => {
    function lD(e, t, r, n) {
      var i = -1,
        o = e == null ? 0 : e.length;
      for (n && o && (r = e[++i]); ++i < o; ) r = t(r, e[i], i, e);
      return r;
    }
    tg.exports = lD;
  });
  var ig = u((xk, ng) => {
    function fD(e) {
      return function (t, r, n) {
        for (var i = -1, o = Object(t), a = n(t), s = a.length; s--; ) {
          var c = a[e ? s : ++i];
          if (r(o[c], c, o) === !1) break;
        }
        return t;
      };
    }
    ng.exports = fD;
  });
  var ag = u((Nk, og) => {
    var dD = ig(),
      pD = dD();
    og.exports = pD;
  });
  var Da = u((qk, sg) => {
    var vD = ag(),
      hD = Br();
    function gD(e, t) {
      return e && vD(e, t, hD);
    }
    sg.exports = gD;
  });
  var cg = u((Lk, ug) => {
    var ED = Mt();
    function _D(e, t) {
      return function (r, n) {
        if (r == null) return r;
        if (!ED(r)) return e(r, n);
        for (
          var i = r.length, o = t ? i : -1, a = Object(r);
          (t ? o-- : ++o < i) && n(a[o], o, a) !== !1;

        );
        return r;
      };
    }
    ug.exports = _D;
  });
  var Ma = u((Pk, lg) => {
    var yD = Da(),
      mD = cg(),
      ID = mD(yD);
    lg.exports = ID;
  });
  var dg = u((Dk, fg) => {
    function TD(e, t, r, n, i) {
      return (
        i(e, function (o, a, s) {
          r = n ? ((n = !1), o) : t(r, o, a, s);
        }),
        r
      );
    }
    fg.exports = TD;
  });
  var vg = u((Mk, pg) => {
    var OD = rg(),
      bD = Ma(),
      SD = At(),
      AD = dg(),
      wD = Ne();
    function RD(e, t, r) {
      var n = wD(e) ? OD : AD,
        i = arguments.length < 3;
      return n(e, SD(t, 4), r, i, bD);
    }
    pg.exports = RD;
  });
  var gg = u((Fk, hg) => {
    var CD = Aa(),
      xD = At(),
      ND = wa(),
      qD = Math.max,
      LD = Math.min;
    function PD(e, t, r) {
      var n = e == null ? 0 : e.length;
      if (!n) return -1;
      var i = n - 1;
      return (
        r !== void 0 &&
          ((i = ND(r)), (i = r < 0 ? qD(n + i, 0) : LD(i, n - 1))),
        CD(e, xD(t, 3), i, !0)
      );
    }
    hg.exports = PD;
  });
  var _g = u((Gk, Eg) => {
    var DD = Sa(),
      MD = gg(),
      FD = DD(MD);
    Eg.exports = FD;
  });
  var mg = u((si) => {
    "use strict";
    Object.defineProperty(si, "__esModule", { value: !0 });
    si.default = void 0;
    var GD = Object.prototype.hasOwnProperty;
    function yg(e, t) {
      return e === t
        ? e !== 0 || t !== 0 || 1 / e === 1 / t
        : e !== e && t !== t;
    }
    function XD(e, t) {
      if (yg(e, t)) return !0;
      if (
        typeof e != "object" ||
        e === null ||
        typeof t != "object" ||
        t === null
      )
        return !1;
      let r = Object.keys(e),
        n = Object.keys(t);
      if (r.length !== n.length) return !1;
      for (let i = 0; i < r.length; i++)
        if (!GD.call(t, r[i]) || !yg(e[r[i]], t[r[i]])) return !1;
      return !0;
    }
    var UD = XD;
    si.default = UD;
  });
  var Vg = u((_e) => {
    "use strict";
    var li = ut().default;
    Object.defineProperty(_e, "__esModule", { value: !0 });
    _e.cleanupHTMLElement = FM;
    _e.clearAllStyles = MM;
    _e.getActionListProgress = XM;
    _e.getAffectedElements = Wa;
    _e.getComputedStyle = fM;
    _e.getDestinationValues = _M;
    _e.getElementId = sM;
    _e.getInstanceId = oM;
    _e.getInstanceOrigin = vM;
    _e.getItemConfigByKey = void 0;
    _e.getMaxDurationItemIndex = Ug;
    _e.getNamespacedParameterId = WM;
    _e.getRenderType = Fg;
    _e.getStyleProp = yM;
    _e.mediaQueriesEqual = HM;
    _e.observeStore = lM;
    _e.reduceListToGroup = UM;
    _e.reifyState = uM;
    _e.renderHTMLElement = mM;
    Object.defineProperty(_e, "shallowEqual", {
      enumerable: !0,
      get: function () {
        return xg.default;
      },
    });
    _e.shouldAllowMediaQuery = BM;
    _e.shouldNamespaceEventParameter = VM;
    _e.stringifyTarget = kM;
    var wt = li(eg()),
      Ga = li(vg()),
      Fa = li(_g()),
      Ig = tr(),
      Ut = We(),
      xg = li(mg()),
      VD = qa(),
      vt = Pa(),
      Ge = ri(),
      {
        BACKGROUND: WD,
        TRANSFORM: BD,
        TRANSLATE_3D: HD,
        SCALE_3D: kD,
        ROTATE_X: jD,
        ROTATE_Y: KD,
        ROTATE_Z: zD,
        SKEW: YD,
        PRESERVE_3D: QD,
        FLEX: $D,
        OPACITY: ui,
        FILTER: zr,
        FONT_VARIATION_SETTINGS: Yr,
        WIDTH: dt,
        HEIGHT: pt,
        BACKGROUND_COLOR: Ng,
        BORDER_COLOR: ZD,
        COLOR: JD,
        CHILDREN: Tg,
        IMMEDIATE_CHILDREN: eM,
        SIBLINGS: Og,
        PARENT: tM,
        DISPLAY: ci,
        WILL_CHANGE: fr,
        AUTO: Rt,
        COMMA_DELIMITER: Qr,
        COLON_DELIMITER: rM,
        BAR_DELIMITER: bg,
        RENDER_TRANSFORM: qg,
        RENDER_GENERAL: Xa,
        RENDER_STYLE: Ua,
        RENDER_PLUGIN: Lg,
      } = Ut.IX2EngineConstants,
      {
        TRANSFORM_MOVE: dr,
        TRANSFORM_SCALE: pr,
        TRANSFORM_ROTATE: vr,
        TRANSFORM_SKEW: $r,
        STYLE_OPACITY: Pg,
        STYLE_FILTER: Zr,
        STYLE_FONT_VARIATION: Jr,
        STYLE_SIZE: hr,
        STYLE_BACKGROUND_COLOR: gr,
        STYLE_BORDER: Er,
        STYLE_TEXT_COLOR: _r,
        GENERAL_DISPLAY: fi,
      } = Ut.ActionTypeConsts,
      nM = "OBJECT_VALUE",
      Dg = (e) => e.trim(),
      Va = Object.freeze({ [gr]: Ng, [Er]: ZD, [_r]: JD }),
      Mg = Object.freeze({
        [Ge.TRANSFORM_PREFIXED]: BD,
        [Ng]: WD,
        [ui]: ui,
        [zr]: zr,
        [dt]: dt,
        [pt]: pt,
        [Yr]: Yr,
      }),
      Sg = {},
      iM = 1;
    function oM() {
      return "i" + iM++;
    }
    var aM = 1;
    function sM(e, t) {
      for (let r in e) {
        let n = e[r];
        if (n && n.ref === t) return n.id;
      }
      return "e" + aM++;
    }
    function uM({ events: e, actionLists: t, site: r } = {}) {
      let n = (0, Ga.default)(
          e,
          (a, s) => {
            let { eventTypeId: c } = s;
            return a[c] || (a[c] = {}), (a[c][s.id] = s), a;
          },
          {}
        ),
        i = r && r.mediaQueries,
        o = [];
      return (
        i
          ? (o = i.map((a) => a.key))
          : ((i = []), console.warn("IX2 missing mediaQueries in site data")),
        {
          ixData: {
            events: e,
            actionLists: t,
            eventTypeMap: n,
            mediaQueries: i,
            mediaQueryKeys: o,
          },
        }
      );
    }
    var cM = (e, t) => e === t;
    function lM({ store: e, select: t, onChange: r, comparator: n = cM }) {
      let { getState: i, subscribe: o } = e,
        a = o(c),
        s = t(i());
      function c() {
        let d = t(i());
        if (d == null) {
          a();
          return;
        }
        n(d, s) || ((s = d), r(s, e));
      }
      return a;
    }
    function Ag(e) {
      let t = typeof e;
      if (t === "string") return { id: e };
      if (e != null && t === "object") {
        let {
          id: r,
          objectId: n,
          selector: i,
          selectorGuids: o,
          appliesTo: a,
          useEventTarget: s,
        } = e;
        return {
          id: r,
          objectId: n,
          selector: i,
          selectorGuids: o,
          appliesTo: a,
          useEventTarget: s,
        };
      }
      return {};
    }
    function Wa({
      config: e,
      event: t,
      eventTarget: r,
      elementRoot: n,
      elementApi: i,
    }) {
      var o, a, s;
      if (!i) throw new Error("IX2 missing elementApi");
      let { targets: c } = e;
      if (Array.isArray(c) && c.length > 0)
        return c.reduce(
          (M, D) =>
            M.concat(
              Wa({
                config: { target: D },
                event: t,
                eventTarget: r,
                elementRoot: n,
                elementApi: i,
              })
            ),
          []
        );
      let {
          getValidDocument: d,
          getQuerySelector: g,
          queryDocument: f,
          getChildElements: y,
          getSiblingElements: h,
          matchSelector: _,
          elementContains: b,
          isSiblingNode: C,
        } = i,
        { target: R } = e;
      if (!R) return [];
      let {
        id: N,
        objectId: S,
        selector: G,
        selectorGuids: F,
        appliesTo: q,
        useEventTarget: W,
      } = Ag(R);
      if (S) return [Sg[S] || (Sg[S] = {})];
      if (q === Ut.EventAppliesTo.PAGE) {
        let M = d(N);
        return M ? [M] : [];
      }
      let Q =
          ((o =
            t == null ||
            (a = t.action) === null ||
            a === void 0 ||
            (s = a.config) === null ||
            s === void 0
              ? void 0
              : s.affectedElements) !== null && o !== void 0
            ? o
            : {})[N || G] || {},
        ae = !!(Q.id || Q.selector),
        re,
        X,
        I,
        L = t && g(Ag(t.target));
      if (
        (ae
          ? ((re = Q.limitAffectedElements), (X = L), (I = g(Q)))
          : (X = I = g({ id: N, selector: G, selectorGuids: F })),
        t && W)
      ) {
        let M = r && (I || W === !0) ? [r] : f(L);
        if (I) {
          if (W === tM) return f(I).filter((D) => M.some(($) => b(D, $)));
          if (W === Tg) return f(I).filter((D) => M.some(($) => b($, D)));
          if (W === Og) return f(I).filter((D) => M.some(($) => C($, D)));
        }
        return M;
      }
      return X == null || I == null
        ? []
        : Ge.IS_BROWSER_ENV && n
        ? f(I).filter((M) => n.contains(M))
        : re === Tg
        ? f(X, I)
        : re === eM
        ? y(f(X)).filter(_(I))
        : re === Og
        ? h(f(X)).filter(_(I))
        : f(I);
    }
    function fM({ element: e, actionItem: t }) {
      if (!Ge.IS_BROWSER_ENV) return {};
      let { actionTypeId: r } = t;
      switch (r) {
        case hr:
        case gr:
        case Er:
        case _r:
        case fi:
          return window.getComputedStyle(e);
        default:
          return {};
      }
    }
    var wg = /px/,
      dM = (e, t) =>
        t.reduce(
          (r, n) => (r[n.type] == null && (r[n.type] = IM[n.type]), r),
          e || {}
        ),
      pM = (e, t) =>
        t.reduce(
          (r, n) => (
            r[n.type] == null &&
              (r[n.type] = TM[n.type] || n.defaultValue || 0),
            r
          ),
          e || {}
        );
    function vM(e, t = {}, r = {}, n, i) {
      let { getStyle: o } = i,
        { actionTypeId: a } = n;
      if ((0, vt.isPluginType)(a)) return (0, vt.getPluginOrigin)(a)(t[a]);
      switch (n.actionTypeId) {
        case dr:
        case pr:
        case vr:
        case $r:
          return t[n.actionTypeId] || Ba[n.actionTypeId];
        case Zr:
          return dM(t[n.actionTypeId], n.config.filters);
        case Jr:
          return pM(t[n.actionTypeId], n.config.fontVariations);
        case Pg:
          return { value: (0, wt.default)(parseFloat(o(e, ui)), 1) };
        case hr: {
          let s = o(e, dt),
            c = o(e, pt),
            d,
            g;
          return (
            n.config.widthUnit === Rt
              ? (d = wg.test(s) ? parseFloat(s) : parseFloat(r.width))
              : (d = (0, wt.default)(parseFloat(s), parseFloat(r.width))),
            n.config.heightUnit === Rt
              ? (g = wg.test(c) ? parseFloat(c) : parseFloat(r.height))
              : (g = (0, wt.default)(parseFloat(c), parseFloat(r.height))),
            { widthValue: d, heightValue: g }
          );
        }
        case gr:
        case Er:
        case _r:
          return LM({
            element: e,
            actionTypeId: n.actionTypeId,
            computedStyle: r,
            getStyle: o,
          });
        case fi:
          return { value: (0, wt.default)(o(e, ci), r.display) };
        case nM:
          return t[n.actionTypeId] || { value: 0 };
        default:
          return;
      }
    }
    var hM = (e, t) => (t && (e[t.type] = t.value || 0), e),
      gM = (e, t) => (t && (e[t.type] = t.value || 0), e),
      EM = (e, t, r) => {
        if ((0, vt.isPluginType)(e)) return (0, vt.getPluginConfig)(e)(r, t);
        switch (e) {
          case Zr: {
            let n = (0, Fa.default)(r.filters, ({ type: i }) => i === t);
            return n ? n.value : 0;
          }
          case Jr: {
            let n = (0, Fa.default)(r.fontVariations, ({ type: i }) => i === t);
            return n ? n.value : 0;
          }
          default:
            return r[t];
        }
      };
    _e.getItemConfigByKey = EM;
    function _M({ element: e, actionItem: t, elementApi: r }) {
      if ((0, vt.isPluginType)(t.actionTypeId))
        return (0, vt.getPluginDestination)(t.actionTypeId)(t.config);
      switch (t.actionTypeId) {
        case dr:
        case pr:
        case vr:
        case $r: {
          let { xValue: n, yValue: i, zValue: o } = t.config;
          return { xValue: n, yValue: i, zValue: o };
        }
        case hr: {
          let { getStyle: n, setStyle: i, getProperty: o } = r,
            { widthUnit: a, heightUnit: s } = t.config,
            { widthValue: c, heightValue: d } = t.config;
          if (!Ge.IS_BROWSER_ENV) return { widthValue: c, heightValue: d };
          if (a === Rt) {
            let g = n(e, dt);
            i(e, dt, ""), (c = o(e, "offsetWidth")), i(e, dt, g);
          }
          if (s === Rt) {
            let g = n(e, pt);
            i(e, pt, ""), (d = o(e, "offsetHeight")), i(e, pt, g);
          }
          return { widthValue: c, heightValue: d };
        }
        case gr:
        case Er:
        case _r: {
          let { rValue: n, gValue: i, bValue: o, aValue: a } = t.config;
          return { rValue: n, gValue: i, bValue: o, aValue: a };
        }
        case Zr:
          return t.config.filters.reduce(hM, {});
        case Jr:
          return t.config.fontVariations.reduce(gM, {});
        default: {
          let { value: n } = t.config;
          return { value: n };
        }
      }
    }
    function Fg(e) {
      if (/^TRANSFORM_/.test(e)) return qg;
      if (/^STYLE_/.test(e)) return Ua;
      if (/^GENERAL_/.test(e)) return Xa;
      if (/^PLUGIN_/.test(e)) return Lg;
    }
    function yM(e, t) {
      return e === Ua ? t.replace("STYLE_", "").toLowerCase() : null;
    }
    function mM(e, t, r, n, i, o, a, s, c) {
      switch (s) {
        case qg:
          return SM(e, t, r, i, a);
        case Ua:
          return PM(e, t, r, i, o, a);
        case Xa:
          return DM(e, i, a);
        case Lg: {
          let { actionTypeId: d } = i;
          if ((0, vt.isPluginType)(d)) return (0, vt.renderPlugin)(d)(c, t, i);
        }
      }
    }
    var Ba = {
        [dr]: Object.freeze({ xValue: 0, yValue: 0, zValue: 0 }),
        [pr]: Object.freeze({ xValue: 1, yValue: 1, zValue: 1 }),
        [vr]: Object.freeze({ xValue: 0, yValue: 0, zValue: 0 }),
        [$r]: Object.freeze({ xValue: 0, yValue: 0 }),
      },
      IM = Object.freeze({
        blur: 0,
        "hue-rotate": 0,
        invert: 0,
        grayscale: 0,
        saturate: 100,
        sepia: 0,
        contrast: 100,
        brightness: 100,
      }),
      TM = Object.freeze({ wght: 0, opsz: 0, wdth: 0, slnt: 0 }),
      OM = (e, t) => {
        let r = (0, Fa.default)(t.filters, ({ type: n }) => n === e);
        if (r && r.unit) return r.unit;
        switch (e) {
          case "blur":
            return "px";
          case "hue-rotate":
            return "deg";
          default:
            return "%";
        }
      },
      bM = Object.keys(Ba);
    function SM(e, t, r, n, i) {
      let o = bM
          .map((s) => {
            let c = Ba[s],
              {
                xValue: d = c.xValue,
                yValue: g = c.yValue,
                zValue: f = c.zValue,
                xUnit: y = "",
                yUnit: h = "",
                zUnit: _ = "",
              } = t[s] || {};
            switch (s) {
              case dr:
                return `${HD}(${d}${y}, ${g}${h}, ${f}${_})`;
              case pr:
                return `${kD}(${d}${y}, ${g}${h}, ${f}${_})`;
              case vr:
                return `${jD}(${d}${y}) ${KD}(${g}${h}) ${zD}(${f}${_})`;
              case $r:
                return `${YD}(${d}${y}, ${g}${h})`;
              default:
                return "";
            }
          })
          .join(" "),
        { setStyle: a } = i;
      Vt(e, Ge.TRANSFORM_PREFIXED, i),
        a(e, Ge.TRANSFORM_PREFIXED, o),
        RM(n, r) && a(e, Ge.TRANSFORM_STYLE_PREFIXED, QD);
    }
    function AM(e, t, r, n) {
      let i = (0, Ga.default)(t, (a, s, c) => `${a} ${c}(${s}${OM(c, r)})`, ""),
        { setStyle: o } = n;
      Vt(e, zr, n), o(e, zr, i);
    }
    function wM(e, t, r, n) {
      let i = (0, Ga.default)(
          t,
          (a, s, c) => (a.push(`"${c}" ${s}`), a),
          []
        ).join(", "),
        { setStyle: o } = n;
      Vt(e, Yr, n), o(e, Yr, i);
    }
    function RM({ actionTypeId: e }, { xValue: t, yValue: r, zValue: n }) {
      return (
        (e === dr && n !== void 0) ||
        (e === pr && n !== void 0) ||
        (e === vr && (t !== void 0 || r !== void 0))
      );
    }
    var CM = "\\(([^)]+)\\)",
      xM = /^rgb/,
      NM = RegExp(`rgba?${CM}`);
    function qM(e, t) {
      let r = e.exec(t);
      return r ? r[1] : "";
    }
    function LM({
      element: e,
      actionTypeId: t,
      computedStyle: r,
      getStyle: n,
    }) {
      let i = Va[t],
        o = n(e, i),
        a = xM.test(o) ? o : r[i],
        s = qM(NM, a).split(Qr);
      return {
        rValue: (0, wt.default)(parseInt(s[0], 10), 255),
        gValue: (0, wt.default)(parseInt(s[1], 10), 255),
        bValue: (0, wt.default)(parseInt(s[2], 10), 255),
        aValue: (0, wt.default)(parseFloat(s[3]), 1),
      };
    }
    function PM(e, t, r, n, i, o) {
      let { setStyle: a } = o;
      switch (n.actionTypeId) {
        case hr: {
          let { widthUnit: s = "", heightUnit: c = "" } = n.config,
            { widthValue: d, heightValue: g } = r;
          d !== void 0 &&
            (s === Rt && (s = "px"), Vt(e, dt, o), a(e, dt, d + s)),
            g !== void 0 &&
              (c === Rt && (c = "px"), Vt(e, pt, o), a(e, pt, g + c));
          break;
        }
        case Zr: {
          AM(e, r, n.config, o);
          break;
        }
        case Jr: {
          wM(e, r, n.config, o);
          break;
        }
        case gr:
        case Er:
        case _r: {
          let s = Va[n.actionTypeId],
            c = Math.round(r.rValue),
            d = Math.round(r.gValue),
            g = Math.round(r.bValue),
            f = r.aValue;
          Vt(e, s, o),
            a(
              e,
              s,
              f >= 1 ? `rgb(${c},${d},${g})` : `rgba(${c},${d},${g},${f})`
            );
          break;
        }
        default: {
          let { unit: s = "" } = n.config;
          Vt(e, i, o), a(e, i, r.value + s);
          break;
        }
      }
    }
    function DM(e, t, r) {
      let { setStyle: n } = r;
      switch (t.actionTypeId) {
        case fi: {
          let { value: i } = t.config;
          i === $D && Ge.IS_BROWSER_ENV
            ? n(e, ci, Ge.FLEX_PREFIXED)
            : n(e, ci, i);
          return;
        }
      }
    }
    function Vt(e, t, r) {
      if (!Ge.IS_BROWSER_ENV) return;
      let n = Mg[t];
      if (!n) return;
      let { getStyle: i, setStyle: o } = r,
        a = i(e, fr);
      if (!a) {
        o(e, fr, n);
        return;
      }
      let s = a.split(Qr).map(Dg);
      s.indexOf(n) === -1 && o(e, fr, s.concat(n).join(Qr));
    }
    function Gg(e, t, r) {
      if (!Ge.IS_BROWSER_ENV) return;
      let n = Mg[t];
      if (!n) return;
      let { getStyle: i, setStyle: o } = r,
        a = i(e, fr);
      !a ||
        a.indexOf(n) === -1 ||
        o(
          e,
          fr,
          a
            .split(Qr)
            .map(Dg)
            .filter((s) => s !== n)
            .join(Qr)
        );
    }
    function MM({ store: e, elementApi: t }) {
      let { ixData: r } = e.getState(),
        { events: n = {}, actionLists: i = {} } = r;
      Object.keys(n).forEach((o) => {
        let a = n[o],
          { config: s } = a.action,
          { actionListId: c } = s,
          d = i[c];
        d && Rg({ actionList: d, event: a, elementApi: t });
      }),
        Object.keys(i).forEach((o) => {
          Rg({ actionList: i[o], elementApi: t });
        });
    }
    function Rg({ actionList: e = {}, event: t, elementApi: r }) {
      let { actionItemGroups: n, continuousParameterGroups: i } = e;
      n &&
        n.forEach((o) => {
          Cg({ actionGroup: o, event: t, elementApi: r });
        }),
        i &&
          i.forEach((o) => {
            let { continuousActionGroups: a } = o;
            a.forEach((s) => {
              Cg({ actionGroup: s, event: t, elementApi: r });
            });
          });
    }
    function Cg({ actionGroup: e, event: t, elementApi: r }) {
      let { actionItems: n } = e;
      n.forEach(({ actionTypeId: i, config: o }) => {
        let a;
        (0, vt.isPluginType)(i)
          ? (a = (0, vt.clearPlugin)(i))
          : (a = Xg({ effect: GM, actionTypeId: i, elementApi: r })),
          Wa({ config: o, event: t, elementApi: r }).forEach(a);
      });
    }
    function FM(e, t, r) {
      let { setStyle: n, getStyle: i } = r,
        { actionTypeId: o } = t;
      if (o === hr) {
        let { config: a } = t;
        a.widthUnit === Rt && n(e, dt, ""), a.heightUnit === Rt && n(e, pt, "");
      }
      i(e, fr) && Xg({ effect: Gg, actionTypeId: o, elementApi: r })(e);
    }
    var Xg =
      ({ effect: e, actionTypeId: t, elementApi: r }) =>
      (n) => {
        switch (t) {
          case dr:
          case pr:
          case vr:
          case $r:
            e(n, Ge.TRANSFORM_PREFIXED, r);
            break;
          case Zr:
            e(n, zr, r);
            break;
          case Jr:
            e(n, Yr, r);
            break;
          case Pg:
            e(n, ui, r);
            break;
          case hr:
            e(n, dt, r), e(n, pt, r);
            break;
          case gr:
          case Er:
          case _r:
            e(n, Va[t], r);
            break;
          case fi:
            e(n, ci, r);
            break;
        }
      };
    function GM(e, t, r) {
      let { setStyle: n } = r;
      Gg(e, t, r),
        n(e, t, ""),
        t === Ge.TRANSFORM_PREFIXED && n(e, Ge.TRANSFORM_STYLE_PREFIXED, "");
    }
    function Ug(e) {
      let t = 0,
        r = 0;
      return (
        e.forEach((n, i) => {
          let { config: o } = n,
            a = o.delay + o.duration;
          a >= t && ((t = a), (r = i));
        }),
        r
      );
    }
    function XM(e, t) {
      let { actionItemGroups: r, useFirstGroupAsInitialState: n } = e,
        { actionItem: i, verboseTimeElapsed: o = 0 } = t,
        a = 0,
        s = 0;
      return (
        r.forEach((c, d) => {
          if (n && d === 0) return;
          let { actionItems: g } = c,
            f = g[Ug(g)],
            { config: y, actionTypeId: h } = f;
          i.id === f.id && (s = a + o);
          let _ = Fg(h) === Xa ? 0 : y.duration;
          a += y.delay + _;
        }),
        a > 0 ? (0, VD.optimizeFloat)(s / a) : 0
      );
    }
    function UM({ actionList: e, actionItemId: t, rawData: r }) {
      let { actionItemGroups: n, continuousParameterGroups: i } = e,
        o = [],
        a = (s) => (
          o.push((0, Ig.mergeIn)(s, ["config"], { delay: 0, duration: 0 })),
          s.id === t
        );
      return (
        n && n.some(({ actionItems: s }) => s.some(a)),
        i &&
          i.some((s) => {
            let { continuousActionGroups: c } = s;
            return c.some(({ actionItems: d }) => d.some(a));
          }),
        (0, Ig.setIn)(r, ["actionLists"], {
          [e.id]: { id: e.id, actionItemGroups: [{ actionItems: o }] },
        })
      );
    }
    function VM(e, { basedOn: t }) {
      return (
        (e === Ut.EventTypeConsts.SCROLLING_IN_VIEW &&
          (t === Ut.EventBasedOn.ELEMENT || t == null)) ||
        (e === Ut.EventTypeConsts.MOUSE_MOVE && t === Ut.EventBasedOn.ELEMENT)
      );
    }
    function WM(e, t) {
      return e + rM + t;
    }
    function BM(e, t) {
      return t == null ? !0 : e.indexOf(t) !== -1;
    }
    function HM(e, t) {
      return (0, xg.default)(e && e.sort(), t && t.sort());
    }
    function kM(e) {
      if (typeof e == "string") return e;
      let { id: t = "", selector: r = "", useEventTarget: n = "" } = e;
      return t + bg + r + bg + n;
    }
  });
  var Wt = u((Xe) => {
    "use strict";
    var yr = Kt().default;
    Object.defineProperty(Xe, "__esModule", { value: !0 });
    Xe.IX2VanillaUtils =
      Xe.IX2VanillaPlugins =
      Xe.IX2ElementsReducer =
      Xe.IX2Easings =
      Xe.IX2EasingUtils =
      Xe.IX2BrowserSupport =
        void 0;
    var jM = yr(ri());
    Xe.IX2BrowserSupport = jM;
    var KM = yr(xa());
    Xe.IX2Easings = KM;
    var zM = yr(qa());
    Xe.IX2EasingUtils = zM;
    var YM = yr(Qh());
    Xe.IX2ElementsReducer = YM;
    var QM = yr(Pa());
    Xe.IX2VanillaPlugins = QM;
    var $M = yr(Vg());
    Xe.IX2VanillaUtils = $M;
  });
  var kg = u((pi) => {
    "use strict";
    Object.defineProperty(pi, "__esModule", { value: !0 });
    pi.ixInstances = void 0;
    var Wg = We(),
      Bg = Wt(),
      mr = tr(),
      {
        IX2_RAW_DATA_IMPORTED: ZM,
        IX2_SESSION_STOPPED: JM,
        IX2_INSTANCE_ADDED: e1,
        IX2_INSTANCE_STARTED: t1,
        IX2_INSTANCE_REMOVED: r1,
        IX2_ANIMATION_FRAME_CHANGED: n1,
      } = Wg.IX2EngineActionTypes,
      {
        optimizeFloat: di,
        applyEasing: Hg,
        createBezierEasing: i1,
      } = Bg.IX2EasingUtils,
      { RENDER_GENERAL: o1 } = Wg.IX2EngineConstants,
      {
        getItemConfigByKey: Ha,
        getRenderType: a1,
        getStyleProp: s1,
      } = Bg.IX2VanillaUtils,
      u1 = (e, t) => {
        let {
            position: r,
            parameterId: n,
            actionGroups: i,
            destinationKeys: o,
            smoothing: a,
            restingValue: s,
            actionTypeId: c,
            customEasingFn: d,
            skipMotion: g,
            skipToValue: f,
          } = e,
          { parameters: y } = t.payload,
          h = Math.max(1 - a, 0.01),
          _ = y[n];
        _ == null && ((h = 1), (_ = s));
        let b = Math.max(_, 0) || 0,
          C = di(b - r),
          R = g ? f : di(r + C * h),
          N = R * 100;
        if (R === r && e.current) return e;
        let S, G, F, q;
        for (let j = 0, { length: Q } = i; j < Q; j++) {
          let { keyframe: ae, actionItems: re } = i[j];
          if ((j === 0 && (S = re[0]), N >= ae)) {
            S = re[0];
            let X = i[j + 1],
              I = X && N !== ae;
            (G = I ? X.actionItems[0] : null),
              I && ((F = ae / 100), (q = (X.keyframe - ae) / 100));
          }
        }
        let W = {};
        if (S && !G)
          for (let j = 0, { length: Q } = o; j < Q; j++) {
            let ae = o[j];
            W[ae] = Ha(c, ae, S.config);
          }
        else if (S && G && F !== void 0 && q !== void 0) {
          let j = (R - F) / q,
            Q = S.config.easing,
            ae = Hg(Q, j, d);
          for (let re = 0, { length: X } = o; re < X; re++) {
            let I = o[re],
              L = Ha(c, I, S.config),
              $ = (Ha(c, I, G.config) - L) * ae + L;
            W[I] = $;
          }
        }
        return (0, mr.merge)(e, { position: R, current: W });
      },
      c1 = (e, t) => {
        let {
            active: r,
            origin: n,
            start: i,
            immediate: o,
            renderType: a,
            verbose: s,
            actionItem: c,
            destination: d,
            destinationKeys: g,
            pluginDuration: f,
            instanceDelay: y,
            customEasingFn: h,
            skipMotion: _,
          } = e,
          b = c.config.easing,
          { duration: C, delay: R } = c.config;
        f != null && (C = f),
          (R = y ?? R),
          a === o1 ? (C = 0) : (o || _) && (C = R = 0);
        let { now: N } = t.payload;
        if (r && n) {
          let S = N - (i + R);
          if (s) {
            let j = N - i,
              Q = C + R,
              ae = di(Math.min(Math.max(0, j / Q), 1));
            e = (0, mr.set)(e, "verboseTimeElapsed", Q * ae);
          }
          if (S < 0) return e;
          let G = di(Math.min(Math.max(0, S / C), 1)),
            F = Hg(b, G, h),
            q = {},
            W = null;
          return (
            g.length &&
              (W = g.reduce((j, Q) => {
                let ae = d[Q],
                  re = parseFloat(n[Q]) || 0,
                  I = (parseFloat(ae) - re) * F + re;
                return (j[Q] = I), j;
              }, {})),
            (q.current = W),
            (q.position = G),
            G === 1 && ((q.active = !1), (q.complete = !0)),
            (0, mr.merge)(e, q)
          );
        }
        return e;
      },
      l1 = (e = Object.freeze({}), t) => {
        switch (t.type) {
          case ZM:
            return t.payload.ixInstances || Object.freeze({});
          case JM:
            return Object.freeze({});
          case e1: {
            let {
                instanceId: r,
                elementId: n,
                actionItem: i,
                eventId: o,
                eventTarget: a,
                eventStateKey: s,
                actionListId: c,
                groupIndex: d,
                isCarrier: g,
                origin: f,
                destination: y,
                immediate: h,
                verbose: _,
                continuous: b,
                parameterId: C,
                actionGroups: R,
                smoothing: N,
                restingValue: S,
                pluginInstance: G,
                pluginDuration: F,
                instanceDelay: q,
                skipMotion: W,
                skipToValue: j,
              } = t.payload,
              { actionTypeId: Q } = i,
              ae = a1(Q),
              re = s1(ae, Q),
              X = Object.keys(y).filter((L) => y[L] != null),
              { easing: I } = i.config;
            return (0, mr.set)(e, r, {
              id: r,
              elementId: n,
              active: !1,
              position: 0,
              start: 0,
              origin: f,
              destination: y,
              destinationKeys: X,
              immediate: h,
              verbose: _,
              current: null,
              actionItem: i,
              actionTypeId: Q,
              eventId: o,
              eventTarget: a,
              eventStateKey: s,
              actionListId: c,
              groupIndex: d,
              renderType: ae,
              isCarrier: g,
              styleProp: re,
              continuous: b,
              parameterId: C,
              actionGroups: R,
              smoothing: N,
              restingValue: S,
              pluginInstance: G,
              pluginDuration: F,
              instanceDelay: q,
              skipMotion: W,
              skipToValue: j,
              customEasingFn:
                Array.isArray(I) && I.length === 4 ? i1(I) : void 0,
            });
          }
          case t1: {
            let { instanceId: r, time: n } = t.payload;
            return (0, mr.mergeIn)(e, [r], {
              active: !0,
              complete: !1,
              start: n,
            });
          }
          case r1: {
            let { instanceId: r } = t.payload;
            if (!e[r]) return e;
            let n = {},
              i = Object.keys(e),
              { length: o } = i;
            for (let a = 0; a < o; a++) {
              let s = i[a];
              s !== r && (n[s] = e[s]);
            }
            return n;
          }
          case n1: {
            let r = e,
              n = Object.keys(e),
              { length: i } = n;
            for (let o = 0; o < i; o++) {
              let a = n[o],
                s = e[a],
                c = s.continuous ? u1 : c1;
              r = (0, mr.set)(r, a, c(s, t));
            }
            return r;
          }
          default:
            return e;
        }
      };
    pi.ixInstances = l1;
  });
  var jg = u((vi) => {
    "use strict";
    Object.defineProperty(vi, "__esModule", { value: !0 });
    vi.ixParameters = void 0;
    var f1 = We(),
      {
        IX2_RAW_DATA_IMPORTED: d1,
        IX2_SESSION_STOPPED: p1,
        IX2_PARAMETER_CHANGED: v1,
      } = f1.IX2EngineActionTypes,
      h1 = (e = {}, t) => {
        switch (t.type) {
          case d1:
            return t.payload.ixParameters || {};
          case p1:
            return {};
          case v1: {
            let { key: r, value: n } = t.payload;
            return (e[r] = n), e;
          }
          default:
            return e;
        }
      };
    vi.ixParameters = h1;
  });
  var Kg = u((hi) => {
    "use strict";
    Object.defineProperty(hi, "__esModule", { value: !0 });
    hi.default = void 0;
    var g1 = Ko(),
      E1 = vf(),
      _1 = Lf(),
      y1 = Df(),
      m1 = Wt(),
      I1 = kg(),
      T1 = jg(),
      { ixElements: O1 } = m1.IX2ElementsReducer,
      b1 = (0, g1.combineReducers)({
        ixData: E1.ixData,
        ixRequest: _1.ixRequest,
        ixSession: y1.ixSession,
        ixElements: O1,
        ixInstances: I1.ixInstances,
        ixParameters: T1.ixParameters,
      });
    hi.default = b1;
  });
  var zg = u((kk, en) => {
    function S1(e, t) {
      if (e == null) return {};
      var r = {},
        n = Object.keys(e),
        i,
        o;
      for (o = 0; o < n.length; o++)
        (i = n[o]), !(t.indexOf(i) >= 0) && (r[i] = e[i]);
      return r;
    }
    (en.exports = S1),
      (en.exports.__esModule = !0),
      (en.exports.default = en.exports);
  });
  var Qg = u((jk, Yg) => {
    var A1 = bt(),
      w1 = Ne(),
      R1 = Et(),
      C1 = "[object String]";
    function x1(e) {
      return typeof e == "string" || (!w1(e) && R1(e) && A1(e) == C1);
    }
    Yg.exports = x1;
  });
  var Zg = u((Kk, $g) => {
    var N1 = ba(),
      q1 = N1("length");
    $g.exports = q1;
  });
  var eE = u((zk, Jg) => {
    var L1 = "\\ud800-\\udfff",
      P1 = "\\u0300-\\u036f",
      D1 = "\\ufe20-\\ufe2f",
      M1 = "\\u20d0-\\u20ff",
      F1 = P1 + D1 + M1,
      G1 = "\\ufe0e\\ufe0f",
      X1 = "\\u200d",
      U1 = RegExp("[" + X1 + L1 + F1 + G1 + "]");
    function V1(e) {
      return U1.test(e);
    }
    Jg.exports = V1;
  });
  var cE = u((Yk, uE) => {
    var rE = "\\ud800-\\udfff",
      W1 = "\\u0300-\\u036f",
      B1 = "\\ufe20-\\ufe2f",
      H1 = "\\u20d0-\\u20ff",
      k1 = W1 + B1 + H1,
      j1 = "\\ufe0e\\ufe0f",
      K1 = "[" + rE + "]",
      ka = "[" + k1 + "]",
      ja = "\\ud83c[\\udffb-\\udfff]",
      z1 = "(?:" + ka + "|" + ja + ")",
      nE = "[^" + rE + "]",
      iE = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      oE = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      Y1 = "\\u200d",
      aE = z1 + "?",
      sE = "[" + j1 + "]?",
      Q1 = "(?:" + Y1 + "(?:" + [nE, iE, oE].join("|") + ")" + sE + aE + ")*",
      $1 = sE + aE + Q1,
      Z1 = "(?:" + [nE + ka + "?", ka, iE, oE, K1].join("|") + ")",
      tE = RegExp(ja + "(?=" + ja + ")|" + Z1 + $1, "g");
    function J1(e) {
      for (var t = (tE.lastIndex = 0); tE.test(e); ) ++t;
      return t;
    }
    uE.exports = J1;
  });
  var fE = u((Qk, lE) => {
    var eF = Zg(),
      tF = eE(),
      rF = cE();
    function nF(e) {
      return tF(e) ? rF(e) : eF(e);
    }
    lE.exports = nF;
  });
  var pE = u(($k, dE) => {
    var iF = Kn(),
      oF = zn(),
      aF = Mt(),
      sF = Qg(),
      uF = fE(),
      cF = "[object Map]",
      lF = "[object Set]";
    function fF(e) {
      if (e == null) return 0;
      if (aF(e)) return sF(e) ? uF(e) : e.length;
      var t = oF(e);
      return t == cF || t == lF ? e.size : iF(e).length;
    }
    dE.exports = fF;
  });
  var hE = u((Zk, vE) => {
    var dF = "Expected a function";
    function pF(e) {
      if (typeof e != "function") throw new TypeError(dF);
      return function () {
        var t = arguments;
        switch (t.length) {
          case 0:
            return !e.call(this);
          case 1:
            return !e.call(this, t[0]);
          case 2:
            return !e.call(this, t[0], t[1]);
          case 3:
            return !e.call(this, t[0], t[1], t[2]);
        }
        return !e.apply(this, t);
      };
    }
    vE.exports = pF;
  });
  var Ka = u((Jk, gE) => {
    var vF = St(),
      hF = (function () {
        try {
          var e = vF(Object, "defineProperty");
          return e({}, "", {}), e;
        } catch {}
      })();
    gE.exports = hF;
  });
  var za = u((ej, _E) => {
    var EE = Ka();
    function gF(e, t, r) {
      t == "__proto__" && EE
        ? EE(e, t, { configurable: !0, enumerable: !0, value: r, writable: !0 })
        : (e[t] = r);
    }
    _E.exports = gF;
  });
  var mE = u((tj, yE) => {
    var EF = za(),
      _F = Fn(),
      yF = Object.prototype,
      mF = yF.hasOwnProperty;
    function IF(e, t, r) {
      var n = e[t];
      (!(mF.call(e, t) && _F(n, r)) || (r === void 0 && !(t in e))) &&
        EF(e, t, r);
    }
    yE.exports = IF;
  });
  var OE = u((rj, TE) => {
    var TF = mE(),
      OF = kr(),
      bF = Bn(),
      IE = ft(),
      SF = cr();
    function AF(e, t, r, n) {
      if (!IE(e)) return e;
      t = OF(t, e);
      for (var i = -1, o = t.length, a = o - 1, s = e; s != null && ++i < o; ) {
        var c = SF(t[i]),
          d = r;
        if (c === "__proto__" || c === "constructor" || c === "prototype")
          return e;
        if (i != a) {
          var g = s[c];
          (d = n ? n(g, c, s) : void 0),
            d === void 0 && (d = IE(g) ? g : bF(t[i + 1]) ? [] : {});
        }
        TF(s, c, d), (s = s[c]);
      }
      return e;
    }
    TE.exports = AF;
  });
  var SE = u((nj, bE) => {
    var wF = $n(),
      RF = OE(),
      CF = kr();
    function xF(e, t, r) {
      for (var n = -1, i = t.length, o = {}; ++n < i; ) {
        var a = t[n],
          s = wF(e, a);
        r(s, a) && RF(o, CF(a, e), s);
      }
      return o;
    }
    bE.exports = xF;
  });
  var wE = u((ij, AE) => {
    var NF = Vn(),
      qF = Po(),
      LF = ca(),
      PF = ua(),
      DF = Object.getOwnPropertySymbols,
      MF = DF
        ? function (e) {
            for (var t = []; e; ) NF(t, LF(e)), (e = qF(e));
            return t;
          }
        : PF;
    AE.exports = MF;
  });
  var CE = u((oj, RE) => {
    function FF(e) {
      var t = [];
      if (e != null) for (var r in Object(e)) t.push(r);
      return t;
    }
    RE.exports = FF;
  });
  var NE = u((aj, xE) => {
    var GF = ft(),
      XF = jn(),
      UF = CE(),
      VF = Object.prototype,
      WF = VF.hasOwnProperty;
    function BF(e) {
      if (!GF(e)) return UF(e);
      var t = XF(e),
        r = [];
      for (var n in e)
        (n == "constructor" && (t || !WF.call(e, n))) || r.push(n);
      return r;
    }
    xE.exports = BF;
  });
  var LE = u((sj, qE) => {
    var HF = fa(),
      kF = NE(),
      jF = Mt();
    function KF(e) {
      return jF(e) ? HF(e, !0) : kF(e);
    }
    qE.exports = KF;
  });
  var DE = u((uj, PE) => {
    var zF = sa(),
      YF = wE(),
      QF = LE();
    function $F(e) {
      return zF(e, QF, YF);
    }
    PE.exports = $F;
  });
  var FE = u((cj, ME) => {
    var ZF = Oa(),
      JF = At(),
      e2 = SE(),
      t2 = DE();
    function r2(e, t) {
      if (e == null) return {};
      var r = ZF(t2(e), function (n) {
        return [n];
      });
      return (
        (t = JF(t)),
        e2(e, r, function (n, i) {
          return t(n, i[0]);
        })
      );
    }
    ME.exports = r2;
  });
  var XE = u((lj, GE) => {
    var n2 = At(),
      i2 = hE(),
      o2 = FE();
    function a2(e, t) {
      return o2(e, i2(n2(t)));
    }
    GE.exports = a2;
  });
  var VE = u((fj, UE) => {
    var s2 = Kn(),
      u2 = zn(),
      c2 = Xr(),
      l2 = Ne(),
      f2 = Mt(),
      d2 = Wn(),
      p2 = jn(),
      v2 = kn(),
      h2 = "[object Map]",
      g2 = "[object Set]",
      E2 = Object.prototype,
      _2 = E2.hasOwnProperty;
    function y2(e) {
      if (e == null) return !0;
      if (
        f2(e) &&
        (l2(e) ||
          typeof e == "string" ||
          typeof e.splice == "function" ||
          d2(e) ||
          v2(e) ||
          c2(e))
      )
        return !e.length;
      var t = u2(e);
      if (t == h2 || t == g2) return !e.size;
      if (p2(e)) return !s2(e).length;
      for (var r in e) if (_2.call(e, r)) return !1;
      return !0;
    }
    UE.exports = y2;
  });
  var BE = u((dj, WE) => {
    var m2 = za(),
      I2 = Da(),
      T2 = At();
    function O2(e, t) {
      var r = {};
      return (
        (t = T2(t, 3)),
        I2(e, function (n, i, o) {
          m2(r, i, t(n, i, o));
        }),
        r
      );
    }
    WE.exports = O2;
  });
  var kE = u((pj, HE) => {
    function b2(e, t) {
      for (
        var r = -1, n = e == null ? 0 : e.length;
        ++r < n && t(e[r], r, e) !== !1;

      );
      return e;
    }
    HE.exports = b2;
  });
  var KE = u((vj, jE) => {
    var S2 = Jn();
    function A2(e) {
      return typeof e == "function" ? e : S2;
    }
    jE.exports = A2;
  });
  var YE = u((hj, zE) => {
    var w2 = kE(),
      R2 = Ma(),
      C2 = KE(),
      x2 = Ne();
    function N2(e, t) {
      var r = x2(e) ? w2 : R2;
      return r(e, C2(t));
    }
    zE.exports = N2;
  });
  var $E = u((gj, QE) => {
    var q2 = tt(),
      L2 = function () {
        return q2.Date.now();
      };
    QE.exports = L2;
  });
  var e_ = u((Ej, JE) => {
    var P2 = ft(),
      Ya = $E(),
      ZE = ei(),
      D2 = "Expected a function",
      M2 = Math.max,
      F2 = Math.min;
    function G2(e, t, r) {
      var n,
        i,
        o,
        a,
        s,
        c,
        d = 0,
        g = !1,
        f = !1,
        y = !0;
      if (typeof e != "function") throw new TypeError(D2);
      (t = ZE(t) || 0),
        P2(r) &&
          ((g = !!r.leading),
          (f = "maxWait" in r),
          (o = f ? M2(ZE(r.maxWait) || 0, t) : o),
          (y = "trailing" in r ? !!r.trailing : y));
      function h(q) {
        var W = n,
          j = i;
        return (n = i = void 0), (d = q), (a = e.apply(j, W)), a;
      }
      function _(q) {
        return (d = q), (s = setTimeout(R, t)), g ? h(q) : a;
      }
      function b(q) {
        var W = q - c,
          j = q - d,
          Q = t - W;
        return f ? F2(Q, o - j) : Q;
      }
      function C(q) {
        var W = q - c,
          j = q - d;
        return c === void 0 || W >= t || W < 0 || (f && j >= o);
      }
      function R() {
        var q = Ya();
        if (C(q)) return N(q);
        s = setTimeout(R, b(q));
      }
      function N(q) {
        return (s = void 0), y && n ? h(q) : ((n = i = void 0), a);
      }
      function S() {
        s !== void 0 && clearTimeout(s), (d = 0), (n = c = i = s = void 0);
      }
      function G() {
        return s === void 0 ? a : N(Ya());
      }
      function F() {
        var q = Ya(),
          W = C(q);
        if (((n = arguments), (i = this), (c = q), W)) {
          if (s === void 0) return _(c);
          if (f) return clearTimeout(s), (s = setTimeout(R, t)), h(c);
        }
        return s === void 0 && (s = setTimeout(R, t)), a;
      }
      return (F.cancel = S), (F.flush = G), F;
    }
    JE.exports = G2;
  });
  var r_ = u((_j, t_) => {
    var X2 = e_(),
      U2 = ft(),
      V2 = "Expected a function";
    function W2(e, t, r) {
      var n = !0,
        i = !0;
      if (typeof e != "function") throw new TypeError(V2);
      return (
        U2(r) &&
          ((n = "leading" in r ? !!r.leading : n),
          (i = "trailing" in r ? !!r.trailing : i)),
        X2(e, t, { leading: n, maxWait: t, trailing: i })
      );
    }
    t_.exports = W2;
  });
  var gi = u((ce) => {
    "use strict";
    var B2 = ut().default;
    Object.defineProperty(ce, "__esModule", { value: !0 });
    ce.viewportWidthChanged =
      ce.testFrameRendered =
      ce.stopRequested =
      ce.sessionStopped =
      ce.sessionStarted =
      ce.sessionInitialized =
      ce.rawDataImported =
      ce.previewRequested =
      ce.playbackRequested =
      ce.parameterChanged =
      ce.mediaQueriesDefined =
      ce.instanceStarted =
      ce.instanceRemoved =
      ce.instanceAdded =
      ce.eventStateChanged =
      ce.eventListenerAdded =
      ce.elementStateChanged =
      ce.clearRequested =
      ce.animationFrameChanged =
      ce.actionListPlaybackChanged =
        void 0;
    var n_ = B2(Pr()),
      i_ = We(),
      H2 = Wt(),
      {
        IX2_RAW_DATA_IMPORTED: k2,
        IX2_SESSION_INITIALIZED: j2,
        IX2_SESSION_STARTED: K2,
        IX2_SESSION_STOPPED: z2,
        IX2_PREVIEW_REQUESTED: Y2,
        IX2_PLAYBACK_REQUESTED: Q2,
        IX2_STOP_REQUESTED: $2,
        IX2_CLEAR_REQUESTED: Z2,
        IX2_EVENT_LISTENER_ADDED: J2,
        IX2_TEST_FRAME_RENDERED: eG,
        IX2_EVENT_STATE_CHANGED: tG,
        IX2_ANIMATION_FRAME_CHANGED: rG,
        IX2_PARAMETER_CHANGED: nG,
        IX2_INSTANCE_ADDED: iG,
        IX2_INSTANCE_STARTED: oG,
        IX2_INSTANCE_REMOVED: aG,
        IX2_ELEMENT_STATE_CHANGED: sG,
        IX2_ACTION_LIST_PLAYBACK_CHANGED: uG,
        IX2_VIEWPORT_WIDTH_CHANGED: cG,
        IX2_MEDIA_QUERIES_DEFINED: lG,
      } = i_.IX2EngineActionTypes,
      { reifyState: fG } = H2.IX2VanillaUtils,
      dG = (e) => ({ type: k2, payload: (0, n_.default)({}, fG(e)) });
    ce.rawDataImported = dG;
    var pG = ({ hasBoundaryNodes: e, reducedMotion: t }) => ({
      type: j2,
      payload: { hasBoundaryNodes: e, reducedMotion: t },
    });
    ce.sessionInitialized = pG;
    var vG = () => ({ type: K2 });
    ce.sessionStarted = vG;
    var hG = () => ({ type: z2 });
    ce.sessionStopped = hG;
    var gG = ({ rawData: e, defer: t }) => ({
      type: Y2,
      payload: { defer: t, rawData: e },
    });
    ce.previewRequested = gG;
    var EG = ({
      actionTypeId: e = i_.ActionTypeConsts.GENERAL_START_ACTION,
      actionListId: t,
      actionItemId: r,
      eventId: n,
      allowEvents: i,
      immediate: o,
      testManual: a,
      verbose: s,
      rawData: c,
    }) => ({
      type: Q2,
      payload: {
        actionTypeId: e,
        actionListId: t,
        actionItemId: r,
        testManual: a,
        eventId: n,
        allowEvents: i,
        immediate: o,
        verbose: s,
        rawData: c,
      },
    });
    ce.playbackRequested = EG;
    var _G = (e) => ({ type: $2, payload: { actionListId: e } });
    ce.stopRequested = _G;
    var yG = () => ({ type: Z2 });
    ce.clearRequested = yG;
    var mG = (e, t) => ({
      type: J2,
      payload: { target: e, listenerParams: t },
    });
    ce.eventListenerAdded = mG;
    var IG = (e = 1) => ({ type: eG, payload: { step: e } });
    ce.testFrameRendered = IG;
    var TG = (e, t) => ({ type: tG, payload: { stateKey: e, newState: t } });
    ce.eventStateChanged = TG;
    var OG = (e, t) => ({ type: rG, payload: { now: e, parameters: t } });
    ce.animationFrameChanged = OG;
    var bG = (e, t) => ({ type: nG, payload: { key: e, value: t } });
    ce.parameterChanged = bG;
    var SG = (e) => ({ type: iG, payload: (0, n_.default)({}, e) });
    ce.instanceAdded = SG;
    var AG = (e, t) => ({ type: oG, payload: { instanceId: e, time: t } });
    ce.instanceStarted = AG;
    var wG = (e) => ({ type: aG, payload: { instanceId: e } });
    ce.instanceRemoved = wG;
    var RG = (e, t, r, n) => ({
      type: sG,
      payload: { elementId: e, actionTypeId: t, current: r, actionItem: n },
    });
    ce.elementStateChanged = RG;
    var CG = ({ actionListId: e, isPlaying: t }) => ({
      type: uG,
      payload: { actionListId: e, isPlaying: t },
    });
    ce.actionListPlaybackChanged = CG;
    var xG = ({ width: e, mediaQueries: t }) => ({
      type: cG,
      payload: { width: e, mediaQueries: t },
    });
    ce.viewportWidthChanged = xG;
    var NG = () => ({ type: lG });
    ce.mediaQueriesDefined = NG;
  });
  var s_ = u((Le) => {
    "use strict";
    Object.defineProperty(Le, "__esModule", { value: !0 });
    Le.elementContains = BG;
    Le.getChildElements = kG;
    Le.getClosestElement = void 0;
    Le.getProperty = GG;
    Le.getQuerySelector = UG;
    Le.getRefType = zG;
    Le.getSiblingElements = jG;
    Le.getStyle = FG;
    Le.getValidDocument = VG;
    Le.isSiblingNode = HG;
    Le.matchSelector = XG;
    Le.queryDocument = WG;
    Le.setStyle = MG;
    var qG = Wt(),
      LG = We(),
      { ELEMENT_MATCHES: Qa } = qG.IX2BrowserSupport,
      {
        IX2_ID_DELIMITER: o_,
        HTML_ELEMENT: PG,
        PLAIN_OBJECT: DG,
        WF_PAGE: a_,
      } = LG.IX2EngineConstants;
    function MG(e, t, r) {
      e.style[t] = r;
    }
    function FG(e, t) {
      return e.style[t];
    }
    function GG(e, t) {
      return e[t];
    }
    function XG(e) {
      return (t) => t[Qa](e);
    }
    function UG({ id: e, selector: t }) {
      if (e) {
        let r = e;
        if (e.indexOf(o_) !== -1) {
          let n = e.split(o_),
            i = n[0];
          if (((r = n[1]), i !== document.documentElement.getAttribute(a_)))
            return null;
        }
        return `[data-w-id="${r}"], [data-w-id^="${r}_instance"]`;
      }
      return t;
    }
    function VG(e) {
      return e == null || e === document.documentElement.getAttribute(a_)
        ? document
        : null;
    }
    function WG(e, t) {
      return Array.prototype.slice.call(
        document.querySelectorAll(t ? e + " " + t : e)
      );
    }
    function BG(e, t) {
      return e.contains(t);
    }
    function HG(e, t) {
      return e !== t && e.parentNode === t.parentNode;
    }
    function kG(e) {
      let t = [];
      for (let r = 0, { length: n } = e || []; r < n; r++) {
        let { children: i } = e[r],
          { length: o } = i;
        if (o) for (let a = 0; a < o; a++) t.push(i[a]);
      }
      return t;
    }
    function jG(e = []) {
      let t = [],
        r = [];
      for (let n = 0, { length: i } = e; n < i; n++) {
        let { parentNode: o } = e[n];
        if (!o || !o.children || !o.children.length || r.indexOf(o) !== -1)
          continue;
        r.push(o);
        let a = o.firstElementChild;
        for (; a != null; )
          e.indexOf(a) === -1 && t.push(a), (a = a.nextElementSibling);
      }
      return t;
    }
    var KG = Element.prototype.closest
      ? (e, t) => (document.documentElement.contains(e) ? e.closest(t) : null)
      : (e, t) => {
          if (!document.documentElement.contains(e)) return null;
          let r = e;
          do {
            if (r[Qa] && r[Qa](t)) return r;
            r = r.parentNode;
          } while (r != null);
          return null;
        };
    Le.getClosestElement = KG;
    function zG(e) {
      return e != null && typeof e == "object"
        ? e instanceof Element
          ? PG
          : DG
        : null;
    }
  });
  var $a = u((Ij, c_) => {
    var YG = ft(),
      u_ = Object.create,
      QG = (function () {
        function e() {}
        return function (t) {
          if (!YG(t)) return {};
          if (u_) return u_(t);
          e.prototype = t;
          var r = new e();
          return (e.prototype = void 0), r;
        };
      })();
    c_.exports = QG;
  });
  var Ei = u((Tj, l_) => {
    function $G() {}
    l_.exports = $G;
  });
  var yi = u((Oj, f_) => {
    var ZG = $a(),
      JG = Ei();
    function _i(e, t) {
      (this.__wrapped__ = e),
        (this.__actions__ = []),
        (this.__chain__ = !!t),
        (this.__index__ = 0),
        (this.__values__ = void 0);
    }
    _i.prototype = ZG(JG.prototype);
    _i.prototype.constructor = _i;
    f_.exports = _i;
  });
  var h_ = u((bj, v_) => {
    var d_ = $t(),
      eX = Xr(),
      tX = Ne(),
      p_ = d_ ? d_.isConcatSpreadable : void 0;
    function rX(e) {
      return tX(e) || eX(e) || !!(p_ && e && e[p_]);
    }
    v_.exports = rX;
  });
  var __ = u((Sj, E_) => {
    var nX = Vn(),
      iX = h_();
    function g_(e, t, r, n, i) {
      var o = -1,
        a = e.length;
      for (r || (r = iX), i || (i = []); ++o < a; ) {
        var s = e[o];
        t > 0 && r(s)
          ? t > 1
            ? g_(s, t - 1, r, n, i)
            : nX(i, s)
          : n || (i[i.length] = s);
      }
      return i;
    }
    E_.exports = g_;
  });
  var m_ = u((Aj, y_) => {
    var oX = __();
    function aX(e) {
      var t = e == null ? 0 : e.length;
      return t ? oX(e, 1) : [];
    }
    y_.exports = aX;
  });
  var T_ = u((wj, I_) => {
    function sX(e, t, r) {
      switch (r.length) {
        case 0:
          return e.call(t);
        case 1:
          return e.call(t, r[0]);
        case 2:
          return e.call(t, r[0], r[1]);
        case 3:
          return e.call(t, r[0], r[1], r[2]);
      }
      return e.apply(t, r);
    }
    I_.exports = sX;
  });
  var S_ = u((Rj, b_) => {
    var uX = T_(),
      O_ = Math.max;
    function cX(e, t, r) {
      return (
        (t = O_(t === void 0 ? e.length - 1 : t, 0)),
        function () {
          for (
            var n = arguments, i = -1, o = O_(n.length - t, 0), a = Array(o);
            ++i < o;

          )
            a[i] = n[t + i];
          i = -1;
          for (var s = Array(t + 1); ++i < t; ) s[i] = n[i];
          return (s[t] = r(a)), uX(e, this, s);
        }
      );
    }
    b_.exports = cX;
  });
  var w_ = u((Cj, A_) => {
    function lX(e) {
      return function () {
        return e;
      };
    }
    A_.exports = lX;
  });
  var x_ = u((xj, C_) => {
    var fX = w_(),
      R_ = Ka(),
      dX = Jn(),
      pX = R_
        ? function (e, t) {
            return R_(e, "toString", {
              configurable: !0,
              enumerable: !1,
              value: fX(t),
              writable: !0,
            });
          }
        : dX;
    C_.exports = pX;
  });
  var q_ = u((Nj, N_) => {
    var vX = 800,
      hX = 16,
      gX = Date.now;
    function EX(e) {
      var t = 0,
        r = 0;
      return function () {
        var n = gX(),
          i = hX - (n - r);
        if (((r = n), i > 0)) {
          if (++t >= vX) return arguments[0];
        } else t = 0;
        return e.apply(void 0, arguments);
      };
    }
    N_.exports = EX;
  });
  var P_ = u((qj, L_) => {
    var _X = x_(),
      yX = q_(),
      mX = yX(_X);
    L_.exports = mX;
  });
  var M_ = u((Lj, D_) => {
    var IX = m_(),
      TX = S_(),
      OX = P_();
    function bX(e) {
      return OX(TX(e, void 0, IX), e + "");
    }
    D_.exports = bX;
  });
  var X_ = u((Pj, G_) => {
    var F_ = da(),
      SX = F_ && new F_();
    G_.exports = SX;
  });
  var V_ = u((Dj, U_) => {
    function AX() {}
    U_.exports = AX;
  });
  var Za = u((Mj, B_) => {
    var W_ = X_(),
      wX = V_(),
      RX = W_
        ? function (e) {
            return W_.get(e);
          }
        : wX;
    B_.exports = RX;
  });
  var k_ = u((Fj, H_) => {
    var CX = {};
    H_.exports = CX;
  });
  var Ja = u((Gj, K_) => {
    var j_ = k_(),
      xX = Object.prototype,
      NX = xX.hasOwnProperty;
    function qX(e) {
      for (
        var t = e.name + "", r = j_[t], n = NX.call(j_, t) ? r.length : 0;
        n--;

      ) {
        var i = r[n],
          o = i.func;
        if (o == null || o == e) return i.name;
      }
      return t;
    }
    K_.exports = qX;
  });
  var Ii = u((Xj, z_) => {
    var LX = $a(),
      PX = Ei(),
      DX = 4294967295;
    function mi(e) {
      (this.__wrapped__ = e),
        (this.__actions__ = []),
        (this.__dir__ = 1),
        (this.__filtered__ = !1),
        (this.__iteratees__ = []),
        (this.__takeCount__ = DX),
        (this.__views__ = []);
    }
    mi.prototype = LX(PX.prototype);
    mi.prototype.constructor = mi;
    z_.exports = mi;
  });
  var Q_ = u((Uj, Y_) => {
    function MX(e, t) {
      var r = -1,
        n = e.length;
      for (t || (t = Array(n)); ++r < n; ) t[r] = e[r];
      return t;
    }
    Y_.exports = MX;
  });
  var Z_ = u((Vj, $_) => {
    var FX = Ii(),
      GX = yi(),
      XX = Q_();
    function UX(e) {
      if (e instanceof FX) return e.clone();
      var t = new GX(e.__wrapped__, e.__chain__);
      return (
        (t.__actions__ = XX(e.__actions__)),
        (t.__index__ = e.__index__),
        (t.__values__ = e.__values__),
        t
      );
    }
    $_.exports = UX;
  });
  var ty = u((Wj, ey) => {
    var VX = Ii(),
      J_ = yi(),
      WX = Ei(),
      BX = Ne(),
      HX = Et(),
      kX = Z_(),
      jX = Object.prototype,
      KX = jX.hasOwnProperty;
    function Ti(e) {
      if (HX(e) && !BX(e) && !(e instanceof VX)) {
        if (e instanceof J_) return e;
        if (KX.call(e, "__wrapped__")) return kX(e);
      }
      return new J_(e);
    }
    Ti.prototype = WX.prototype;
    Ti.prototype.constructor = Ti;
    ey.exports = Ti;
  });
  var ny = u((Bj, ry) => {
    var zX = Ii(),
      YX = Za(),
      QX = Ja(),
      $X = ty();
    function ZX(e) {
      var t = QX(e),
        r = $X[t];
      if (typeof r != "function" || !(t in zX.prototype)) return !1;
      if (e === r) return !0;
      var n = YX(r);
      return !!n && e === n[0];
    }
    ry.exports = ZX;
  });
  var sy = u((Hj, ay) => {
    var iy = yi(),
      JX = M_(),
      eU = Za(),
      es = Ja(),
      tU = Ne(),
      oy = ny(),
      rU = "Expected a function",
      nU = 8,
      iU = 32,
      oU = 128,
      aU = 256;
    function sU(e) {
      return JX(function (t) {
        var r = t.length,
          n = r,
          i = iy.prototype.thru;
        for (e && t.reverse(); n--; ) {
          var o = t[n];
          if (typeof o != "function") throw new TypeError(rU);
          if (i && !a && es(o) == "wrapper") var a = new iy([], !0);
        }
        for (n = a ? n : r; ++n < r; ) {
          o = t[n];
          var s = es(o),
            c = s == "wrapper" ? eU(o) : void 0;
          c &&
          oy(c[0]) &&
          c[1] == (oU | nU | iU | aU) &&
          !c[4].length &&
          c[9] == 1
            ? (a = a[es(c[0])].apply(a, c[3]))
            : (a = o.length == 1 && oy(o) ? a[s]() : a.thru(o));
        }
        return function () {
          var d = arguments,
            g = d[0];
          if (a && d.length == 1 && tU(g)) return a.plant(g).value();
          for (var f = 0, y = r ? t[f].apply(this, d) : g; ++f < r; )
            y = t[f].call(this, y);
          return y;
        };
      });
    }
    ay.exports = sU;
  });
  var cy = u((kj, uy) => {
    var uU = sy(),
      cU = uU();
    uy.exports = cU;
  });
  var fy = u((jj, ly) => {
    function lU(e, t, r) {
      return (
        e === e &&
          (r !== void 0 && (e = e <= r ? e : r),
          t !== void 0 && (e = e >= t ? e : t)),
        e
      );
    }
    ly.exports = lU;
  });
  var py = u((Kj, dy) => {
    var fU = fy(),
      ts = ei();
    function dU(e, t, r) {
      return (
        r === void 0 && ((r = t), (t = void 0)),
        r !== void 0 && ((r = ts(r)), (r = r === r ? r : 0)),
        t !== void 0 && ((t = ts(t)), (t = t === t ? t : 0)),
        fU(ts(e), t, r)
      );
    }
    dy.exports = dU;
  });
  var Ny = u((wi) => {
    "use strict";
    var Ai = ut().default;
    Object.defineProperty(wi, "__esModule", { value: !0 });
    wi.default = void 0;
    var je = Ai(Pr()),
      pU = Ai(cy()),
      vU = Ai(Zn()),
      hU = Ai(py()),
      Bt = We(),
      rs = as(),
      Oi = gi(),
      gU = Wt(),
      {
        MOUSE_CLICK: EU,
        MOUSE_SECOND_CLICK: _U,
        MOUSE_DOWN: yU,
        MOUSE_UP: mU,
        MOUSE_OVER: IU,
        MOUSE_OUT: TU,
        DROPDOWN_CLOSE: OU,
        DROPDOWN_OPEN: bU,
        SLIDER_ACTIVE: SU,
        SLIDER_INACTIVE: AU,
        TAB_ACTIVE: wU,
        TAB_INACTIVE: RU,
        NAVBAR_CLOSE: CU,
        NAVBAR_OPEN: xU,
        MOUSE_MOVE: NU,
        PAGE_SCROLL_DOWN: Ty,
        SCROLL_INTO_VIEW: Oy,
        SCROLL_OUT_OF_VIEW: qU,
        PAGE_SCROLL_UP: LU,
        SCROLLING_IN_VIEW: PU,
        PAGE_FINISH: by,
        ECOMMERCE_CART_CLOSE: DU,
        ECOMMERCE_CART_OPEN: MU,
        PAGE_START: Sy,
        PAGE_SCROLL: FU,
      } = Bt.EventTypeConsts,
      ns = "COMPONENT_ACTIVE",
      Ay = "COMPONENT_INACTIVE",
      { COLON_DELIMITER: vy } = Bt.IX2EngineConstants,
      { getNamespacedParameterId: hy } = gU.IX2VanillaUtils,
      wy = (e) => (t) => typeof t == "object" && e(t) ? !0 : t,
      rn = wy(({ element: e, nativeEvent: t }) => e === t.target),
      GU = wy(({ element: e, nativeEvent: t }) => e.contains(t.target)),
      ht = (0, pU.default)([rn, GU]),
      Ry = (e, t) => {
        if (t) {
          let { ixData: r } = e.getState(),
            { events: n } = r,
            i = n[t];
          if (i && !UU[i.eventTypeId]) return i;
        }
        return null;
      },
      XU = ({ store: e, event: t }) => {
        let { action: r } = t,
          { autoStopEventId: n } = r.config;
        return !!Ry(e, n);
      },
      He = ({ store: e, event: t, element: r, eventStateKey: n }, i) => {
        let { action: o, id: a } = t,
          { actionListId: s, autoStopEventId: c } = o.config,
          d = Ry(e, c);
        return (
          d &&
            (0, rs.stopActionGroup)({
              store: e,
              eventId: c,
              eventTarget: r,
              eventStateKey: c + vy + n.split(vy)[1],
              actionListId: (0, vU.default)(d, "action.config.actionListId"),
            }),
          (0, rs.stopActionGroup)({
            store: e,
            eventId: a,
            eventTarget: r,
            eventStateKey: n,
            actionListId: s,
          }),
          (0, rs.startActionGroup)({
            store: e,
            eventId: a,
            eventTarget: r,
            eventStateKey: n,
            actionListId: s,
          }),
          i
        );
      },
      rt = (e, t) => (r, n) => e(r, n) === !0 ? t(r, n) : n,
      nn = { handler: rt(ht, He) },
      Cy = (0, je.default)({}, nn, { types: [ns, Ay].join(" ") }),
      is = [
        { target: window, types: "resize orientationchange", throttle: !0 },
        {
          target: document,
          types: "scroll wheel readystatechange IX2_PAGE_UPDATE",
          throttle: !0,
        },
      ],
      gy = "mouseover mouseout",
      os = { types: is },
      UU = { PAGE_START: Sy, PAGE_FINISH: by },
      tn = (() => {
        let e = window.pageXOffset !== void 0,
          r =
            document.compatMode === "CSS1Compat"
              ? document.documentElement
              : document.body;
        return () => ({
          scrollLeft: e ? window.pageXOffset : r.scrollLeft,
          scrollTop: e ? window.pageYOffset : r.scrollTop,
          stiffScrollTop: (0, hU.default)(
            e ? window.pageYOffset : r.scrollTop,
            0,
            r.scrollHeight - window.innerHeight
          ),
          scrollWidth: r.scrollWidth,
          scrollHeight: r.scrollHeight,
          clientWidth: r.clientWidth,
          clientHeight: r.clientHeight,
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight,
        });
      })(),
      VU = (e, t) =>
        !(
          e.left > t.right ||
          e.right < t.left ||
          e.top > t.bottom ||
          e.bottom < t.top
        ),
      WU = ({ element: e, nativeEvent: t }) => {
        let { type: r, target: n, relatedTarget: i } = t,
          o = e.contains(n);
        if (r === "mouseover" && o) return !0;
        let a = e.contains(i);
        return !!(r === "mouseout" && o && a);
      },
      BU = (e) => {
        let {
            element: t,
            event: { config: r },
          } = e,
          { clientWidth: n, clientHeight: i } = tn(),
          o = r.scrollOffsetValue,
          c = r.scrollOffsetUnit === "PX" ? o : (i * (o || 0)) / 100;
        return VU(t.getBoundingClientRect(), {
          left: 0,
          top: c,
          right: n,
          bottom: i - c,
        });
      },
      xy = (e) => (t, r) => {
        let { type: n } = t.nativeEvent,
          i = [ns, Ay].indexOf(n) !== -1 ? n === ns : r.isActive,
          o = (0, je.default)({}, r, { isActive: i });
        return ((!r || o.isActive !== r.isActive) && e(t, o)) || o;
      },
      Ey = (e) => (t, r) => {
        let n = { elementHovered: WU(t) };
        return (
          ((r ? n.elementHovered !== r.elementHovered : n.elementHovered) &&
            e(t, n)) ||
          n
        );
      },
      HU = (e) => (t, r) => {
        let n = (0, je.default)({}, r, { elementVisible: BU(t) });
        return (
          ((r ? n.elementVisible !== r.elementVisible : n.elementVisible) &&
            e(t, n)) ||
          n
        );
      },
      _y =
        (e) =>
        (t, r = {}) => {
          let { stiffScrollTop: n, scrollHeight: i, innerHeight: o } = tn(),
            {
              event: { config: a, eventTypeId: s },
            } = t,
            { scrollOffsetValue: c, scrollOffsetUnit: d } = a,
            g = d === "PX",
            f = i - o,
            y = Number((n / f).toFixed(2));
          if (r && r.percentTop === y) return r;
          let h = (g ? c : (o * (c || 0)) / 100) / f,
            _,
            b,
            C = 0;
          r &&
            ((_ = y > r.percentTop),
            (b = r.scrollingDown !== _),
            (C = b ? y : r.anchorTop));
          let R = s === Ty ? y >= C + h : y <= C - h,
            N = (0, je.default)({}, r, {
              percentTop: y,
              inBounds: R,
              anchorTop: C,
              scrollingDown: _,
            });
          return (r && R && (b || N.inBounds !== r.inBounds) && e(t, N)) || N;
        },
      kU = (e, t) =>
        e.left > t.left &&
        e.left < t.right &&
        e.top > t.top &&
        e.top < t.bottom,
      jU = (e) => (t, r) => {
        let n = { finished: document.readyState === "complete" };
        return n.finished && !(r && r.finshed) && e(t), n;
      },
      KU = (e) => (t, r) => {
        let n = { started: !0 };
        return r || e(t), n;
      },
      yy =
        (e) =>
        (t, r = { clickCount: 0 }) => {
          let n = { clickCount: (r.clickCount % 2) + 1 };
          return (n.clickCount !== r.clickCount && e(t, n)) || n;
        },
      bi = (e = !0) =>
        (0, je.default)({}, Cy, {
          handler: rt(
            e ? ht : rn,
            xy((t, r) => (r.isActive ? nn.handler(t, r) : r))
          ),
        }),
      Si = (e = !0) =>
        (0, je.default)({}, Cy, {
          handler: rt(
            e ? ht : rn,
            xy((t, r) => (r.isActive ? r : nn.handler(t, r)))
          ),
        }),
      my = (0, je.default)({}, os, {
        handler: HU((e, t) => {
          let { elementVisible: r } = t,
            { event: n, store: i } = e,
            { ixData: o } = i.getState(),
            { events: a } = o;
          return !a[n.action.config.autoStopEventId] && t.triggered
            ? t
            : (n.eventTypeId === Oy) === r
            ? (He(e), (0, je.default)({}, t, { triggered: !0 }))
            : t;
        }),
      }),
      Iy = 0.05,
      zU = {
        [SU]: bi(),
        [AU]: Si(),
        [bU]: bi(),
        [OU]: Si(),
        [xU]: bi(!1),
        [CU]: Si(!1),
        [wU]: bi(),
        [RU]: Si(),
        [MU]: { types: "ecommerce-cart-open", handler: rt(ht, He) },
        [DU]: { types: "ecommerce-cart-close", handler: rt(ht, He) },
        [EU]: {
          types: "click",
          handler: rt(
            ht,
            yy((e, { clickCount: t }) => {
              XU(e) ? t === 1 && He(e) : He(e);
            })
          ),
        },
        [_U]: {
          types: "click",
          handler: rt(
            ht,
            yy((e, { clickCount: t }) => {
              t === 2 && He(e);
            })
          ),
        },
        [yU]: (0, je.default)({}, nn, { types: "mousedown" }),
        [mU]: (0, je.default)({}, nn, { types: "mouseup" }),
        [IU]: {
          types: gy,
          handler: rt(
            ht,
            Ey((e, t) => {
              t.elementHovered && He(e);
            })
          ),
        },
        [TU]: {
          types: gy,
          handler: rt(
            ht,
            Ey((e, t) => {
              t.elementHovered || He(e);
            })
          ),
        },
        [NU]: {
          types: "mousemove mouseout scroll",
          handler: (
            {
              store: e,
              element: t,
              eventConfig: r,
              nativeEvent: n,
              eventStateKey: i,
            },
            o = { clientX: 0, clientY: 0, pageX: 0, pageY: 0 }
          ) => {
            let {
                basedOn: a,
                selectedAxis: s,
                continuousParameterGroupId: c,
                reverse: d,
                restingState: g = 0,
              } = r,
              {
                clientX: f = o.clientX,
                clientY: y = o.clientY,
                pageX: h = o.pageX,
                pageY: _ = o.pageY,
              } = n,
              b = s === "X_AXIS",
              C = n.type === "mouseout",
              R = g / 100,
              N = c,
              S = !1;
            switch (a) {
              case Bt.EventBasedOn.VIEWPORT: {
                R = b
                  ? Math.min(f, window.innerWidth) / window.innerWidth
                  : Math.min(y, window.innerHeight) / window.innerHeight;
                break;
              }
              case Bt.EventBasedOn.PAGE: {
                let {
                  scrollLeft: G,
                  scrollTop: F,
                  scrollWidth: q,
                  scrollHeight: W,
                } = tn();
                R = b ? Math.min(G + h, q) / q : Math.min(F + _, W) / W;
                break;
              }
              case Bt.EventBasedOn.ELEMENT:
              default: {
                N = hy(i, c);
                let G = n.type.indexOf("mouse") === 0;
                if (G && ht({ element: t, nativeEvent: n }) !== !0) break;
                let F = t.getBoundingClientRect(),
                  { left: q, top: W, width: j, height: Q } = F;
                if (!G && !kU({ left: f, top: y }, F)) break;
                (S = !0), (R = b ? (f - q) / j : (y - W) / Q);
                break;
              }
            }
            return (
              C && (R > 1 - Iy || R < Iy) && (R = Math.round(R)),
              (a !== Bt.EventBasedOn.ELEMENT || S || S !== o.elementHovered) &&
                ((R = d ? 1 - R : R),
                e.dispatch((0, Oi.parameterChanged)(N, R))),
              { elementHovered: S, clientX: f, clientY: y, pageX: h, pageY: _ }
            );
          },
        },
        [FU]: {
          types: is,
          handler: ({ store: e, eventConfig: t }) => {
            let { continuousParameterGroupId: r, reverse: n } = t,
              { scrollTop: i, scrollHeight: o, clientHeight: a } = tn(),
              s = i / (o - a);
            (s = n ? 1 - s : s), e.dispatch((0, Oi.parameterChanged)(r, s));
          },
        },
        [PU]: {
          types: is,
          handler: (
            { element: e, store: t, eventConfig: r, eventStateKey: n },
            i = { scrollPercent: 0 }
          ) => {
            let {
                scrollLeft: o,
                scrollTop: a,
                scrollWidth: s,
                scrollHeight: c,
                clientHeight: d,
              } = tn(),
              {
                basedOn: g,
                selectedAxis: f,
                continuousParameterGroupId: y,
                startsEntering: h,
                startsExiting: _,
                addEndOffset: b,
                addStartOffset: C,
                addOffsetValue: R = 0,
                endOffsetValue: N = 0,
              } = r,
              S = f === "X_AXIS";
            if (g === Bt.EventBasedOn.VIEWPORT) {
              let G = S ? o / s : a / c;
              return (
                G !== i.scrollPercent &&
                  t.dispatch((0, Oi.parameterChanged)(y, G)),
                { scrollPercent: G }
              );
            } else {
              let G = hy(n, y),
                F = e.getBoundingClientRect(),
                q = (C ? R : 0) / 100,
                W = (b ? N : 0) / 100;
              (q = h ? q : 1 - q), (W = _ ? W : 1 - W);
              let j = F.top + Math.min(F.height * q, d),
                ae = F.top + F.height * W - j,
                re = Math.min(d + ae, c),
                I = Math.min(Math.max(0, d - j), re) / re;
              return (
                I !== i.scrollPercent &&
                  t.dispatch((0, Oi.parameterChanged)(G, I)),
                { scrollPercent: I }
              );
            }
          },
        },
        [Oy]: my,
        [qU]: my,
        [Ty]: (0, je.default)({}, os, {
          handler: _y((e, t) => {
            t.scrollingDown && He(e);
          }),
        }),
        [LU]: (0, je.default)({}, os, {
          handler: _y((e, t) => {
            t.scrollingDown || He(e);
          }),
        }),
        [by]: {
          types: "readystatechange IX2_PAGE_UPDATE",
          handler: rt(rn, jU(He)),
        },
        [Sy]: {
          types: "readystatechange IX2_PAGE_UPDATE",
          handler: rt(rn, KU(He)),
        },
      };
    wi.default = zU;
  });
  var as = u((xt) => {
    "use strict";
    var it = ut().default,
      YU = Kt().default;
    Object.defineProperty(xt, "__esModule", { value: !0 });
    xt.observeRequests = bV;
    xt.startActionGroup = ps;
    xt.startEngine = Ni;
    xt.stopActionGroup = ds;
    xt.stopAllActionGroups = Uy;
    xt.stopEngine = qi;
    var QU = it(Pr()),
      $U = it(zg()),
      ZU = it(Ra()),
      Ct = it(Zn()),
      JU = it(pE()),
      eV = it(XE()),
      tV = it(VE()),
      rV = it(BE()),
      on = it(YE()),
      nV = it(r_()),
      nt = We(),
      Py = Wt(),
      be = gi(),
      Re = YU(s_()),
      iV = it(Ny()),
      oV = ["store", "computedStyle"],
      aV = Object.keys(nt.QuickEffectIds),
      ss = (e) => aV.includes(e),
      {
        COLON_DELIMITER: us,
        BOUNDARY_SELECTOR: Ri,
        HTML_ELEMENT: Dy,
        RENDER_GENERAL: sV,
        W_MOD_IX: qy,
      } = nt.IX2EngineConstants,
      {
        getAffectedElements: Ci,
        getElementId: uV,
        getDestinationValues: cs,
        observeStore: Ht,
        getInstanceId: cV,
        renderHTMLElement: lV,
        clearAllStyles: My,
        getMaxDurationItemIndex: fV,
        getComputedStyle: dV,
        getInstanceOrigin: pV,
        reduceListToGroup: vV,
        shouldNamespaceEventParameter: hV,
        getNamespacedParameterId: gV,
        shouldAllowMediaQuery: xi,
        cleanupHTMLElement: EV,
        stringifyTarget: _V,
        mediaQueriesEqual: yV,
        shallowEqual: mV,
      } = Py.IX2VanillaUtils,
      {
        isPluginType: ls,
        createPluginInstance: fs,
        getPluginDuration: IV,
      } = Py.IX2VanillaPlugins,
      Ly = navigator.userAgent,
      TV = Ly.match(/iPad/i) || Ly.match(/iPhone/),
      OV = 12;
    function bV(e) {
      Ht({ store: e, select: ({ ixRequest: t }) => t.preview, onChange: wV }),
        Ht({
          store: e,
          select: ({ ixRequest: t }) => t.playback,
          onChange: RV,
        }),
        Ht({ store: e, select: ({ ixRequest: t }) => t.stop, onChange: CV }),
        Ht({ store: e, select: ({ ixRequest: t }) => t.clear, onChange: xV });
    }
    function SV(e) {
      Ht({
        store: e,
        select: ({ ixSession: t }) => t.mediaQueryKey,
        onChange: () => {
          qi(e),
            My({ store: e, elementApi: Re }),
            Ni({ store: e, allowEvents: !0 }),
            Fy();
        },
      });
    }
    function AV(e, t) {
      let r = Ht({
        store: e,
        select: ({ ixSession: n }) => n.tick,
        onChange: (n) => {
          t(n), r();
        },
      });
    }
    function wV({ rawData: e, defer: t }, r) {
      let n = () => {
        Ni({ store: r, rawData: e, allowEvents: !0 }), Fy();
      };
      t ? setTimeout(n, 0) : n();
    }
    function Fy() {
      document.dispatchEvent(new CustomEvent("IX2_PAGE_UPDATE"));
    }
    function RV(e, t) {
      let {
          actionTypeId: r,
          actionListId: n,
          actionItemId: i,
          eventId: o,
          allowEvents: a,
          immediate: s,
          testManual: c,
          verbose: d = !0,
        } = e,
        { rawData: g } = e;
      if (n && i && g && s) {
        let f = g.actionLists[n];
        f && (g = vV({ actionList: f, actionItemId: i, rawData: g }));
      }
      if (
        (Ni({ store: t, rawData: g, allowEvents: a, testManual: c }),
        (n && r === nt.ActionTypeConsts.GENERAL_START_ACTION) || ss(r))
      ) {
        ds({ store: t, actionListId: n }),
          Xy({ store: t, actionListId: n, eventId: o });
        let f = ps({
          store: t,
          eventId: o,
          actionListId: n,
          immediate: s,
          verbose: d,
        });
        d &&
          f &&
          t.dispatch(
            (0, be.actionListPlaybackChanged)({
              actionListId: n,
              isPlaying: !s,
            })
          );
      }
    }
    function CV({ actionListId: e }, t) {
      e ? ds({ store: t, actionListId: e }) : Uy({ store: t }), qi(t);
    }
    function xV(e, t) {
      qi(t), My({ store: t, elementApi: Re });
    }
    function Ni({ store: e, rawData: t, allowEvents: r, testManual: n }) {
      let { ixSession: i } = e.getState();
      t && e.dispatch((0, be.rawDataImported)(t)),
        i.active ||
          (e.dispatch(
            (0, be.sessionInitialized)({
              hasBoundaryNodes: !!document.querySelector(Ri),
              reducedMotion:
                document.body.hasAttribute("data-wf-ix-vacation") &&
                window.matchMedia("(prefers-reduced-motion)").matches,
            })
          ),
          r &&
            (MV(e),
            NV(),
            e.getState().ixSession.hasDefinedMediaQueries && SV(e)),
          e.dispatch((0, be.sessionStarted)()),
          qV(e, n));
    }
    function NV() {
      let { documentElement: e } = document;
      e.className.indexOf(qy) === -1 && (e.className += ` ${qy}`);
    }
    function qV(e, t) {
      let r = (n) => {
        let { ixSession: i, ixParameters: o } = e.getState();
        i.active &&
          (e.dispatch((0, be.animationFrameChanged)(n, o)),
          t ? AV(e, r) : requestAnimationFrame(r));
      };
      r(window.performance.now());
    }
    function qi(e) {
      let { ixSession: t } = e.getState();
      if (t.active) {
        let { eventListeners: r } = t;
        r.forEach(LV), e.dispatch((0, be.sessionStopped)());
      }
    }
    function LV({ target: e, listenerParams: t }) {
      e.removeEventListener.apply(e, t);
    }
    function PV({
      store: e,
      eventStateKey: t,
      eventTarget: r,
      eventId: n,
      eventConfig: i,
      actionListId: o,
      parameterGroup: a,
      smoothing: s,
      restingValue: c,
    }) {
      let { ixData: d, ixSession: g } = e.getState(),
        { events: f } = d,
        y = f[n],
        { eventTypeId: h } = y,
        _ = {},
        b = {},
        C = [],
        { continuousActionGroups: R } = a,
        { id: N } = a;
      hV(h, i) && (N = gV(t, N));
      let S = g.hasBoundaryNodes && r ? Re.getClosestElement(r, Ri) : null;
      R.forEach((G) => {
        let { keyframe: F, actionItems: q } = G;
        q.forEach((W) => {
          let { actionTypeId: j } = W,
            { target: Q } = W.config;
          if (!Q) return;
          let ae = Q.boundaryMode ? S : null,
            re = _V(Q) + us + j;
          if (((b[re] = DV(b[re], F, W)), !_[re])) {
            _[re] = !0;
            let { config: X } = W;
            Ci({
              config: X,
              event: y,
              eventTarget: r,
              elementRoot: ae,
              elementApi: Re,
            }).forEach((I) => {
              C.push({ element: I, key: re });
            });
          }
        });
      }),
        C.forEach(({ element: G, key: F }) => {
          let q = b[F],
            W = (0, Ct.default)(q, "[0].actionItems[0]", {}),
            { actionTypeId: j } = W,
            Q = ls(j) ? fs(j)(G, W) : null,
            ae = cs({ element: G, actionItem: W, elementApi: Re }, Q);
          vs({
            store: e,
            element: G,
            eventId: n,
            actionListId: o,
            actionItem: W,
            destination: ae,
            continuous: !0,
            parameterId: N,
            actionGroups: q,
            smoothing: s,
            restingValue: c,
            pluginInstance: Q,
          });
        });
    }
    function DV(e = [], t, r) {
      let n = [...e],
        i;
      return (
        n.some((o, a) => (o.keyframe === t ? ((i = a), !0) : !1)),
        i == null && ((i = n.length), n.push({ keyframe: t, actionItems: [] })),
        n[i].actionItems.push(r),
        n
      );
    }
    function MV(e) {
      let { ixData: t } = e.getState(),
        { eventTypeMap: r } = t;
      Gy(e),
        (0, on.default)(r, (i, o) => {
          let a = iV.default[o];
          if (!a) {
            console.warn(`IX2 event type not configured: ${o}`);
            return;
          }
          WV({ logic: a, store: e, events: i });
        });
      let { ixSession: n } = e.getState();
      n.eventListeners.length && GV(e);
    }
    var FV = ["resize", "orientationchange"];
    function GV(e) {
      let t = () => {
        Gy(e);
      };
      FV.forEach((r) => {
        window.addEventListener(r, t),
          e.dispatch((0, be.eventListenerAdded)(window, [r, t]));
      }),
        t();
    }
    function Gy(e) {
      let { ixSession: t, ixData: r } = e.getState(),
        n = window.innerWidth;
      if (n !== t.viewportWidth) {
        let { mediaQueries: i } = r;
        e.dispatch((0, be.viewportWidthChanged)({ width: n, mediaQueries: i }));
      }
    }
    var XV = (e, t) => (0, eV.default)((0, rV.default)(e, t), tV.default),
      UV = (e, t) => {
        (0, on.default)(e, (r, n) => {
          r.forEach((i, o) => {
            let a = n + us + o;
            t(i, n, a);
          });
        });
      },
      VV = (e) => {
        let t = { target: e.target, targets: e.targets };
        return Ci({ config: t, elementApi: Re });
      };
    function WV({ logic: e, store: t, events: r }) {
      BV(r);
      let { types: n, handler: i } = e,
        { ixData: o } = t.getState(),
        { actionLists: a } = o,
        s = XV(r, VV);
      if (!(0, JU.default)(s)) return;
      (0, on.default)(s, (f, y) => {
        let h = r[y],
          { action: _, id: b, mediaQueries: C = o.mediaQueryKeys } = h,
          { actionListId: R } = _.config;
        yV(C, o.mediaQueryKeys) || t.dispatch((0, be.mediaQueriesDefined)()),
          _.actionTypeId === nt.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION &&
            (Array.isArray(h.config) ? h.config : [h.config]).forEach((S) => {
              let { continuousParameterGroupId: G } = S,
                F = (0, Ct.default)(a, `${R}.continuousParameterGroups`, []),
                q = (0, ZU.default)(F, ({ id: Q }) => Q === G),
                W = (S.smoothing || 0) / 100,
                j = (S.restingState || 0) / 100;
              q &&
                f.forEach((Q, ae) => {
                  let re = b + us + ae;
                  PV({
                    store: t,
                    eventStateKey: re,
                    eventTarget: Q,
                    eventId: b,
                    eventConfig: S,
                    actionListId: R,
                    parameterGroup: q,
                    smoothing: W,
                    restingValue: j,
                  });
                });
            }),
          (_.actionTypeId === nt.ActionTypeConsts.GENERAL_START_ACTION ||
            ss(_.actionTypeId)) &&
            Xy({ store: t, actionListId: R, eventId: b });
      });
      let c = (f) => {
          let { ixSession: y } = t.getState();
          UV(s, (h, _, b) => {
            let C = r[_],
              R = y.eventState[b],
              { action: N, mediaQueries: S = o.mediaQueryKeys } = C;
            if (!xi(S, y.mediaQueryKey)) return;
            let G = (F = {}) => {
              let q = i(
                {
                  store: t,
                  element: h,
                  event: C,
                  eventConfig: F,
                  nativeEvent: f,
                  eventStateKey: b,
                },
                R
              );
              mV(q, R) || t.dispatch((0, be.eventStateChanged)(b, q));
            };
            N.actionTypeId === nt.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION
              ? (Array.isArray(C.config) ? C.config : [C.config]).forEach(G)
              : G();
          });
        },
        d = (0, nV.default)(c, OV),
        g = ({ target: f = document, types: y, throttle: h }) => {
          y.split(" ")
            .filter(Boolean)
            .forEach((_) => {
              let b = h ? d : c;
              f.addEventListener(_, b),
                t.dispatch((0, be.eventListenerAdded)(f, [_, b]));
            });
        };
      Array.isArray(n) ? n.forEach(g) : typeof n == "string" && g(e);
    }
    function BV(e) {
      if (!TV) return;
      let t = {},
        r = "";
      for (let n in e) {
        let { eventTypeId: i, target: o } = e[n],
          a = Re.getQuerySelector(o);
        t[a] ||
          ((i === nt.EventTypeConsts.MOUSE_CLICK ||
            i === nt.EventTypeConsts.MOUSE_SECOND_CLICK) &&
            ((t[a] = !0),
            (r += a + "{cursor: pointer;touch-action: manipulation;}")));
      }
      if (r) {
        let n = document.createElement("style");
        (n.textContent = r), document.body.appendChild(n);
      }
    }
    function Xy({ store: e, actionListId: t, eventId: r }) {
      let { ixData: n, ixSession: i } = e.getState(),
        { actionLists: o, events: a } = n,
        s = a[r],
        c = o[t];
      if (c && c.useFirstGroupAsInitialState) {
        let d = (0, Ct.default)(c, "actionItemGroups[0].actionItems", []),
          g = (0, Ct.default)(s, "mediaQueries", n.mediaQueryKeys);
        if (!xi(g, i.mediaQueryKey)) return;
        d.forEach((f) => {
          var y;
          let { config: h, actionTypeId: _ } = f,
            b =
              (h == null || (y = h.target) === null || y === void 0
                ? void 0
                : y.useEventTarget) === !0
                ? { target: s.target, targets: s.targets }
                : h,
            C = Ci({ config: b, event: s, elementApi: Re }),
            R = ls(_);
          C.forEach((N) => {
            let S = R ? fs(_)(N, f) : null;
            vs({
              destination: cs({ element: N, actionItem: f, elementApi: Re }, S),
              immediate: !0,
              store: e,
              element: N,
              eventId: r,
              actionItem: f,
              actionListId: t,
              pluginInstance: S,
            });
          });
        });
      }
    }
    function Uy({ store: e }) {
      let { ixInstances: t } = e.getState();
      (0, on.default)(t, (r) => {
        if (!r.continuous) {
          let { actionListId: n, verbose: i } = r;
          hs(r, e),
            i &&
              e.dispatch(
                (0, be.actionListPlaybackChanged)({
                  actionListId: n,
                  isPlaying: !1,
                })
              );
        }
      });
    }
    function ds({
      store: e,
      eventId: t,
      eventTarget: r,
      eventStateKey: n,
      actionListId: i,
    }) {
      let { ixInstances: o, ixSession: a } = e.getState(),
        s = a.hasBoundaryNodes && r ? Re.getClosestElement(r, Ri) : null;
      (0, on.default)(o, (c) => {
        let d = (0, Ct.default)(c, "actionItem.config.target.boundaryMode"),
          g = n ? c.eventStateKey === n : !0;
        if (c.actionListId === i && c.eventId === t && g) {
          if (s && d && !Re.elementContains(s, c.element)) return;
          hs(c, e),
            c.verbose &&
              e.dispatch(
                (0, be.actionListPlaybackChanged)({
                  actionListId: i,
                  isPlaying: !1,
                })
              );
        }
      });
    }
    function ps({
      store: e,
      eventId: t,
      eventTarget: r,
      eventStateKey: n,
      actionListId: i,
      groupIndex: o = 0,
      immediate: a,
      verbose: s,
    }) {
      var c;
      let { ixData: d, ixSession: g } = e.getState(),
        { events: f } = d,
        y = f[t] || {},
        { mediaQueries: h = d.mediaQueryKeys } = y,
        _ = (0, Ct.default)(d, `actionLists.${i}`, {}),
        { actionItemGroups: b, useFirstGroupAsInitialState: C } = _;
      if (!b || !b.length) return !1;
      o >= b.length && (0, Ct.default)(y, "config.loop") && (o = 0),
        o === 0 && C && o++;
      let N =
          (o === 0 || (o === 1 && C)) &&
          ss((c = y.action) === null || c === void 0 ? void 0 : c.actionTypeId)
            ? y.config.delay
            : void 0,
        S = (0, Ct.default)(b, [o, "actionItems"], []);
      if (!S.length || !xi(h, g.mediaQueryKey)) return !1;
      let G = g.hasBoundaryNodes && r ? Re.getClosestElement(r, Ri) : null,
        F = fV(S),
        q = !1;
      return (
        S.forEach((W, j) => {
          let { config: Q, actionTypeId: ae } = W,
            re = ls(ae),
            { target: X } = Q;
          if (!X) return;
          let I = X.boundaryMode ? G : null;
          Ci({
            config: Q,
            event: y,
            eventTarget: r,
            elementRoot: I,
            elementApi: Re,
          }).forEach((M, D) => {
            let $ = re ? fs(ae)(M, W) : null,
              ne = re ? IV(ae)(M, W) : null;
            q = !0;
            let P = F === j && D === 0,
              U = dV({ element: M, actionItem: W }),
              K = cs({ element: M, actionItem: W, elementApi: Re }, $);
            vs({
              store: e,
              element: M,
              actionItem: W,
              eventId: t,
              eventTarget: r,
              eventStateKey: n,
              actionListId: i,
              groupIndex: o,
              isCarrier: P,
              computedStyle: U,
              destination: K,
              immediate: a,
              verbose: s,
              pluginInstance: $,
              pluginDuration: ne,
              instanceDelay: N,
            });
          });
        }),
        q
      );
    }
    function vs(e) {
      var t;
      let { store: r, computedStyle: n } = e,
        i = (0, $U.default)(e, oV),
        {
          element: o,
          actionItem: a,
          immediate: s,
          pluginInstance: c,
          continuous: d,
          restingValue: g,
          eventId: f,
        } = i,
        y = !d,
        h = cV(),
        { ixElements: _, ixSession: b, ixData: C } = r.getState(),
        R = uV(_, o),
        { refState: N } = _[R] || {},
        S = Re.getRefType(o),
        G = b.reducedMotion && nt.ReducedMotionTypes[a.actionTypeId],
        F;
      if (G && d)
        switch (
          (t = C.events[f]) === null || t === void 0 ? void 0 : t.eventTypeId
        ) {
          case nt.EventTypeConsts.MOUSE_MOVE:
          case nt.EventTypeConsts.MOUSE_MOVE_IN_VIEWPORT:
            F = g;
            break;
          default:
            F = 0.5;
            break;
        }
      let q = pV(o, N, n, a, Re, c);
      if (
        (r.dispatch(
          (0, be.instanceAdded)(
            (0, QU.default)(
              {
                instanceId: h,
                elementId: R,
                origin: q,
                refType: S,
                skipMotion: G,
                skipToValue: F,
              },
              i
            )
          )
        ),
        Vy(document.body, "ix2-animation-started", h),
        s)
      ) {
        HV(r, h);
        return;
      }
      Ht({ store: r, select: ({ ixInstances: W }) => W[h], onChange: Wy }),
        y && r.dispatch((0, be.instanceStarted)(h, b.tick));
    }
    function hs(e, t) {
      Vy(document.body, "ix2-animation-stopping", {
        instanceId: e.id,
        state: t.getState(),
      });
      let { elementId: r, actionItem: n } = e,
        { ixElements: i } = t.getState(),
        { ref: o, refType: a } = i[r] || {};
      a === Dy && EV(o, n, Re), t.dispatch((0, be.instanceRemoved)(e.id));
    }
    function Vy(e, t, r) {
      let n = document.createEvent("CustomEvent");
      n.initCustomEvent(t, !0, !0, r), e.dispatchEvent(n);
    }
    function HV(e, t) {
      let { ixParameters: r } = e.getState();
      e.dispatch((0, be.instanceStarted)(t, 0)),
        e.dispatch((0, be.animationFrameChanged)(performance.now(), r));
      let { ixInstances: n } = e.getState();
      Wy(n[t], e);
    }
    function Wy(e, t) {
      let {
          active: r,
          continuous: n,
          complete: i,
          elementId: o,
          actionItem: a,
          actionTypeId: s,
          renderType: c,
          current: d,
          groupIndex: g,
          eventId: f,
          eventTarget: y,
          eventStateKey: h,
          actionListId: _,
          isCarrier: b,
          styleProp: C,
          verbose: R,
          pluginInstance: N,
        } = e,
        { ixData: S, ixSession: G } = t.getState(),
        { events: F } = S,
        q = F[f] || {},
        { mediaQueries: W = S.mediaQueryKeys } = q;
      if (xi(W, G.mediaQueryKey) && (n || r || i)) {
        if (d || (c === sV && i)) {
          t.dispatch((0, be.elementStateChanged)(o, s, d, a));
          let { ixElements: j } = t.getState(),
            { ref: Q, refType: ae, refState: re } = j[o] || {},
            X = re && re[s];
          switch (ae) {
            case Dy: {
              lV(Q, re, X, f, a, C, Re, c, N);
              break;
            }
          }
        }
        if (i) {
          if (b) {
            let j = ps({
              store: t,
              eventId: f,
              eventTarget: y,
              eventStateKey: h,
              actionListId: _,
              groupIndex: g + 1,
              verbose: R,
            });
            R &&
              !j &&
              t.dispatch(
                (0, be.actionListPlaybackChanged)({
                  actionListId: _,
                  isPlaying: !1,
                })
              );
          }
          hs(e, t);
        }
      }
    }
  });
  var Hy = u((mt) => {
    "use strict";
    var kV = Kt().default,
      jV = ut().default;
    Object.defineProperty(mt, "__esModule", { value: !0 });
    mt.actions = void 0;
    mt.destroy = By;
    mt.init = $V;
    mt.setEnv = QV;
    mt.store = void 0;
    Nl();
    var KV = Ko(),
      zV = jV(Kg()),
      gs = as(),
      YV = kV(gi());
    mt.actions = YV;
    var Li = (0, KV.createStore)(zV.default);
    mt.store = Li;
    function QV(e) {
      e() && (0, gs.observeRequests)(Li);
    }
    function $V(e) {
      By(), (0, gs.startEngine)({ store: Li, rawData: e, allowEvents: !0 });
    }
    function By() {
      (0, gs.stopEngine)(Li);
    }
  });
  var zy = u(($j, Ky) => {
    var ky = Ze(),
      jy = Hy();
    jy.setEnv(ky.env);
    ky.define(
      "ix2",
      (Ky.exports = function () {
        return jy;
      })
    );
  });
  var Qy = u((Zj, Yy) => {
    var Ir = Ze();
    Ir.define(
      "links",
      (Yy.exports = function (e, t) {
        var r = {},
          n = e(window),
          i,
          o = Ir.env(),
          a = window.location,
          s = document.createElement("a"),
          c = "w--current",
          d = /index\.(html|php)$/,
          g = /\/$/,
          f,
          y;
        r.ready = r.design = r.preview = h;
        function h() {
          (i = o && Ir.env("design")),
            (y = Ir.env("slug") || a.pathname || ""),
            Ir.scroll.off(b),
            (f = []);
          for (var R = document.links, N = 0; N < R.length; ++N) _(R[N]);
          f.length && (Ir.scroll.on(b), b());
        }
        function _(R) {
          var N =
            (i && R.getAttribute("href-disabled")) || R.getAttribute("href");
          if (((s.href = N), !(N.indexOf(":") >= 0))) {
            var S = e(R);
            if (
              s.hash.length > 1 &&
              s.host + s.pathname === a.host + a.pathname
            ) {
              if (!/^#[a-zA-Z0-9\-\_]+$/.test(s.hash)) return;
              var G = e(s.hash);
              G.length && f.push({ link: S, sec: G, active: !1 });
              return;
            }
            if (!(N === "#" || N === "")) {
              var F = s.href === a.href || N === y || (d.test(N) && g.test(y));
              C(S, c, F);
            }
          }
        }
        function b() {
          var R = n.scrollTop(),
            N = n.height();
          t.each(f, function (S) {
            var G = S.link,
              F = S.sec,
              q = F.offset().top,
              W = F.outerHeight(),
              j = N * 0.5,
              Q = F.is(":visible") && q + W - j >= R && q + j <= R + N;
            S.active !== Q && ((S.active = Q), C(G, c, Q));
          });
        }
        function C(R, N, S) {
          var G = R.hasClass(N);
          (S && G) || (!S && !G) || (S ? R.addClass(N) : R.removeClass(N));
        }
        return r;
      })
    );
  });
  var Zy = u((Jj, $y) => {
    var Pi = Ze();
    Pi.define(
      "scroll",
      ($y.exports = function (e) {
        var t = {
            WF_CLICK_EMPTY: "click.wf-empty-link",
            WF_CLICK_SCROLL: "click.wf-scroll",
          },
          r = window.location,
          n = _() ? null : window.history,
          i = e(window),
          o = e(document),
          a = e(document.body),
          s =
            window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            function (X) {
              window.setTimeout(X, 15);
            },
          c = Pi.env("editor") ? ".w-editor-body" : "body",
          d =
            "header, " +
            c +
            " > .header, " +
            c +
            " > .w-nav:not([data-no-scroll])",
          g = 'a[href="#"]',
          f = 'a[href*="#"]:not(.w-tab-link):not(' + g + ")",
          y = '.wf-force-outline-none[tabindex="-1"]:focus{outline:none;}',
          h = document.createElement("style");
        h.appendChild(document.createTextNode(y));
        function _() {
          try {
            return !!window.frameElement;
          } catch {
            return !0;
          }
        }
        var b = /^#[a-zA-Z0-9][\w:.-]*$/;
        function C(X) {
          return b.test(X.hash) && X.host + X.pathname === r.host + r.pathname;
        }
        let R =
          typeof window.matchMedia == "function" &&
          window.matchMedia("(prefers-reduced-motion: reduce)");
        function N() {
          return (
            document.body.getAttribute("data-wf-scroll-motion") === "none" ||
            R.matches
          );
        }
        function S(X, I) {
          var L;
          switch (I) {
            case "add":
              (L = X.attr("tabindex")),
                L
                  ? X.attr("data-wf-tabindex-swap", L)
                  : X.attr("tabindex", "-1");
              break;
            case "remove":
              (L = X.attr("data-wf-tabindex-swap")),
                L
                  ? (X.attr("tabindex", L),
                    X.removeAttr("data-wf-tabindex-swap"))
                  : X.removeAttr("tabindex");
              break;
          }
          X.toggleClass("wf-force-outline-none", I === "add");
        }
        function G(X) {
          var I = X.currentTarget;
          if (
            !(
              Pi.env("design") ||
              (window.$.mobile && /(?:^|\s)ui-link(?:$|\s)/.test(I.className))
            )
          ) {
            var L = C(I) ? I.hash : "";
            if (L !== "") {
              var M = e(L);
              M.length &&
                (X && (X.preventDefault(), X.stopPropagation()),
                F(L, X),
                window.setTimeout(
                  function () {
                    q(M, function () {
                      S(M, "add"),
                        M.get(0).focus({ preventScroll: !0 }),
                        S(M, "remove");
                    });
                  },
                  X ? 0 : 300
                ));
            }
          }
        }
        function F(X) {
          if (
            r.hash !== X &&
            n &&
            n.pushState &&
            !(Pi.env.chrome && r.protocol === "file:")
          ) {
            var I = n.state && n.state.hash;
            I !== X && n.pushState({ hash: X }, "", X);
          }
        }
        function q(X, I) {
          var L = i.scrollTop(),
            M = W(X);
          if (L !== M) {
            var D = j(X, L, M),
              $ = Date.now(),
              ne = function () {
                var P = Date.now() - $;
                window.scroll(0, Q(L, M, P, D)),
                  P <= D ? s(ne) : typeof I == "function" && I();
              };
            s(ne);
          }
        }
        function W(X) {
          var I = e(d),
            L = I.css("position") === "fixed" ? I.outerHeight() : 0,
            M = X.offset().top - L;
          if (X.data("scroll") === "mid") {
            var D = i.height() - L,
              $ = X.outerHeight();
            $ < D && (M -= Math.round((D - $) / 2));
          }
          return M;
        }
        function j(X, I, L) {
          if (N()) return 0;
          var M = 1;
          return (
            a.add(X).each(function (D, $) {
              var ne = parseFloat($.getAttribute("data-scroll-time"));
              !isNaN(ne) && ne >= 0 && (M = ne);
            }),
            (472.143 * Math.log(Math.abs(I - L) + 125) - 2e3) * M
          );
        }
        function Q(X, I, L, M) {
          return L > M ? I : X + (I - X) * ae(L / M);
        }
        function ae(X) {
          return X < 0.5
            ? 4 * X * X * X
            : (X - 1) * (2 * X - 2) * (2 * X - 2) + 1;
        }
        function re() {
          var { WF_CLICK_EMPTY: X, WF_CLICK_SCROLL: I } = t;
          o.on(I, f, G),
            o.on(X, g, function (L) {
              L.preventDefault();
            }),
            document.head.insertBefore(h, document.head.firstChild);
        }
        return { ready: re };
      })
    );
  });
  var em = u((eK, Jy) => {
    var ZV = Ze();
    ZV.define(
      "touch",
      (Jy.exports = function (e) {
        var t = {},
          r = window.getSelection;
        (e.event.special.tap = { bindType: "click", delegateType: "click" }),
          (t.init = function (o) {
            return (
              (o = typeof o == "string" ? e(o).get(0) : o), o ? new n(o) : null
            );
          });
        function n(o) {
          var a = !1,
            s = !1,
            c = Math.min(Math.round(window.innerWidth * 0.04), 40),
            d,
            g;
          o.addEventListener("touchstart", f, !1),
            o.addEventListener("touchmove", y, !1),
            o.addEventListener("touchend", h, !1),
            o.addEventListener("touchcancel", _, !1),
            o.addEventListener("mousedown", f, !1),
            o.addEventListener("mousemove", y, !1),
            o.addEventListener("mouseup", h, !1),
            o.addEventListener("mouseout", _, !1);
          function f(C) {
            var R = C.touches;
            (R && R.length > 1) ||
              ((a = !0),
              R ? ((s = !0), (d = R[0].clientX)) : (d = C.clientX),
              (g = d));
          }
          function y(C) {
            if (a) {
              if (s && C.type === "mousemove") {
                C.preventDefault(), C.stopPropagation();
                return;
              }
              var R = C.touches,
                N = R ? R[0].clientX : C.clientX,
                S = N - g;
              (g = N),
                Math.abs(S) > c &&
                  r &&
                  String(r()) === "" &&
                  (i("swipe", C, { direction: S > 0 ? "right" : "left" }), _());
            }
          }
          function h(C) {
            if (a && ((a = !1), s && C.type === "mouseup")) {
              C.preventDefault(), C.stopPropagation(), (s = !1);
              return;
            }
          }
          function _() {
            a = !1;
          }
          function b() {
            o.removeEventListener("touchstart", f, !1),
              o.removeEventListener("touchmove", y, !1),
              o.removeEventListener("touchend", h, !1),
              o.removeEventListener("touchcancel", _, !1),
              o.removeEventListener("mousedown", f, !1),
              o.removeEventListener("mousemove", y, !1),
              o.removeEventListener("mouseup", h, !1),
              o.removeEventListener("mouseout", _, !1),
              (o = null);
          }
          this.destroy = b;
        }
        function i(o, a, s) {
          var c = e.Event(o, { originalEvent: a });
          e(a.target).trigger(c, s);
        }
        return (t.instance = t.init(document)), t;
      })
    );
  });
  var rm = u((tK, tm) => {
    var Es = Ze();
    Es.define(
      "forms",
      (tm.exports = function (e, t) {
        var r = {},
          n = e(document),
          i,
          o = window.location,
          a = window.XDomainRequest && !window.atob,
          s = ".w-form",
          c,
          d = /e(-)?mail/i,
          g = /^\S+@\S+$/,
          f = window.alert,
          y = Es.env(),
          h,
          _,
          b,
          C = /list-manage[1-9]?.com/i,
          R = t.debounce(function () {
            f(
              "Oops! This page has improperly configured forms. Please contact your website administrator to fix this issue."
            );
          }, 100);
        r.ready =
          r.design =
          r.preview =
            function () {
              N(), !y && !h && G();
            };
        function N() {
          (c = e("html").attr("data-wf-site")),
            (_ = "https://webflow.com/api/v1/form/" + c),
            a &&
              _.indexOf("https://webflow.com") >= 0 &&
              (_ = _.replace(
                "https://webflow.com",
                "https://formdata.webflow.com"
              )),
            (b = `${_}/signFile`),
            (i = e(s + " form")),
            i.length && i.each(S);
        }
        function S(P, U) {
          var K = e(U),
            p = e.data(U, s);
          p || (p = e.data(U, s, { form: K })), F(p);
          var m = K.closest("div.w-form");
          (p.done = m.find("> .w-form-done")),
            (p.fail = m.find("> .w-form-fail")),
            (p.fileUploads = m.find(".w-file-upload")),
            p.fileUploads.each(function (ie) {
              D(ie, p);
            });
          var B =
            p.form.attr("aria-label") || p.form.attr("data-name") || "Form";
          p.done.attr("aria-label") || p.form.attr("aria-label", B),
            p.done.attr("tabindex", "-1"),
            p.done.attr("role", "region"),
            p.done.attr("aria-label") ||
              p.done.attr("aria-label", B + " success"),
            p.fail.attr("tabindex", "-1"),
            p.fail.attr("role", "region"),
            p.fail.attr("aria-label") ||
              p.fail.attr("aria-label", B + " failure");
          var ee = (p.action = K.attr("action"));
          if (
            ((p.handler = null),
            (p.redirect = K.attr("data-redirect")),
            C.test(ee))
          ) {
            p.handler = I;
            return;
          }
          if (!ee) {
            if (c) {
              p.handler = X;
              return;
            }
            R();
          }
        }
        function G() {
          (h = !0),
            n.on("submit", s + " form", function (ie) {
              var Y = e.data(this, s);
              Y.handler && ((Y.evt = ie), Y.handler(Y));
            });
          let P = ".w-checkbox-input",
            U = ".w-radio-input",
            K = "w--redirected-checked",
            p = "w--redirected-focus",
            m = "w--redirected-focus-visible",
            B = ":focus-visible, [data-wf-focus-visible]",
            ee = [
              ["checkbox", P],
              ["radio", U],
            ];
          n.on(
            "change",
            s + ' form input[type="checkbox"]:not(' + P + ")",
            (ie) => {
              e(ie.target).siblings(P).toggleClass(K);
            }
          ),
            n.on("change", s + ' form input[type="radio"]', (ie) => {
              e(`input[name="${ie.target.name}"]:not(${P})`).map((J, Oe) =>
                e(Oe).siblings(U).removeClass(K)
              );
              let Y = e(ie.target);
              Y.hasClass("w-radio-input") || Y.siblings(U).addClass(K);
            }),
            ee.forEach(([ie, Y]) => {
              n.on(
                "focus",
                s + ` form input[type="${ie}"]:not(` + Y + ")",
                (J) => {
                  e(J.target).siblings(Y).addClass(p),
                    e(J.target).filter(B).siblings(Y).addClass(m);
                }
              ),
                n.on(
                  "blur",
                  s + ` form input[type="${ie}"]:not(` + Y + ")",
                  (J) => {
                    e(J.target).siblings(Y).removeClass(`${p} ${m}`);
                  }
                );
            });
        }
        function F(P) {
          var U = (P.btn = P.form.find(':input[type="submit"]'));
          (P.wait = P.btn.attr("data-wait") || null),
            (P.success = !1),
            U.prop("disabled", !1),
            P.label && U.val(P.label);
        }
        function q(P) {
          var U = P.btn,
            K = P.wait;
          U.prop("disabled", !0), K && ((P.label = U.val()), U.val(K));
        }
        function W(P, U) {
          var K = null;
          return (
            (U = U || {}),
            P.find(':input:not([type="submit"]):not([type="file"])').each(
              function (p, m) {
                var B = e(m),
                  ee = B.attr("type"),
                  ie =
                    B.attr("data-name") || B.attr("name") || "Field " + (p + 1),
                  Y = B.val();
                if (ee === "checkbox") Y = B.is(":checked");
                else if (ee === "radio") {
                  if (U[ie] === null || typeof U[ie] == "string") return;
                  Y =
                    P.find(
                      'input[name="' + B.attr("name") + '"]:checked'
                    ).val() || null;
                }
                typeof Y == "string" && (Y = e.trim(Y)),
                  (U[ie] = Y),
                  (K = K || re(B, ee, ie, Y));
              }
            ),
            K
          );
        }
        function j(P) {
          var U = {};
          return (
            P.find(':input[type="file"]').each(function (K, p) {
              var m = e(p),
                B = m.attr("data-name") || m.attr("name") || "File " + (K + 1),
                ee = m.attr("data-value");
              typeof ee == "string" && (ee = e.trim(ee)), (U[B] = ee);
            }),
            U
          );
        }
        let Q = { _mkto_trk: "marketo" };
        function ae() {
          return document.cookie.split("; ").reduce(function (U, K) {
            let p = K.split("="),
              m = p[0];
            if (m in Q) {
              let B = Q[m],
                ee = p.slice(1).join("=");
              U[B] = ee;
            }
            return U;
          }, {});
        }
        function re(P, U, K, p) {
          var m = null;
          return (
            U === "password"
              ? (m = "Passwords cannot be submitted.")
              : P.attr("required")
              ? p
                ? d.test(P.attr("type")) &&
                  (g.test(p) ||
                    (m = "Please enter a valid email address for: " + K))
                : (m = "Please fill out the required field: " + K)
              : K === "g-recaptcha-response" &&
                !p &&
                (m = "Please confirm you\u2019re not a robot."),
            m
          );
        }
        function X(P) {
          M(P), L(P);
        }
        function I(P) {
          F(P);
          var U = P.form,
            K = {};
          if (/^https/.test(o.href) && !/^https/.test(P.action)) {
            U.attr("method", "post");
            return;
          }
          M(P);
          var p = W(U, K);
          if (p) return f(p);
          q(P);
          var m;
          t.each(K, function (Y, J) {
            d.test(J) && (K.EMAIL = Y),
              /^((full[ _-]?)?name)$/i.test(J) && (m = Y),
              /^(first[ _-]?name)$/i.test(J) && (K.FNAME = Y),
              /^(last[ _-]?name)$/i.test(J) && (K.LNAME = Y);
          }),
            m &&
              !K.FNAME &&
              ((m = m.split(" ")),
              (K.FNAME = m[0]),
              (K.LNAME = K.LNAME || m[1]));
          var B = P.action.replace("/post?", "/post-json?") + "&c=?",
            ee = B.indexOf("u=") + 2;
          ee = B.substring(ee, B.indexOf("&", ee));
          var ie = B.indexOf("id=") + 3;
          (ie = B.substring(ie, B.indexOf("&", ie))),
            (K["b_" + ee + "_" + ie] = ""),
            e
              .ajax({ url: B, data: K, dataType: "jsonp" })
              .done(function (Y) {
                (P.success = Y.result === "success" || /already/.test(Y.msg)),
                  P.success || console.info("MailChimp error: " + Y.msg),
                  L(P);
              })
              .fail(function () {
                L(P);
              });
        }
        function L(P) {
          var U = P.form,
            K = P.redirect,
            p = P.success;
          if (p && K) {
            Es.location(K);
            return;
          }
          P.done.toggle(p),
            P.fail.toggle(!p),
            p ? P.done.focus() : P.fail.focus(),
            U.toggle(!p),
            F(P);
        }
        function M(P) {
          P.evt && P.evt.preventDefault(), (P.evt = null);
        }
        function D(P, U) {
          if (!U.fileUploads || !U.fileUploads[P]) return;
          var K,
            p = e(U.fileUploads[P]),
            m = p.find("> .w-file-upload-default"),
            B = p.find("> .w-file-upload-uploading"),
            ee = p.find("> .w-file-upload-success"),
            ie = p.find("> .w-file-upload-error"),
            Y = m.find(".w-file-upload-input"),
            J = m.find(".w-file-upload-label"),
            Oe = J.children(),
            fe = ie.find(".w-file-upload-error-msg"),
            v = ee.find(".w-file-upload-file"),
            V = ee.find(".w-file-remove-link"),
            z = v.find(".w-file-upload-file-name"),
            k = fe.attr("data-w-size-error"),
            ve = fe.attr("data-w-type-error"),
            Ke = fe.attr("data-w-generic-error");
          if (
            (y ||
              J.on("click keydown", function (T) {
                (T.type === "keydown" && T.which !== 13 && T.which !== 32) ||
                  (T.preventDefault(), Y.click());
              }),
            J.find(".w-icon-file-upload-icon").attr("aria-hidden", "true"),
            V.find(".w-icon-file-upload-remove").attr("aria-hidden", "true"),
            y)
          )
            Y.on("click", function (T) {
              T.preventDefault();
            }),
              J.on("click", function (T) {
                T.preventDefault();
              }),
              Oe.on("click", function (T) {
                T.preventDefault();
              });
          else {
            V.on("click keydown", function (T) {
              if (T.type === "keydown") {
                if (T.which !== 13 && T.which !== 32) return;
                T.preventDefault();
              }
              Y.removeAttr("data-value"),
                Y.val(""),
                z.html(""),
                m.toggle(!0),
                ee.toggle(!1),
                J.focus();
            }),
              Y.on("change", function (T) {
                (K = T.target && T.target.files && T.target.files[0]),
                  K &&
                    (m.toggle(!1),
                    ie.toggle(!1),
                    B.toggle(!0),
                    B.focus(),
                    z.text(K.name),
                    A() || q(U),
                    (U.fileUploads[P].uploading = !0),
                    $(K, E));
              });
            var Ue = J.outerHeight();
            Y.height(Ue), Y.width(1);
          }
          function l(T) {
            var w = T.responseJSON && T.responseJSON.msg,
              Z = Ke;
            typeof w == "string" && w.indexOf("InvalidFileTypeError") === 0
              ? (Z = ve)
              : typeof w == "string" &&
                w.indexOf("MaxFileSizeError") === 0 &&
                (Z = k),
              fe.text(Z),
              Y.removeAttr("data-value"),
              Y.val(""),
              B.toggle(!1),
              m.toggle(!0),
              ie.toggle(!0),
              ie.focus(),
              (U.fileUploads[P].uploading = !1),
              A() || F(U);
          }
          function E(T, w) {
            if (T) return l(T);
            var Z = w.fileName,
              oe = w.postData,
              Ee = w.fileId,
              H = w.s3Url;
            Y.attr("data-value", Ee), ne(H, oe, K, Z, O);
          }
          function O(T) {
            if (T) return l(T);
            B.toggle(!1),
              ee.css("display", "inline-block"),
              ee.focus(),
              (U.fileUploads[P].uploading = !1),
              A() || F(U);
          }
          function A() {
            var T = (U.fileUploads && U.fileUploads.toArray()) || [];
            return T.some(function (w) {
              return w.uploading;
            });
          }
        }
        function $(P, U) {
          var K = new URLSearchParams({ name: P.name, size: P.size });
          e.ajax({ type: "GET", url: `${b}?${K}`, crossDomain: !0 })
            .done(function (p) {
              U(null, p);
            })
            .fail(function (p) {
              U(p);
            });
        }
        function ne(P, U, K, p, m) {
          var B = new FormData();
          for (var ee in U) B.append(ee, U[ee]);
          B.append("file", K, p),
            e
              .ajax({
                type: "POST",
                url: P,
                data: B,
                processData: !1,
                contentType: !1,
              })
              .done(function () {
                m(null);
              })
              .fail(function (ie) {
                m(ie);
              });
        }
        return r;
      })
    );
  });
  var om = u((rK, im) => {
    var _s = Ze(),
      nm = "w-condition-invisible",
      JV = "." + nm;
    function eW(e) {
      return e.filter(function (t) {
        return !sn(t);
      });
    }
    function sn(e) {
      return !!(e.$el && e.$el.closest(JV).length);
    }
    function ys(e, t) {
      for (var r = e; r >= 0; r--) if (!sn(t[r])) return r;
      return -1;
    }
    function ms(e, t) {
      for (var r = e; r <= t.length - 1; r++) if (!sn(t[r])) return r;
      return -1;
    }
    function tW(e, t) {
      return ys(e - 1, t) === -1;
    }
    function rW(e, t) {
      return ms(e + 1, t) === -1;
    }
    function an(e, t) {
      e.attr("aria-label") || e.attr("aria-label", t);
    }
    function nW(e, t, r, n) {
      var i = r.tram,
        o = Array.isArray,
        a = "w-lightbox",
        s = a + "-",
        c = /(^|\s+)/g,
        d = [],
        g,
        f,
        y,
        h = [];
      function _(p, m) {
        return (
          (d = o(p) ? p : [p]),
          f || _.build(),
          eW(d).length > 1 &&
            ((f.items = f.empty),
            d.forEach(function (B, ee) {
              var ie = U("thumbnail"),
                Y = U("item")
                  .prop("tabIndex", 0)
                  .attr("aria-controls", "w-lightbox-view")
                  .attr("role", "tab")
                  .append(ie);
              an(Y, `show item ${ee + 1} of ${d.length}`),
                sn(B) && Y.addClass(nm),
                (f.items = f.items.add(Y)),
                ae(B.thumbnailUrl || B.url, function (J) {
                  J.prop("width") > J.prop("height")
                    ? D(J, "wide")
                    : D(J, "tall"),
                    ie.append(D(J, "thumbnail-image"));
                });
            }),
            f.strip.empty().append(f.items),
            D(f.content, "group")),
          i($(f.lightbox, "hide").trigger("focus"))
            .add("opacity .3s")
            .start({ opacity: 1 }),
          D(f.html, "noscroll"),
          _.show(m || 0)
        );
      }
      (_.build = function () {
        return (
          _.destroy(),
          (f = { html: r(t.documentElement), empty: r() }),
          (f.arrowLeft = U("control left inactive")
            .attr("role", "button")
            .attr("aria-hidden", !0)
            .attr("aria-controls", "w-lightbox-view")),
          (f.arrowRight = U("control right inactive")
            .attr("role", "button")
            .attr("aria-hidden", !0)
            .attr("aria-controls", "w-lightbox-view")),
          (f.close = U("control close").attr("role", "button")),
          an(f.arrowLeft, "previous image"),
          an(f.arrowRight, "next image"),
          an(f.close, "close lightbox"),
          (f.spinner = U("spinner")
            .attr("role", "progressbar")
            .attr("aria-live", "polite")
            .attr("aria-hidden", !1)
            .attr("aria-busy", !0)
            .attr("aria-valuemin", 0)
            .attr("aria-valuemax", 100)
            .attr("aria-valuenow", 0)
            .attr("aria-valuetext", "Loading image")),
          (f.strip = U("strip").attr("role", "tablist")),
          (y = new I(f.spinner, L("hide"))),
          (f.content = U("content").append(
            f.spinner,
            f.arrowLeft,
            f.arrowRight,
            f.close
          )),
          (f.container = U("container").append(f.content, f.strip)),
          (f.lightbox = U("backdrop hide").append(f.container)),
          f.strip.on("click", M("item"), S),
          f.content
            .on("swipe", G)
            .on("click", M("left"), C)
            .on("click", M("right"), R)
            .on("click", M("close"), N)
            .on("click", M("image, caption"), R),
          f.container.on("click", M("view"), N).on("dragstart", M("img"), q),
          f.lightbox.on("keydown", W).on("focusin", F),
          r(n).append(f.lightbox),
          _
        );
      }),
        (_.destroy = function () {
          f && ($(f.html, "noscroll"), f.lightbox.remove(), (f = void 0));
        }),
        (_.show = function (p) {
          if (p !== g) {
            var m = d[p];
            if (!m) return _.hide();
            if (sn(m)) {
              if (p < g) {
                var B = ys(p - 1, d);
                p = B > -1 ? B : p;
              } else {
                var ee = ms(p + 1, d);
                p = ee > -1 ? ee : p;
              }
              m = d[p];
            }
            var ie = g;
            (g = p),
              f.spinner
                .attr("aria-hidden", !1)
                .attr("aria-busy", !0)
                .attr("aria-valuenow", 0)
                .attr("aria-valuetext", "Loading image"),
              y.show();
            var Y = (m.html && K(m.width, m.height)) || m.url;
            return (
              ae(Y, function (J) {
                if (p !== g) return;
                var Oe = U("figure", "figure").append(D(J, "image")),
                  fe = U("frame").append(Oe),
                  v = U("view")
                    .prop("tabIndex", 0)
                    .attr("id", "w-lightbox-view")
                    .append(fe),
                  V,
                  z;
                m.html &&
                  ((V = r(m.html)),
                  (z = V.is("iframe")),
                  z && V.on("load", k),
                  Oe.append(D(V, "embed"))),
                  m.caption &&
                    Oe.append(U("caption", "figcaption").text(m.caption)),
                  f.spinner.before(v),
                  z || k();
                function k() {
                  if (
                    (f.spinner
                      .attr("aria-hidden", !0)
                      .attr("aria-busy", !1)
                      .attr("aria-valuenow", 100)
                      .attr("aria-valuetext", "Loaded image"),
                    y.hide(),
                    p !== g)
                  ) {
                    v.remove();
                    return;
                  }
                  let ve = tW(p, d);
                  ne(f.arrowLeft, "inactive", ve),
                    P(f.arrowLeft, ve),
                    ve && f.arrowLeft.is(":focus") && f.arrowRight.focus();
                  let Ke = rW(p, d);
                  if (
                    (ne(f.arrowRight, "inactive", Ke),
                    P(f.arrowRight, Ke),
                    Ke && f.arrowRight.is(":focus") && f.arrowLeft.focus(),
                    f.view
                      ? (i(f.view)
                          .add("opacity .3s")
                          .start({ opacity: 0 })
                          .then(re(f.view)),
                        i(v)
                          .add("opacity .3s")
                          .add("transform .3s")
                          .set({ x: p > ie ? "80px" : "-80px" })
                          .start({ opacity: 1, x: 0 }))
                      : v.css("opacity", 1),
                    (f.view = v),
                    f.view.prop("tabIndex", 0),
                    f.items)
                  ) {
                    $(f.items, "active"), f.items.removeAttr("aria-selected");
                    var Ue = f.items.eq(p);
                    D(Ue, "active"), Ue.attr("aria-selected", !0), X(Ue);
                  }
                }
              }),
              f.close.prop("tabIndex", 0),
              r(":focus").addClass("active-lightbox"),
              h.length === 0 &&
                (r("body")
                  .children()
                  .each(function () {
                    r(this).hasClass("w-lightbox-backdrop") ||
                      r(this).is("script") ||
                      (h.push({
                        node: r(this),
                        hidden: r(this).attr("aria-hidden"),
                        tabIndex: r(this).attr("tabIndex"),
                      }),
                      r(this).attr("aria-hidden", !0).attr("tabIndex", -1));
                  }),
                f.close.focus()),
              _
            );
          }
        }),
        (_.hide = function () {
          return (
            i(f.lightbox).add("opacity .3s").start({ opacity: 0 }).then(Q), _
          );
        }),
        (_.prev = function () {
          var p = ys(g - 1, d);
          p > -1 && _.show(p);
        }),
        (_.next = function () {
          var p = ms(g + 1, d);
          p > -1 && _.show(p);
        });
      function b(p) {
        return function (m) {
          this === m.target && (m.stopPropagation(), m.preventDefault(), p());
        };
      }
      var C = b(_.prev),
        R = b(_.next),
        N = b(_.hide),
        S = function (p) {
          var m = r(this).index();
          p.preventDefault(), _.show(m);
        },
        G = function (p, m) {
          p.preventDefault(),
            m.direction === "left"
              ? _.next()
              : m.direction === "right" && _.prev();
        },
        F = function () {
          this.focus();
        };
      function q(p) {
        p.preventDefault();
      }
      function W(p) {
        var m = p.keyCode;
        m === 27 || j(m, "close")
          ? _.hide()
          : m === 37 || j(m, "left")
          ? _.prev()
          : m === 39 || j(m, "right")
          ? _.next()
          : j(m, "item") && r(":focus").click();
      }
      function j(p, m) {
        if (p !== 13 && p !== 32) return !1;
        var B = r(":focus").attr("class"),
          ee = L(m).trim();
        return B.includes(ee);
      }
      function Q() {
        f &&
          (f.strip.scrollLeft(0).empty(),
          $(f.html, "noscroll"),
          D(f.lightbox, "hide"),
          f.view && f.view.remove(),
          $(f.content, "group"),
          D(f.arrowLeft, "inactive"),
          D(f.arrowRight, "inactive"),
          (g = f.view = void 0),
          h.forEach(function (p) {
            var m = p.node;
            m &&
              (p.hidden
                ? m.attr("aria-hidden", p.hidden)
                : m.removeAttr("aria-hidden"),
              p.tabIndex
                ? m.attr("tabIndex", p.tabIndex)
                : m.removeAttr("tabIndex"));
          }),
          (h = []),
          r(".active-lightbox").removeClass("active-lightbox").focus());
      }
      function ae(p, m) {
        var B = U("img", "img");
        return (
          B.one("load", function () {
            m(B);
          }),
          B.attr("src", p),
          B
        );
      }
      function re(p) {
        return function () {
          p.remove();
        };
      }
      function X(p) {
        var m = p.get(0),
          B = f.strip.get(0),
          ee = m.offsetLeft,
          ie = m.clientWidth,
          Y = B.scrollLeft,
          J = B.clientWidth,
          Oe = B.scrollWidth - J,
          fe;
        ee < Y
          ? (fe = Math.max(0, ee + ie - J))
          : ee + ie > J + Y && (fe = Math.min(ee, Oe)),
          fe != null &&
            i(f.strip).add("scroll-left 500ms").start({ "scroll-left": fe });
      }
      function I(p, m, B) {
        (this.$element = p),
          (this.className = m),
          (this.delay = B || 200),
          this.hide();
      }
      (I.prototype.show = function () {
        var p = this;
        p.timeoutId ||
          (p.timeoutId = setTimeout(function () {
            p.$element.removeClass(p.className), delete p.timeoutId;
          }, p.delay));
      }),
        (I.prototype.hide = function () {
          var p = this;
          if (p.timeoutId) {
            clearTimeout(p.timeoutId), delete p.timeoutId;
            return;
          }
          p.$element.addClass(p.className);
        });
      function L(p, m) {
        return p.replace(c, (m ? " ." : " ") + s);
      }
      function M(p) {
        return L(p, !0);
      }
      function D(p, m) {
        return p.addClass(L(m));
      }
      function $(p, m) {
        return p.removeClass(L(m));
      }
      function ne(p, m, B) {
        return p.toggleClass(L(m), B);
      }
      function P(p, m) {
        return p.attr("aria-hidden", m).attr("tabIndex", m ? -1 : 0);
      }
      function U(p, m) {
        return D(r(t.createElement(m || "div")), p);
      }
      function K(p, m) {
        var B =
          '<svg xmlns="http://www.w3.org/2000/svg" width="' +
          p +
          '" height="' +
          m +
          '"/>';
        return "data:image/svg+xml;charset=utf-8," + encodeURI(B);
      }
      return (
        (function () {
          var p = e.navigator.userAgent,
            m = /(iPhone|iPad|iPod);[^OS]*OS (\d)/,
            B = p.match(m),
            ee = p.indexOf("Android ") > -1 && p.indexOf("Chrome") === -1;
          if (!ee && (!B || B[2] > 7)) return;
          var ie = t.createElement("style");
          t.head.appendChild(ie), e.addEventListener("resize", Y, !0);
          function Y() {
            var J = e.innerHeight,
              Oe = e.innerWidth,
              fe =
                ".w-lightbox-content, .w-lightbox-view, .w-lightbox-view:before {height:" +
                J +
                "px}.w-lightbox-view {width:" +
                Oe +
                "px}.w-lightbox-group, .w-lightbox-group .w-lightbox-view, .w-lightbox-group .w-lightbox-view:before {height:" +
                0.86 * J +
                "px}.w-lightbox-image {max-width:" +
                Oe +
                "px;max-height:" +
                J +
                "px}.w-lightbox-group .w-lightbox-image {max-height:" +
                0.86 * J +
                "px}.w-lightbox-strip {padding: 0 " +
                0.01 * J +
                "px}.w-lightbox-item {width:" +
                0.1 * J +
                "px;padding:" +
                0.02 * J +
                "px " +
                0.01 * J +
                "px}.w-lightbox-thumbnail {height:" +
                0.1 * J +
                "px}@media (min-width: 768px) {.w-lightbox-content, .w-lightbox-view, .w-lightbox-view:before {height:" +
                0.96 * J +
                "px}.w-lightbox-content {margin-top:" +
                0.02 * J +
                "px}.w-lightbox-group, .w-lightbox-group .w-lightbox-view, .w-lightbox-group .w-lightbox-view:before {height:" +
                0.84 * J +
                "px}.w-lightbox-image {max-width:" +
                0.96 * Oe +
                "px;max-height:" +
                0.96 * J +
                "px}.w-lightbox-group .w-lightbox-image {max-width:" +
                0.823 * Oe +
                "px;max-height:" +
                0.84 * J +
                "px}}";
            ie.textContent = fe;
          }
          Y();
        })(),
        _
      );
    }
    _s.define(
      "lightbox",
      (im.exports = function (e) {
        var t = {},
          r = _s.env(),
          n = nW(window, document, e, r ? "#lightbox-mountpoint" : "body"),
          i = e(document),
          o,
          a,
          s = ".w-lightbox",
          c;
        t.ready = t.design = t.preview = d;
        function d() {
          (a = r && _s.env("design")),
            n.destroy(),
            (c = {}),
            (o = i.find(s)),
            o.webflowLightBox(),
            o.each(function () {
              an(e(this), "open lightbox"),
                e(this).attr("aria-haspopup", "dialog");
            });
        }
        jQuery.fn.extend({
          webflowLightBox: function () {
            var h = this;
            e.each(h, function (_, b) {
              var C = e.data(b, s);
              C ||
                (C = e.data(b, s, {
                  el: e(b),
                  mode: "images",
                  images: [],
                  embed: "",
                })),
                C.el.off(s),
                g(C),
                a
                  ? C.el.on("setting" + s, g.bind(null, C))
                  : C.el.on("click" + s, f(C)).on("click" + s, function (R) {
                      R.preventDefault();
                    });
            });
          },
        });
        function g(h) {
          var _ = h.el.children(".w-json").html(),
            b,
            C;
          if (!_) {
            h.items = [];
            return;
          }
          try {
            _ = JSON.parse(_);
          } catch (R) {
            console.error("Malformed lightbox JSON configuration.", R);
          }
          y(_),
            _.items.forEach(function (R) {
              R.$el = h.el;
            }),
            (b = _.group),
            b
              ? ((C = c[b]),
                C || (C = c[b] = []),
                (h.items = C),
                _.items.length &&
                  ((h.index = C.length), C.push.apply(C, _.items)))
              : ((h.items = _.items), (h.index = 0));
        }
        function f(h) {
          return function () {
            h.items.length && n(h.items, h.index || 0);
          };
        }
        function y(h) {
          h.images &&
            (h.images.forEach(function (_) {
              _.type = "image";
            }),
            (h.items = h.images)),
            h.embed && ((h.embed.type = "video"), (h.items = [h.embed])),
            h.groupId && (h.group = h.groupId);
        }
        return t;
      })
    );
  });
  var sm = u((nK, am) => {
    var Nt = Ze(),
      iW = Wi(),
      Pe = {
        ARROW_LEFT: 37,
        ARROW_UP: 38,
        ARROW_RIGHT: 39,
        ARROW_DOWN: 40,
        ESCAPE: 27,
        SPACE: 32,
        ENTER: 13,
        HOME: 36,
        END: 35,
      };
    Nt.define(
      "navbar",
      (am.exports = function (e, t) {
        var r = {},
          n = e.tram,
          i = e(window),
          o = e(document),
          a = t.debounce,
          s,
          c,
          d,
          g,
          f = Nt.env(),
          y = '<div class="w-nav-overlay" data-wf-ignore />',
          h = ".w-nav",
          _ = "w--open",
          b = "w--nav-dropdown-open",
          C = "w--nav-dropdown-toggle-open",
          R = "w--nav-dropdown-list-open",
          N = "w--nav-link-open",
          S = iW.triggers,
          G = e();
        (r.ready = r.design = r.preview = F),
          (r.destroy = function () {
            (G = e()), q(), c && c.length && c.each(ae);
          });
        function F() {
          (d = f && Nt.env("design")),
            (g = Nt.env("editor")),
            (s = e(document.body)),
            (c = o.find(h)),
            c.length && (c.each(Q), q(), W());
        }
        function q() {
          Nt.resize.off(j);
        }
        function W() {
          Nt.resize.on(j);
        }
        function j() {
          c.each(m);
        }
        function Q(v, V) {
          var z = e(V),
            k = e.data(V, h);
          k ||
            (k = e.data(V, h, {
              open: !1,
              el: z,
              config: {},
              selectedIdx: -1,
            })),
            (k.menu = z.find(".w-nav-menu")),
            (k.links = k.menu.find(".w-nav-link")),
            (k.dropdowns = k.menu.find(".w-dropdown")),
            (k.dropdownToggle = k.menu.find(".w-dropdown-toggle")),
            (k.dropdownList = k.menu.find(".w-dropdown-list")),
            (k.button = z.find(".w-nav-button")),
            (k.container = z.find(".w-container")),
            (k.overlayContainerId = "w-nav-overlay-" + v),
            (k.outside = K(k));
          var ve = z.find(".w-nav-brand");
          ve &&
            ve.attr("href") === "/" &&
            ve.attr("aria-label") == null &&
            ve.attr("aria-label", "home"),
            k.button.attr("style", "-webkit-user-select: text;"),
            k.button.attr("aria-label") == null &&
              k.button.attr("aria-label", "menu"),
            k.button.attr("role", "button"),
            k.button.attr("tabindex", "0"),
            k.button.attr("aria-controls", k.overlayContainerId),
            k.button.attr("aria-haspopup", "menu"),
            k.button.attr("aria-expanded", "false"),
            k.el.off(h),
            k.button.off(h),
            k.menu.off(h),
            I(k),
            d
              ? (re(k), k.el.on("setting" + h, L(k)))
              : (X(k),
                k.button.on("click" + h, P(k)),
                k.menu.on("click" + h, "a", U(k)),
                k.button.on("keydown" + h, M(k)),
                k.el.on("keydown" + h, D(k))),
            m(v, V);
        }
        function ae(v, V) {
          var z = e.data(V, h);
          z && (re(z), e.removeData(V, h));
        }
        function re(v) {
          v.overlay && (fe(v, !0), v.overlay.remove(), (v.overlay = null));
        }
        function X(v) {
          v.overlay ||
            ((v.overlay = e(y).appendTo(v.el)),
            v.overlay.attr("id", v.overlayContainerId),
            (v.parent = v.menu.parent()),
            fe(v, !0));
        }
        function I(v) {
          var V = {},
            z = v.config || {},
            k = (V.animation = v.el.attr("data-animation") || "default");
          (V.animOver = /^over/.test(k)),
            (V.animDirect = /left$/.test(k) ? -1 : 1),
            z.animation !== k && v.open && t.defer(ne, v),
            (V.easing = v.el.attr("data-easing") || "ease"),
            (V.easing2 = v.el.attr("data-easing2") || "ease");
          var ve = v.el.attr("data-duration");
          (V.duration = ve != null ? Number(ve) : 400),
            (V.docHeight = v.el.attr("data-doc-height")),
            (v.config = V);
        }
        function L(v) {
          return function (V, z) {
            z = z || {};
            var k = i.width();
            I(v),
              z.open === !0 && J(v, !0),
              z.open === !1 && fe(v, !0),
              v.open &&
                t.defer(function () {
                  k !== i.width() && ne(v);
                });
          };
        }
        function M(v) {
          return function (V) {
            switch (V.keyCode) {
              case Pe.SPACE:
              case Pe.ENTER:
                return P(v)(), V.preventDefault(), V.stopPropagation();
              case Pe.ESCAPE:
                return fe(v), V.preventDefault(), V.stopPropagation();
              case Pe.ARROW_RIGHT:
              case Pe.ARROW_DOWN:
              case Pe.HOME:
              case Pe.END:
                return v.open
                  ? (V.keyCode === Pe.END
                      ? (v.selectedIdx = v.links.length - 1)
                      : (v.selectedIdx = 0),
                    $(v),
                    V.preventDefault(),
                    V.stopPropagation())
                  : (V.preventDefault(), V.stopPropagation());
            }
          };
        }
        function D(v) {
          return function (V) {
            if (v.open)
              switch (
                ((v.selectedIdx = v.links.index(document.activeElement)),
                V.keyCode)
              ) {
                case Pe.HOME:
                case Pe.END:
                  return (
                    V.keyCode === Pe.END
                      ? (v.selectedIdx = v.links.length - 1)
                      : (v.selectedIdx = 0),
                    $(v),
                    V.preventDefault(),
                    V.stopPropagation()
                  );
                case Pe.ESCAPE:
                  return (
                    fe(v),
                    v.button.focus(),
                    V.preventDefault(),
                    V.stopPropagation()
                  );
                case Pe.ARROW_LEFT:
                case Pe.ARROW_UP:
                  return (
                    (v.selectedIdx = Math.max(-1, v.selectedIdx - 1)),
                    $(v),
                    V.preventDefault(),
                    V.stopPropagation()
                  );
                case Pe.ARROW_RIGHT:
                case Pe.ARROW_DOWN:
                  return (
                    (v.selectedIdx = Math.min(
                      v.links.length - 1,
                      v.selectedIdx + 1
                    )),
                    $(v),
                    V.preventDefault(),
                    V.stopPropagation()
                  );
              }
          };
        }
        function $(v) {
          if (v.links[v.selectedIdx]) {
            var V = v.links[v.selectedIdx];
            V.focus(), U(V);
          }
        }
        function ne(v) {
          v.open && (fe(v, !0), J(v, !0));
        }
        function P(v) {
          return a(function () {
            v.open ? fe(v) : J(v);
          });
        }
        function U(v) {
          return function (V) {
            var z = e(this),
              k = z.attr("href");
            if (!Nt.validClick(V.currentTarget)) {
              V.preventDefault();
              return;
            }
            k && k.indexOf("#") === 0 && v.open && fe(v);
          };
        }
        function K(v) {
          return (
            v.outside && o.off("click" + h, v.outside),
            function (V) {
              var z = e(V.target);
              (g && z.closest(".w-editor-bem-EditorOverlay").length) || p(v, z);
            }
          );
        }
        var p = a(function (v, V) {
          if (v.open) {
            var z = V.closest(".w-nav-menu");
            v.menu.is(z) || fe(v);
          }
        });
        function m(v, V) {
          var z = e.data(V, h),
            k = (z.collapsed = z.button.css("display") !== "none");
          if ((z.open && !k && !d && fe(z, !0), z.container.length)) {
            var ve = ee(z);
            z.links.each(ve), z.dropdowns.each(ve);
          }
          z.open && Oe(z);
        }
        var B = "max-width";
        function ee(v) {
          var V = v.container.css(B);
          return (
            V === "none" && (V = ""),
            function (z, k) {
              (k = e(k)), k.css(B, ""), k.css(B) === "none" && k.css(B, V);
            }
          );
        }
        function ie(v, V) {
          V.setAttribute("data-nav-menu-open", "");
        }
        function Y(v, V) {
          V.removeAttribute("data-nav-menu-open");
        }
        function J(v, V) {
          if (v.open) return;
          (v.open = !0),
            v.menu.each(ie),
            v.links.addClass(N),
            v.dropdowns.addClass(b),
            v.dropdownToggle.addClass(C),
            v.dropdownList.addClass(R),
            v.button.addClass(_);
          var z = v.config,
            k = z.animation;
          (k === "none" || !n.support.transform || z.duration <= 0) && (V = !0);
          var ve = Oe(v),
            Ke = v.menu.outerHeight(!0),
            Ue = v.menu.outerWidth(!0),
            l = v.el.height(),
            E = v.el[0];
          if (
            (m(0, E),
            S.intro(0, E),
            Nt.redraw.up(),
            d || o.on("click" + h, v.outside),
            V)
          ) {
            T();
            return;
          }
          var O = "transform " + z.duration + "ms " + z.easing;
          if (
            (v.overlay &&
              ((G = v.menu.prev()), v.overlay.show().append(v.menu)),
            z.animOver)
          ) {
            n(v.menu)
              .add(O)
              .set({ x: z.animDirect * Ue, height: ve })
              .start({ x: 0 })
              .then(T),
              v.overlay && v.overlay.width(Ue);
            return;
          }
          var A = l + Ke;
          n(v.menu).add(O).set({ y: -A }).start({ y: 0 }).then(T);
          function T() {
            v.button.attr("aria-expanded", "true");
          }
        }
        function Oe(v) {
          var V = v.config,
            z = V.docHeight ? o.height() : s.height();
          return (
            V.animOver
              ? v.menu.height(z)
              : v.el.css("position") !== "fixed" && (z -= v.el.outerHeight(!0)),
            v.overlay && v.overlay.height(z),
            z
          );
        }
        function fe(v, V) {
          if (!v.open) return;
          (v.open = !1), v.button.removeClass(_);
          var z = v.config;
          if (
            ((z.animation === "none" ||
              !n.support.transform ||
              z.duration <= 0) &&
              (V = !0),
            S.outro(0, v.el[0]),
            o.off("click" + h, v.outside),
            V)
          ) {
            n(v.menu).stop(), E();
            return;
          }
          var k = "transform " + z.duration + "ms " + z.easing2,
            ve = v.menu.outerHeight(!0),
            Ke = v.menu.outerWidth(!0),
            Ue = v.el.height();
          if (z.animOver) {
            n(v.menu)
              .add(k)
              .start({ x: Ke * z.animDirect })
              .then(E);
            return;
          }
          var l = Ue + ve;
          n(v.menu).add(k).start({ y: -l }).then(E);
          function E() {
            v.menu.height(""),
              n(v.menu).set({ x: 0, y: 0 }),
              v.menu.each(Y),
              v.links.removeClass(N),
              v.dropdowns.removeClass(b),
              v.dropdownToggle.removeClass(C),
              v.dropdownList.removeClass(R),
              v.overlay &&
                v.overlay.children().length &&
                (G.length ? v.menu.insertAfter(G) : v.menu.prependTo(v.parent),
                v.overlay.attr("style", "").hide()),
              v.el.triggerHandler("w-close"),
              v.button.attr("aria-expanded", "false");
          }
        }
        return r;
      })
    );
  });
  Ls();
  Ds();
  Gs();
  Wi();
  zy();
  Qy();
  Zy();
  em();
  rm();
  om();
  sm();
})();
/*!
 * tram.js v0.8.2-global
 * Cross-browser CSS3 transitions in JavaScript
 * https://github.com/bkwld/tram
 * MIT License
 */
/*!
 * Webflow._ (aka) Underscore.js 1.6.0 (custom build)
 * _.each
 * _.map
 * _.find
 * _.filter
 * _.any
 * _.contains
 * _.delay
 * _.defer
 * _.throttle (webflow)
 * _.debounce
 * _.keys
 * _.has
 * _.now
 * _.template (webflow: upgraded to 1.13.6)
 *
 * http://underscorejs.org
 * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Underscore may be freely distributed under the MIT license.
 * @license MIT
 */
/*! Bundled license information:

timm/lib/timm.js:
  (*!
   * Timm
   *
   * Immutability helpers with fast reads and acceptable writes.
   *
   * @copyright Guillermo Grau Panea 2016
   * @license MIT
   *)
*/
/**
 * ----------------------------------------------------------------------
 * Webflow: Interactions 2.0: Init
 */
Webflow.require("ix2").init({
  events: {
    e: {
      id: "e",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OVER",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-2",
        },
      },
      mediaQueries: ["main"],
      target: {
        selector: ".button",
        originalId:
          "645cdd2e710e5b32461471cd|d0e16afa-af7b-ba4f-0f1a-1ad023b6fc2a",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".button",
          originalId:
            "645cdd2e710e5b32461471cd|d0e16afa-af7b-ba4f-0f1a-1ad023b6fc2a",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1683818336893,
    },
    "e-2": {
      id: "e-2",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OUT",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-2",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e",
        },
      },
      mediaQueries: ["main"],
      target: {
        selector: ".button",
        originalId:
          "645cdd2e710e5b32461471cd|d0e16afa-af7b-ba4f-0f1a-1ad023b6fc2a",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".button",
          originalId:
            "645cdd2e710e5b32461471cd|d0e16afa-af7b-ba4f-0f1a-1ad023b6fc2a",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1683818336894,
    },
    "e-3": {
      id: "e-3",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "FADE_EFFECT",
        instant: false,
        config: { actionListId: "fadeIn", autoStopEventId: "e-4" },
      },
      mediaQueries: ["medium", "small", "tiny"],
      target: {
        id: "645cdcf2ec1fddef7c94d40c|805a8d95-8451-ec2b-c376-1928c277b4b1",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "645cdcf2ec1fddef7c94d40c|805a8d95-8451-ec2b-c376-1928c277b4b1",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: null,
        effectIn: true,
      },
      createdOn: 1679166764591,
    },
    "e-5": {
      id: "e-5",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "FADE_EFFECT",
        instant: false,
        config: { actionListId: "fadeIn", autoStopEventId: "e-6" },
      },
      mediaQueries: ["medium", "small", "tiny"],
      target: {
        id: "02e1cc36-5a24-42f4-38c6-3e63a056636c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "02e1cc36-5a24-42f4-38c6-3e63a056636c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: null,
        effectIn: true,
      },
      createdOn: 1683878587933,
    },
    "e-9": {
      id: "e-9",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-3",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-10",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".faq-question",
        originalId: "0bf51656-0f3b-fc60-82a5-0bfc6471b258",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".faq-question",
          originalId: "0bf51656-0f3b-fc60-82a5-0bfc6471b258",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684145241909,
    },
    "e-10": {
      id: "e-10",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_SECOND_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-4",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-9",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".faq-question",
        originalId: "0bf51656-0f3b-fc60-82a5-0bfc6471b258",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".faq-question",
          originalId: "0bf51656-0f3b-fc60-82a5-0bfc6471b258",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684145241909,
    },
    "e-11": {
      id: "e-11",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-5",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-12",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".product-form-item",
        originalId:
          "645cdcf2ec1fddef7c94d40c|43ec2dde-3809-53fe-173c-578d276a4138",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".product-form-item",
          originalId:
            "645cdcf2ec1fddef7c94d40c|43ec2dde-3809-53fe-173c-578d276a4138",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684237789895,
    },
    "e-13": {
      id: "e-13",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-5",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-14",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "645cdcf2ec1fddef7c94d40c|053dfe66-23bf-30db-821c-47666f67182c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "645cdcf2ec1fddef7c94d40c|053dfe66-23bf-30db-821c-47666f67182c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684238922999,
    },
    "e-15": {
      id: "e-15",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-6",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-16",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "645cdcf2ec1fddef7c94d40c|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "645cdcf2ec1fddef7c94d40c|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684241614541,
    },
    "e-16": {
      id: "e-16",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_SECOND_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-7",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-15",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "645cdcf2ec1fddef7c94d40c|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "645cdcf2ec1fddef7c94d40c|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684241614541,
    },
    "e-17": {
      id: "e-17",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-18",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".product-faq-question",
        originalId:
          "645cdcf2ec1fddef7c94d40c|d06bf445-deeb-543f-ce27-4b67cf9e96df",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".product-faq-question",
          originalId:
            "645cdcf2ec1fddef7c94d40c|d06bf445-deeb-543f-ce27-4b67cf9e96df",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684246038841,
    },
    "e-18": {
      id: "e-18",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_SECOND_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-9",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-17",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".product-faq-question",
        originalId:
          "645cdcf2ec1fddef7c94d40c|d06bf445-deeb-543f-ce27-4b67cf9e96df",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".product-faq-question",
          originalId:
            "645cdcf2ec1fddef7c94d40c|d06bf445-deeb-543f-ce27-4b67cf9e96df",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684246038842,
    },
    "e-19": {
      id: "e-19",
      name: "",
      animationType: "custom",
      eventTypeId: "NAVBAR_OPEN",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-20",
        },
      },
      mediaQueries: ["medium", "small", "tiny"],
      target: {
        id: "3b7e8291-76fb-a7e8-ebe8-603db68a396c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "3b7e8291-76fb-a7e8-ebe8-603db68a396c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684251655124,
    },
    "e-20": {
      id: "e-20",
      name: "",
      animationType: "custom",
      eventTypeId: "NAVBAR_CLOSE",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-11",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-19",
        },
      },
      mediaQueries: ["medium", "small", "tiny"],
      target: {
        id: "3b7e8291-76fb-a7e8-ebe8-603db68a396c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "3b7e8291-76fb-a7e8-ebe8-603db68a396c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684251655124,
    },
    "e-21": {
      id: "e-21",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-12", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "645cdcf2ec1fddef7c94d40c",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "645cdcf2ec1fddef7c94d40c",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-12-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1684253320449,
    },
    "e-28": {
      id: "e-28",
      name: "",
      animationType: "preset",
      eventTypeId: "PAGE_SCROLL",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-12", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6463b281ae7a31df330f116f",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6463b281ae7a31df330f116f",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-12-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1684255361436,
    },
    "e-29": {
      id: "e-29",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-12", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "6464b345bcfedb569a3da6af",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6464b345bcfedb569a3da6af",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-12-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1684323144013,
    },
    "e-30": {
      id: "e-30",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "FADE_EFFECT",
        instant: false,
        config: { actionListId: "fadeIn", autoStopEventId: "e-31" },
      },
      mediaQueries: ["medium", "small", "tiny"],
      target: {
        id: "6463b281ae7a31df330f116f|c6c806b8-7176-7637-c89e-dd7e6209c679",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "6463b281ae7a31df330f116f|c6c806b8-7176-7637-c89e-dd7e6209c679",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: null,
        effectIn: true,
      },
      createdOn: 1684837483208,
    },
  },
  actionLists: {
    a: {
      id: "a",
      title: "Button - hover in",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "outCirc",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".button-icon",
                  selectorGuids: ["c7df2065-9188-1a39-28f7-d8458e162b0d"],
                },
                xValue: 12,
                xUnit: "px",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1683818348557,
    },
    "a-2": {
      id: "a-2",
      title: "Button - hover out",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-2-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "inCirc",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".button-icon",
                  selectorGuids: ["c7df2065-9188-1a39-28f7-d8458e162b0d"],
                },
                xValue: 0,
                xUnit: "px",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1683818348557,
    },
    "a-3": {
      id: "a-3",
      title: "FAQ - opens",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-3-n",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".faq-answer",
                  selectorGuids: ["786b16e7-1268-c7d4-59da-99a230848e0a"],
                },
                heightValue: 0,
                widthUnit: "PX",
                heightUnit: "px",
                locked: false,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-3-n-2",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".faq-arrow",
                  selectorGuids: ["c0657ad0-c02b-84a1-ccc1-c6b84bd26431"],
                },
                xValue: 180,
                xUnit: "deg",
                yUnit: "DEG",
                zUnit: "DEG",
              },
            },
            {
              id: "a-3-n-3",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 300,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".faq-answer",
                  selectorGuids: ["786b16e7-1268-c7d4-59da-99a230848e0a"],
                },
                widthUnit: "PX",
                heightUnit: "AUTO",
                locked: false,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1684145058168,
    },
    "a-4": {
      id: "a-4",
      title: "FAQ - closes",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-4-n-2",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".faq-arrow",
                  selectorGuids: ["c0657ad0-c02b-84a1-ccc1-c6b84bd26431"],
                },
                xValue: 0,
                xUnit: "deg",
                yUnit: "DEG",
                zUnit: "DEG",
              },
            },
            {
              id: "a-4-n-3",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 300,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".faq-answer",
                  selectorGuids: ["786b16e7-1268-c7d4-59da-99a230848e0a"],
                },
                heightValue: 0,
                widthUnit: "PX",
                heightUnit: "px",
                locked: false,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684145058168,
    },
    "a-5": {
      id: "a-5",
      title: "Product Form Item",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-5-n-3",
              actionTypeId: "STYLE_BORDER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".product-form-item",
                  selectorGuids: ["95e3f479-3574-e2a8-ee2d-9710ce9007cc"],
                },
                globalSwatchId: "",
                rValue: 0,
                bValue: 0,
                gValue: 0,
                aValue: 0.12,
              },
            },
            {
              id: "a-5-n-4",
              actionTypeId: "STYLE_TEXT_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  selector: ".product-form-name",
                  selectorGuids: ["e6c50a00-6d9e-2d8b-e901-4ce09385d89f"],
                },
                globalSwatchId: "234cab64",
                rValue: 0,
                bValue: 0,
                gValue: 0,
                aValue: 1,
              },
            },
            {
              id: "a-5-n",
              actionTypeId: "STYLE_BORDER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: true,
                  id: "645cdcf2ec1fddef7c94d40c|43ec2dde-3809-53fe-173c-578d276a4138",
                },
                globalSwatchId: "9783e1a9",
                rValue: 23,
                bValue: 133,
                gValue: 43,
                aValue: 1,
              },
            },
            {
              id: "a-5-n-2",
              actionTypeId: "STYLE_TEXT_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-form-name",
                  selectorGuids: ["e6c50a00-6d9e-2d8b-e901-4ce09385d89f"],
                },
                globalSwatchId: "9783e1a9",
                rValue: 23,
                bValue: 133,
                gValue: 43,
                aValue: 1,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684237930492,
    },
    "a-6": {
      id: "a-6",
      title: "Switch - click on",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-6-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-form-switch-ellipse-block",
                  selectorGuids: ["6d5a07ee-cf61-d3cf-8c69-e91ad13b31dd"],
                },
                xValue: 28,
                xUnit: "px",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-6-n-3",
              actionTypeId: "STYLE_BACKGROUND_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: true,
                  id: "645cdcf2ec1fddef7c94d40c|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
                },
                globalSwatchId: "45490373",
                rValue: 246,
                bValue: 103,
                gValue: 197,
                aValue: 1,
              },
            },
            {
              id: "a-6-n-2",
              actionTypeId: "STYLE_BACKGROUND_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-form-switch-ellipse",
                  selectorGuids: ["722c2bd2-6bce-0978-f405-cefc48b3a7ce"],
                },
                globalSwatchId: "9783e1a9",
                rValue: 23,
                bValue: 133,
                gValue: 43,
                aValue: 1,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684241617639,
    },
    "a-7": {
      id: "a-7",
      title: "Switch - click on 2",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-7-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-form-switch-ellipse-block",
                  selectorGuids: ["6d5a07ee-cf61-d3cf-8c69-e91ad13b31dd"],
                },
                xValue: 0,
                xUnit: "px",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-7-n-2",
              actionTypeId: "STYLE_BACKGROUND_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: true,
                  id: "645cdcf2ec1fddef7c94d40c|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
                },
                globalSwatchId: "",
                rValue: 0,
                bValue: 0,
                gValue: 0,
                aValue: 0.12,
              },
            },
            {
              id: "a-7-n-3",
              actionTypeId: "STYLE_BACKGROUND_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-form-switch-ellipse",
                  selectorGuids: ["722c2bd2-6bce-0978-f405-cefc48b3a7ce"],
                },
                globalSwatchId: "234cab64",
                rValue: 0,
                bValue: 0,
                gValue: 0,
                aValue: 1,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684241617639,
    },
    "a-8": {
      id: "a-8",
      title: "Product FAQ - opens",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-8-n-2",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".product-faq-answer",
                  selectorGuids: ["45423f84-727f-f3b8-203f-16c9eade7225"],
                },
                heightValue: 0,
                widthUnit: "PX",
                heightUnit: "px",
                locked: false,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-8-n",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-faq-plus",
                  selectorGuids: ["aaac6d2b-6efa-7e78-3751-8bea460b5c9d"],
                },
                zValue: 225,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-8-n-3",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 300,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".product-faq-answer",
                  selectorGuids: ["45423f84-727f-f3b8-203f-16c9eade7225"],
                },
                widthUnit: "PX",
                heightUnit: "AUTO",
                locked: false,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1684246042835,
    },
    "a-9": {
      id: "a-9",
      title: "Product FAQ - closes",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-9-n-2",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-faq-plus",
                  selectorGuids: ["aaac6d2b-6efa-7e78-3751-8bea460b5c9d"],
                },
                zValue: 0,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-9-n-3",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 300,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".product-faq-answer",
                  selectorGuids: ["45423f84-727f-f3b8-203f-16c9eade7225"],
                },
                heightValue: 0,
                widthUnit: "PX",
                heightUnit: "px",
                locked: false,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684246042835,
    },
    "a-10": {
      id: "a-10",
      title: "Nav Menu - opens",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-10-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["c65294c2-5ed2-807c-1ffb-950bd0c2d045"],
                },
                yValue: 6,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-10-n-7",
              actionTypeId: "STYLE_FILTER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".page-wrapper",
                  selectorGuids: ["1458cc90-c968-acab-e784-a52b416f400d"],
                },
                filters: [
                  { type: "blur", filterId: "0979", value: 9, unit: "px" },
                ],
              },
            },
            {
              id: "a-10-n-6",
              actionTypeId: "STYLE_FILTER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".page-wrapper",
                  selectorGuids: ["1458cc90-c968-acab-e784-a52b416f400d"],
                },
                filters: [
                  {
                    type: "grayscale",
                    filterId: "317f",
                    value: 100,
                    unit: "%",
                  },
                ],
              },
            },
            {
              id: "a-10-n-5",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["d94c09f5-f9d2-18fb-4735-f06d582b293d"],
                },
                zValue: -45,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-10-n-4",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["c65294c2-5ed2-807c-1ffb-950bd0c2d045"],
                },
                zValue: 45,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-10-n-3",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["d94c09f5-f9d2-18fb-4735-f06d582b293d"],
                },
                yValue: -6,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-10-n-2",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-middle",
                  selectorGuids: ["6df53799-ea50-8500-4c43-193691f82dcd"],
                },
                value: 0,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684251660870,
    },
    "a-11": {
      id: "a-11",
      title: "Nav Menu - closes",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-11-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["c65294c2-5ed2-807c-1ffb-950bd0c2d045"],
                },
                yValue: 0,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-11-n-2",
              actionTypeId: "STYLE_FILTER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".page-wrapper",
                  selectorGuids: ["1458cc90-c968-acab-e784-a52b416f400d"],
                },
                filters: [
                  { type: "blur", filterId: "0979", value: 0, unit: "px" },
                ],
              },
            },
            {
              id: "a-11-n-3",
              actionTypeId: "STYLE_FILTER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".page-wrapper",
                  selectorGuids: ["1458cc90-c968-acab-e784-a52b416f400d"],
                },
                filters: [
                  { type: "grayscale", filterId: "317f", value: 0, unit: "%" },
                ],
              },
            },
            {
              id: "a-11-n-4",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["d94c09f5-f9d2-18fb-4735-f06d582b293d"],
                },
                zValue: 0,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-11-n-5",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["c65294c2-5ed2-807c-1ffb-950bd0c2d045"],
                },
                zValue: 0,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-11-n-6",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["d94c09f5-f9d2-18fb-4735-f06d582b293d"],
                },
                yValue: 0,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-11-n-7",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-middle",
                  selectorGuids: ["6df53799-ea50-8500-4c43-193691f82dcd"],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684251660870,
    },
    "a-12": {
      id: "a-12",
      title: "Navbar - scrolls",
      continuousParameterGroups: [
        {
          id: "a-12-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-12-n",
                  actionTypeId: "STYLE_BORDER",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".navbar",
                      selectorGuids: ["b36ca07c-90b9-6623-2917-5106d3b35fa7"],
                    },
                    globalSwatchId: "",
                    rValue: 0,
                    bValue: 0,
                    gValue: 0,
                    aValue: 0,
                  },
                },
              ],
            },
            {
              keyframe: 3,
              actionItems: [
                {
                  id: "a-12-n-3",
                  actionTypeId: "STYLE_BORDER",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".navbar",
                      selectorGuids: ["b36ca07c-90b9-6623-2917-5106d3b35fa7"],
                    },
                    globalSwatchId: "",
                    rValue: 0,
                    bValue: 0,
                    gValue: 0,
                    aValue: 0.12,
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1684253324135,
    },
    fadeIn: {
      id: "fadeIn",
      useFirstGroupAsInitialState: true,
      actionItemGroups: [
        {
          actionItems: [
            {
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                duration: 0,
                target: {
                  id: "N/A",
                  appliesTo: "TRIGGER_ELEMENT",
                  useEventTarget: true,
                },
                value: 0,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "outQuart",
                duration: 1000,
                target: {
                  id: "N/A",
                  appliesTo: "TRIGGER_ELEMENT",
                  useEventTarget: true,
                },
                value: 1,
              },
            },
          ],
        },
      ],
    },
  },
  site: {
    mediaQueries: [
      { key: "main", min: 992, max: 10000 },
      { key: "medium", min: 768, max: 991 },
      { key: "small", min: 480, max: 767 },
      { key: "tiny", min: 0, max: 479 },
    ],
  },
});
